import * as VueDemi from "vue-demi";
import { isVue2, getCurrentInstance, defineComponent, computed, inject, useSlots, toRef, defineAsyncComponent, getCurrentScope, onScopeDispose, provide, unref, ref, watch, nextTick, watchEffect, onMounted, reactive, isVue3 } from "vue-demi";
import { openBlock, createElementBlock, normalizeClass, renderSlot, createBlock, resolveDynamicComponent, normalizeStyle, withCtx, toDisplayString, createCommentVNode, resolveComponent, createElementVNode, withModifiers, mergeProps, createSlots, toHandlers, createVNode, createTextVNode, Fragment, renderList, withDirectives, vShow } from "vue";
import PortalVue from "portal-vue";
const isFunction$3 = (value) => typeof value === "function";
const isArray$2 = (value, predicate) => {
  if (!Array.isArray(value)) {
    return false;
  }
  if (!isFunction$3(predicate)) {
    return true;
  }
  return value.every(predicate);
};
const isUndefined = (value) => typeof value === "undefined";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var lodash_isequal = { exports: {} };
lodash_isequal.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE2 = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil = function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function arrayFilter2(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  function arrayPush2(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }
  function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  function baseTimes2(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function baseUnary2(func) {
    return function(value) {
      return func(value);
    };
  }
  function cacheHas2(cache, key) {
    return cache.has(key);
  }
  function getValue2(object, key) {
    return object == null ? void 0 : object[key];
  }
  function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var nativeObjectToString = objectProto2.toString;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array = root2.Uint8Array, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  var nativeGetSymbols2 = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, nativeKeys = overArg2(Object.keys, Object);
  var DataView = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString = toSource2(DataView), mapCtorString = toSource2(Map2), promiseCtorString = toSource2(Promise2), setCtorString = toSource2(Set), weakMapCtorString = toSource2(WeakMap2);
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0;
  function Hash2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
    this.size = 0;
  }
  function hashDelete2(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    var result = getMapData2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value) {
    var data = getMapData2(this, key), size2 = data.size;
    data.set(key, value);
    this.size += data.size == size2 ? 0 : 1;
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function SetCache2(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache2();
    while (++index < length) {
      this.add(values[index]);
    }
  }
  function setCacheAdd2(value) {
    this.__data__.set(value, HASH_UNDEFINED2);
    return this;
  }
  function setCacheHas2(value) {
    return this.__data__.has(value);
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  function Stack(entries) {
    var data = this.__data__ = new ListCache2(entries);
    this.size = data.size;
  }
  function stackClear() {
    this.__data__ = new ListCache2();
    this.size = 0;
  }
  function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache2) {
      var pairs = data.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache2(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys2(value, inherited) {
    var isArr = isArray2(value), isArg = !isArr && isArguments2(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value.length, String) : [], length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex2(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf2(array, key) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseGetAllKeys2(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray2(object) ? result : arrayPush2(result, symbolsFunc(object));
  }
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString2(value);
  }
  function baseIsArguments(value) {
    return isObjectLike2(value) && baseGetTag(value) == argsTag2;
  }
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag2 ? objectTag : objTag;
    othTag = othTag == argsTag2 ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseIsTypedArray(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  function baseKeys(object) {
    if (!isPrototype2(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty2.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache2() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq2(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        return object == other + "";
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object);
        return result;
      case symbolTag2:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  function getAllKeys(object) {
    return baseGetAllKeys2(object, keys, getSymbols2);
  }
  function getMapData2(map, key) {
    var data = map.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative2(object, key) {
    var value = getValue2(object, key);
    return baseIsNative2(value) ? value : void 0;
  }
  function getRawTag(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter2(nativeGetSymbols2(object), function(symbol) {
      return propertyIsEnumerable2.call(object, symbol);
    });
  };
  var getTag = baseGetTag;
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
    getTag = function(value) {
      var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function isIndex2(value, length) {
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (typeof value == "number" || reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function objectToString2(value) {
    return nativeObjectToString.call(value);
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  var isArguments2 = baseIsArguments(/* @__PURE__ */ function() {
    return arguments;
  }()) ? baseIsArguments : function(value) {
    return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
  };
  var isArray2 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  var isBuffer = nativeIsBuffer || stubFalse;
  function isEqual2(value, other) {
    return baseIsEqual(value, other);
  }
  function isFunction2(value) {
    if (!isObject2(value)) {
      return false;
    }
    var tag = baseGetTag(value);
    return tag == funcTag2 || tag == genTag2 || tag == asyncTag || tag == proxyTag;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return value != null && typeof value == "object";
  }
  var isTypedArray = nodeIsTypedArray ? baseUnary2(nodeIsTypedArray) : baseIsTypedArray;
  function keys(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object) : baseKeys(object);
  }
  function stubArray2() {
    return [];
  }
  function stubFalse() {
    return false;
  }
  module.exports = isEqual2;
})(lodash_isequal, lodash_isequal.exports);
var lodash_isequalExports = lodash_isequal.exports;
const _isEqual = /* @__PURE__ */ getDefaultExportFromCjs(lodash_isequalExports);
const isEqual = (a, b) => _isEqual(a, b);
const isHTMLElement = (value, subtype) => {
  return subtype ? value instanceof subtype : value instanceof HTMLElement;
};
const isNull = (value) => value === null;
const isNullish = (value) => isUndefined(value) || isNull(value);
const isObject$4 = (value) => !isNull(value) && (typeof value === "object" || isFunction$3(value));
const isString = (value) => typeof value === "string";
const adaptOnsV3 = (ons) => {
  if (!ons)
    return null;
  return Object.entries(ons).reduce((ret, [key, handler]) => {
    key = key.charAt(0).toUpperCase() + key.slice(1);
    key = `on${key}`;
    return { ...ret, [key]: handler };
  }, {});
};
const h = (type, options = {}, children) => {
  if (VueDemi.isVue2)
    return VueDemi.h(type, options, children);
  const { props, domProps, on, attrs, ...extraOptions } = options;
  const ons = adaptOnsV3(on);
  const params = { ...extraOptions, ...props, ...domProps, ...ons };
  const vue3Type = isNullish(type) || isObject$4(type) ? type : VueDemi == null ? void 0 : VueDemi.resolveComponent(type);
  return VueDemi.h(
    vue3Type,
    params,
    children
  );
};
const slot = (s, attrs) => {
  if (typeof s == "function")
    return s(attrs);
  return s;
};
const render = (fn) => {
  return (arg1, arg2) => {
    return fn(isVue2 ? arg2.props : arg1);
  };
};
const arrayIncludes$1 = (array, item, fromIndex) => {
  return array.includes(item, fromIndex);
};
var freeGlobal$5 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$5 = typeof self == "object" && self && self.Object === Object && self;
var root$5 = freeGlobal$5 || freeSelf$5 || Function("return this")();
var Symbol$6 = root$5.Symbol;
var symbolProto$3 = Symbol$6 ? Symbol$6.prototype : void 0;
symbolProto$3 ? symbolProto$3.toString : void 0;
var freeGlobal$4 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$4 = typeof self == "object" && self && self.Object === Object && self;
var root$4 = freeGlobal$4 || freeSelf$4 || Function("return this")();
var Symbol$5 = root$4.Symbol;
var symbolProto$2 = Symbol$5 ? Symbol$5.prototype : void 0;
symbolProto$2 ? symbolProto$2.toString : void 0;
var lodash_findkey = { exports: {} };
lodash_findkey.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE2 = 200;
  var FUNC_ERROR_TEXT = "Expected a function";
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
  var INFINITY2 = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reEscapeChar = /\\(\\)?/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil = function() {
    try {
      return freeProcess && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection2) {
      if (predicate(value, key, collection2)) {
        result = key;
        return false;
      }
    });
    return result;
  }
  function baseProperty2(key) {
    return function(object) {
      return object == null ? void 0 : object[key];
    };
  }
  function baseTimes2(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function baseUnary2(func) {
    return function(value) {
      return func(value);
    };
  }
  function getValue2(object, key) {
    return object == null ? void 0 : object[key];
  }
  function isHostObject2(value) {
    var result = false;
    if (value != null && typeof value.toString != "function") {
      try {
        result = !!(value + "");
      } catch (e) {
      }
    }
    return result;
  }
  function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var objectToString2 = objectProto2.toString;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Symbol2 = root2.Symbol, Uint8Array = root2.Uint8Array, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice;
  var nativeKeys = overArg2(Object.keys, Object);
  var DataView = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString = toSource2(DataView), mapCtorString = toSource2(Map2), promiseCtorString = toSource2(Promise2), setCtorString = toSource2(Set), weakMapCtorString = toSource2(WeakMap2);
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0, symbolToString = symbolProto2 ? symbolProto2.toString : void 0;
  function Hash2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
  }
  function hashDelete2(key) {
    return this.has(key) && delete this.__data__[key];
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index, 1);
    }
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    return getMapData2(this, key)["delete"](key);
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value) {
    getMapData2(this, key).set(key, value);
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function SetCache2(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache2();
    while (++index < length) {
      this.add(values[index]);
    }
  }
  function setCacheAdd2(value) {
    this.__data__.set(value, HASH_UNDEFINED2);
    return this;
  }
  function setCacheHas2(value) {
    return this.__data__.has(value);
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  function Stack(entries) {
    this.__data__ = new ListCache2(entries);
  }
  function stackClear() {
    this.__data__ = new ListCache2();
  }
  function stackDelete(key) {
    return this.__data__["delete"](key);
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache2) {
      var pairs = cache.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value]);
        return this;
      }
      cache = this.__data__ = new MapCache2(pairs);
    }
    cache.set(key, value);
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys2(value, inherited) {
    var result = isArray2(value) || isArguments2(value) ? baseTimes2(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isIndex2(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf2(array, key) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  var baseFor = createBaseFor();
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }
  function baseGet(object, path) {
    path = isKey(path, object) ? [path] : castPath(path);
    var index = 0, length = path.length;
    while (object != null && index < length) {
      object = object[toKey2(path[index++])];
    }
    return index && index == length ? object : void 0;
  }
  function baseGetTag(value) {
    return objectToString2.call(value);
  }
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObject2(value) && !isObjectLike2(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
  }
  function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
      objTag = getTag(object);
      objTag = objTag == argsTag2 ? objectTag : objTag;
    }
    if (!othIsArr) {
      othTag = getTag(other);
      othTag = othTag == argsTag2 ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject2(object), othIsObj = othTag == objectTag && !isHostObject2(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
  }
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === void 0 ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) || isHostObject2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseIsTypedArray(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags[objectToString2.call(value)];
  }
  function baseIteratee(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if (typeof value == "object") {
      return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }
  function baseKeys(object) {
    if (!isPrototype2(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty2.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey2(path), srcValue);
    }
    return function(object) {
      var objValue = get(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, void 0, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
  }
  function basePropertyDeep(path) {
    return function(object) {
      return baseGet(object, path);
    };
  }
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isSymbol2(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY2 ? "-0" : result;
  }
  function castPath(value) {
    return isArray2(value) ? value : stringToPath(value);
  }
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache2() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!seen.has(othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, customizer, bitmask, stack))) {
            return seen.add(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq2(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        return object == other + "";
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= UNORDERED_COMPARE_FLAG;
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
        stack["delete"](object);
        return result;
      case symbolTag2:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  function getMapData2(map, key) {
    var data = map.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getMatchData(object) {
    var result = keys(object), length = result.length;
    while (length--) {
      var key = result[length], value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }
  function getNative2(object, key) {
    var value = getValue2(object, key);
    return baseIsNative2(value) ? value : void 0;
  }
  var getTag = baseGetTag;
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
    getTag = function(value) {
      var result = objectToString2.call(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : void 0;
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [path] : castPath(path);
    var result, index = -1, length = path.length;
    while (++index < length) {
      var key = toKey2(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result) {
      return result;
    }
    var length = object ? object.length : 0;
    return !!length && isLength2(length) && isIndex2(key, length) && (isArray2(object) || isArguments2(object));
  }
  function isIndex2(value, length) {
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (typeof value == "number" || reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isKey(value, object) {
    if (isArray2(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function isStrictComparable(value) {
    return value === value && !isObject2(value);
  }
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  var stringToPath = memoize(function(string) {
    string = toString2(string);
    var result = [];
    if (reLeadingDot.test(string)) {
      result.push("");
    }
    string.replace(rePropName, function(match, number, quote, string2) {
      result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
  });
  function toKey2(value) {
    if (typeof value == "string" || isSymbol2(value)) {
      return value;
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY2 ? "-0" : result;
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache2)();
    return memoized;
  }
  memoize.Cache = MapCache2;
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  function isArguments2(value) {
    return isArrayLikeObject2(value) && hasOwnProperty2.call(value, "callee") && (!propertyIsEnumerable2.call(value, "callee") || objectToString2.call(value) == argsTag2);
  }
  var isArray2 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  function isArrayLikeObject2(value) {
    return isObjectLike2(value) && isArrayLike2(value);
  }
  function isFunction2(value) {
    var tag = isObject2(value) ? objectToString2.call(value) : "";
    return tag == funcTag2 || tag == genTag2;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return !!value && typeof value == "object";
  }
  function isSymbol2(value) {
    return typeof value == "symbol" || isObjectLike2(value) && objectToString2.call(value) == symbolTag2;
  }
  var isTypedArray = nodeIsTypedArray ? baseUnary2(nodeIsTypedArray) : baseIsTypedArray;
  function toString2(value) {
    return value == null ? "" : baseToString(value);
  }
  function findKey(object, predicate) {
    return baseFindKey(object, baseIteratee(predicate), baseForOwn);
  }
  function get(object, path, defaultValue) {
    var result = object == null ? void 0 : baseGet(object, path);
    return result === void 0 ? defaultValue : result;
  }
  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }
  function keys(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object) : baseKeys(object);
  }
  function identity(value) {
    return value;
  }
  function property(path) {
    return isKey(path) ? baseProperty2(toKey2(path)) : basePropertyDeep(path);
  }
  module.exports = findKey;
})(lodash_findkey, lodash_findkey.exports);
lodash_findkey.exports;
const getCurrentComponentTagName = () => {
  var _a;
  const instanceOptions = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy.$options;
  const currentComponentTag = objectHasOwn(instanceOptions, "_componentTag") && isString(instanceOptions._componentTag) ? instanceOptions._componentTag : "unknown-component";
  return currentComponentTag;
};
var freeGlobal$3 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$3 = typeof self == "object" && self && self.Object === Object && self;
var root$3 = freeGlobal$3 || freeSelf$3 || Function("return this")();
var Symbol$4 = root$3.Symbol;
var symbolProto$1 = Symbol$4 ? Symbol$4.prototype : void 0;
symbolProto$1 ? symbolProto$1.toString : void 0;
var lodash_mapvalues = { exports: {} };
lodash_mapvalues.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE2 = 200;
  var FUNC_ERROR_TEXT = "Expected a function";
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
  var INFINITY2 = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reEscapeChar = /\\(\\)?/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil = function() {
    try {
      return freeProcess && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  function baseProperty2(key) {
    return function(object) {
      return object == null ? void 0 : object[key];
    };
  }
  function baseTimes2(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function baseUnary2(func) {
    return function(value) {
      return func(value);
    };
  }
  function getValue2(object, key) {
    return object == null ? void 0 : object[key];
  }
  function isHostObject2(value) {
    var result = false;
    if (value != null && typeof value.toString != "function") {
      try {
        result = !!(value + "");
      } catch (e) {
      }
    }
    return result;
  }
  function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var objectToString2 = objectProto2.toString;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Symbol2 = root2.Symbol, Uint8Array = root2.Uint8Array, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice;
  var nativeKeys = overArg2(Object.keys, Object);
  var DataView = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString = toSource2(DataView), mapCtorString = toSource2(Map2), promiseCtorString = toSource2(Promise2), setCtorString = toSource2(Set), weakMapCtorString = toSource2(WeakMap2);
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0, symbolToString = symbolProto2 ? symbolProto2.toString : void 0;
  function Hash2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
  }
  function hashDelete2(key) {
    return this.has(key) && delete this.__data__[key];
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index, 1);
    }
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    return getMapData2(this, key)["delete"](key);
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value) {
    getMapData2(this, key).set(key, value);
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function SetCache2(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache2();
    while (++index < length) {
      this.add(values[index]);
    }
  }
  function setCacheAdd2(value) {
    this.__data__.set(value, HASH_UNDEFINED2);
    return this;
  }
  function setCacheHas2(value) {
    return this.__data__.has(value);
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  function Stack(entries) {
    this.__data__ = new ListCache2(entries);
  }
  function stackClear() {
    this.__data__ = new ListCache2();
  }
  function stackDelete(key) {
    return this.__data__["delete"](key);
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache2) {
      var pairs = cache.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value]);
        return this;
      }
      cache = this.__data__ = new MapCache2(pairs);
    }
    cache.set(key, value);
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys2(value, inherited) {
    var result = isArray2(value) || isArguments2(value) ? baseTimes2(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isIndex2(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf2(array, key) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  var baseFor = createBaseFor();
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }
  function baseGet(object, path) {
    path = isKey(path, object) ? [path] : castPath(path);
    var index = 0, length = path.length;
    while (object != null && index < length) {
      object = object[toKey2(path[index++])];
    }
    return index && index == length ? object : void 0;
  }
  function baseGetTag(value) {
    return objectToString2.call(value);
  }
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObject2(value) && !isObjectLike2(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
  }
  function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
      objTag = getTag(object);
      objTag = objTag == argsTag2 ? objectTag : objTag;
    }
    if (!othIsArr) {
      othTag = getTag(other);
      othTag = othTag == argsTag2 ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject2(object), othIsObj = othTag == objectTag && !isHostObject2(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
  }
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === void 0 ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) || isHostObject2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseIsTypedArray(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags[objectToString2.call(value)];
  }
  function baseIteratee(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if (typeof value == "object") {
      return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }
  function baseKeys(object) {
    if (!isPrototype2(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty2.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey2(path), srcValue);
    }
    return function(object) {
      var objValue = get(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, void 0, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
  }
  function basePropertyDeep(path) {
    return function(object) {
      return baseGet(object, path);
    };
  }
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isSymbol2(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY2 ? "-0" : result;
  }
  function castPath(value) {
    return isArray2(value) ? value : stringToPath(value);
  }
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache2() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!seen.has(othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, customizer, bitmask, stack))) {
            return seen.add(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq2(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        return object == other + "";
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= UNORDERED_COMPARE_FLAG;
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
        stack["delete"](object);
        return result;
      case symbolTag2:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  function getMapData2(map, key) {
    var data = map.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getMatchData(object) {
    var result = keys(object), length = result.length;
    while (length--) {
      var key = result[length], value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }
  function getNative2(object, key) {
    var value = getValue2(object, key);
    return baseIsNative2(value) ? value : void 0;
  }
  var getTag = baseGetTag;
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
    getTag = function(value) {
      var result = objectToString2.call(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : void 0;
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [path] : castPath(path);
    var result, index = -1, length = path.length;
    while (++index < length) {
      var key = toKey2(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result) {
      return result;
    }
    var length = object ? object.length : 0;
    return !!length && isLength2(length) && isIndex2(key, length) && (isArray2(object) || isArguments2(object));
  }
  function isIndex2(value, length) {
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (typeof value == "number" || reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isKey(value, object) {
    if (isArray2(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function isStrictComparable(value) {
    return value === value && !isObject2(value);
  }
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  var stringToPath = memoize(function(string) {
    string = toString2(string);
    var result = [];
    if (reLeadingDot.test(string)) {
      result.push("");
    }
    string.replace(rePropName, function(match, number, quote, string2) {
      result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
  });
  function toKey2(value) {
    if (typeof value == "string" || isSymbol2(value)) {
      return value;
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY2 ? "-0" : result;
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache2)();
    return memoized;
  }
  memoize.Cache = MapCache2;
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  function isArguments2(value) {
    return isArrayLikeObject2(value) && hasOwnProperty2.call(value, "callee") && (!propertyIsEnumerable2.call(value, "callee") || objectToString2.call(value) == argsTag2);
  }
  var isArray2 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  function isArrayLikeObject2(value) {
    return isObjectLike2(value) && isArrayLike2(value);
  }
  function isFunction2(value) {
    var tag = isObject2(value) ? objectToString2.call(value) : "";
    return tag == funcTag2 || tag == genTag2;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return !!value && typeof value == "object";
  }
  function isSymbol2(value) {
    return typeof value == "symbol" || isObjectLike2(value) && objectToString2.call(value) == symbolTag2;
  }
  var isTypedArray = nodeIsTypedArray ? baseUnary2(nodeIsTypedArray) : baseIsTypedArray;
  function toString2(value) {
    return value == null ? "" : baseToString(value);
  }
  function get(object, path, defaultValue) {
    var result = object == null ? void 0 : baseGet(object, path);
    return result === void 0 ? defaultValue : result;
  }
  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }
  function keys(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object) : baseKeys(object);
  }
  function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee);
    baseForOwn(object, function(value, key, object2) {
      result[key] = iteratee(value, key, object2);
    });
    return result;
  }
  function identity(value) {
    return value;
  }
  function property(path) {
    return isKey(path) ? baseProperty2(toKey2(path)) : basePropertyDeep(path);
  }
  module.exports = mapValues;
})(lodash_mapvalues, lodash_mapvalues.exports);
lodash_mapvalues.exports;
var lodash_merge = { exports: {} };
lodash_merge.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE2 = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var HOT_COUNT = 800, HOT_SPAN = 16;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function apply2(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }
  function baseTimes2(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function baseUnary2(func) {
    return function(value) {
      return func(value);
    };
  }
  function getValue2(object, key) {
    return object == null ? void 0 : object[key];
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var nativeObjectToString = objectProto2.toString;
  var objectCtorString = funcToString2.call(Object);
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array = root2.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0, getPrototype2 = overArg2(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  var defineProperty = function() {
    try {
      var func = getNative2(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {
    }
  }();
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, nativeMax2 = Math.max, nativeNow = Date.now;
  var Map2 = getNative2(root2, "Map"), nativeCreate2 = getNative2(Object, "create");
  var baseCreate = /* @__PURE__ */ function() {
    function object() {
    }
    return function(proto) {
      if (!isObject2(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object();
      object.prototype = void 0;
      return result;
    };
  }();
  function Hash2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
    this.size = 0;
  }
  function hashDelete2(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    var result = getMapData2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value) {
    var data = getMapData2(this, key), size2 = data.size;
    data.set(key, value);
    this.size += data.size == size2 ? 0 : 1;
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function Stack(entries) {
    var data = this.__data__ = new ListCache2(entries);
    this.size = data.size;
  }
  function stackClear() {
    this.__data__ = new ListCache2();
    this.size = 0;
  }
  function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache2) {
      var pairs = data.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache2(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys2(value, inherited) {
    var isArr = isArray2(value), isArg = !isArr && isArguments2(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value.length, String) : [], length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex2(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assignMergeValue(object, key, value) {
    if (value !== void 0 && !eq2(object[key], value) || value === void 0 && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty2.call(object, key) && eq2(objValue, value)) || value === void 0 && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }
  function assocIndexOf2(array, key) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) {
      defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }
  var baseFor = createBaseFor();
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString2(value);
  }
  function baseIsArguments(value) {
    return isObjectLike2(value) && baseGetTag(value) == argsTag2;
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseIsTypedArray(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  function baseKeysIn2(object) {
    if (!isObject2(object)) {
      return nativeKeysIn2(object);
    }
    var isProto = isPrototype2(object), result = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    baseFor(source, function(srcValue, key) {
      stack || (stack = new Stack());
      if (isObject2(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
        if (newValue === void 0) {
          newValue = srcValue;
        }
        assignMergeValue(object, key, newValue);
      }
    }, keysIn2);
  }
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
    var isCommon = newValue === void 0;
    if (isCommon) {
      var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray2(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject2(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject(srcValue) || isArguments2(srcValue)) {
        newValue = objValue;
        if (isArguments2(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject2(objValue) || isFunction2(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }
    if (isCommon) {
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
  }
  function baseRest2(func, start) {
    return setToString(overRest(func, start, identity), func + "");
  }
  var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant(string),
      "writable": true
    });
  };
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
      if (newValue === void 0) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }
  function createAssigner(assigner) {
    return baseRest2(function(object, sources) {
      var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
      customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? void 0 : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }
  function getMapData2(map, key) {
    var data = map.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative2(object, key) {
    var value = getValue2(object, key);
    return baseIsNative2(value) ? value : void 0;
  }
  function getRawTag(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype2(object) ? baseCreate(getPrototype2(object)) : {};
  }
  function isIndex2(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isIterateeCall(value, index, object) {
    if (!isObject2(object)) {
      return false;
    }
    var type = typeof index;
    if (type == "number" ? isArrayLike2(object) && isIndex2(index, object.length) : type == "string" && index in object) {
      return eq2(object[index], value);
    }
    return false;
  }
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function nativeKeysIn2(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }
  function objectToString2(value) {
    return nativeObjectToString.call(value);
  }
  function overRest(func, start, transform) {
    start = nativeMax2(start === void 0 ? func.length - 1 : start, 0);
    return function() {
      var args = arguments, index = -1, length = nativeMax2(args.length - start, 0), array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply2(func, this, otherArgs);
    };
  }
  function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") {
      return;
    }
    if (key == "__proto__") {
      return;
    }
    return object[key];
  }
  var setToString = shortOut(baseSetToString);
  function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
      var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(void 0, arguments);
    };
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  var isArguments2 = baseIsArguments(/* @__PURE__ */ function() {
    return arguments;
  }()) ? baseIsArguments : function(value) {
    return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
  };
  var isArray2 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  function isArrayLikeObject2(value) {
    return isObjectLike2(value) && isArrayLike2(value);
  }
  var isBuffer = nativeIsBuffer || stubFalse;
  function isFunction2(value) {
    if (!isObject2(value)) {
      return false;
    }
    var tag = baseGetTag(value);
    return tag == funcTag2 || tag == genTag2 || tag == asyncTag || tag == proxyTag;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return value != null && typeof value == "object";
  }
  function isPlainObject(value) {
    if (!isObjectLike2(value) || baseGetTag(value) != objectTag) {
      return false;
    }
    var proto = getPrototype2(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) == objectCtorString;
  }
  var isTypedArray = nodeIsTypedArray ? baseUnary2(nodeIsTypedArray) : baseIsTypedArray;
  function toPlainObject(value) {
    return copyObject(value, keysIn2(value));
  }
  function keysIn2(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object, true) : baseKeysIn2(object);
  }
  var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });
  function constant(value) {
    return function() {
      return value;
    };
  }
  function identity(value) {
    return value;
  }
  function stubFalse() {
    return false;
  }
  module.exports = merge;
})(lodash_merge, lodash_merge.exports);
var lodash_mergeExports = lodash_merge.exports;
const _merge = /* @__PURE__ */ getDefaultExportFromCjs(lodash_mergeExports);
const objectEntries = (value) => {
  return Object.entries(value);
};
const objectFromEntries = (value) => {
  return Object.fromEntries(value);
};
const has = Object.prototype.hasOwnProperty;
const objectHasOwn = (object, key) => {
  return has.call(object, key);
};
const objectKeys = (value) => {
  return Object.keys(value);
};
var LARGE_ARRAY_SIZE = 200;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var INFINITY$1 = 1 / 0, MAX_SAFE_INTEGER$2 = 9007199254740991;
var argsTag$1 = "[object Arguments]", funcTag$2 = "[object Function]", genTag$2 = "[object GeneratorFunction]", symbolTag$1 = "[object Symbol]";
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var reIsUint = /^(?:0|[1-9]\d*)$/;
var freeGlobal$2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$2 = typeof self == "object" && self && self.Object === Object && self;
var root$2 = freeGlobal$2 || freeSelf$2 || Function("return this")();
function apply$2(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
function arrayIncludesWith(array, value, comparator) {
  var index = -1, length = array ? array.length : 0;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}
function arrayMap$2(array, iteratee) {
  var index = -1, length = array ? array.length : 0, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
function arrayPush$1(array, values) {
  var index = -1, length = values.length, offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1, length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
function baseIsNaN(value) {
  return value !== value;
}
function baseTimes$1(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
function cacheHas(cache, key) {
  return cache.has(key);
}
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function isHostObject(value) {
  var result = false;
  if (value != null && typeof value.toString != "function") {
    try {
      result = !!(value + "");
    } catch (e) {
    }
  }
  return result;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto$2 = Object.prototype;
var coreJsData = root$2["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
var funcToString = funcProto.toString;
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
var objectToString$2 = objectProto$2.toString;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$1).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
var Symbol$3 = root$2.Symbol, getPrototype = overArg(Object.getPrototypeOf, Object), propertyIsEnumerable$1 = objectProto$2.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol$1 = Symbol$3 ? Symbol$3.isConcatSpreadable : void 0;
var nativeGetSymbols = Object.getOwnPropertySymbols, nativeMax$2 = Math.max;
var Map$1 = getNative(root$2, "Map"), nativeCreate = getNative(Object, "create");
function Hash(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? void 0 : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : void 0;
}
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== void 0 : hasOwnProperty$1.call(data, key);
}
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
  return this;
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function ListCache(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function listCacheClear() {
  this.__data__ = [];
}
function listCacheDelete(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function MapCache(entries) {
  var index = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
function mapCacheClear() {
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function mapCacheDelete(key) {
  return getMapData(this, key)["delete"](key);
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
function SetCache(values) {
  var index = -1, length = values ? values.length : 0;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arrayLikeKeys(value, inherited) {
  var result = isArray$1(value) || isArguments$1(value) ? baseTimes$1(value.length, String) : [];
  var length = result.length, skipIndexes = !!length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$1.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
function baseDifference(array, values, iteratee, comparator) {
  var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap$2(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
    while (++index < length) {
      var value = array[index], computed2 = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed2 === computed2) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed2) {
            continue outer;
          }
        }
        result.push(value);
      } else if (!includes(values, computed2, comparator)) {
        result.push(value);
      }
    }
  return result;
}
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1, length = array.length;
  predicate || (predicate = isFlattenable$1);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush$1(result, symbolsFunc(object));
}
function baseIsNative(value) {
  if (!isObject$3(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function baseKeysIn(object) {
  if (!isObject$3(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
function basePick$1(object, props) {
  object = Object(object);
  return basePickBy$1(object, props, function(value, key) {
    return key in object;
  });
}
function basePickBy$1(object, props, predicate) {
  var index = -1, length = props.length, result = {};
  while (++index < length) {
    var key = props[index], value = object[key];
    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}
function baseRest$2(func, start) {
  start = nativeMax$2(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax$2(args.length - start, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply$2(func, this, otherArgs);
  };
}
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};
function isFlattenable$1(value) {
  return isArray$1(value) || isArguments$1(value) || !!(spreadableSymbol$1 && value && value[spreadableSymbol$1]);
}
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$2 : length;
  return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$2;
  return value === proto;
}
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
function toKey$1(value) {
  if (typeof value == "string" || isSymbol$1(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
function isArguments$1(value) {
  return isArrayLikeObject$2(value) && hasOwnProperty$1.call(value, "callee") && (!propertyIsEnumerable$1.call(value, "callee") || objectToString$2.call(value) == argsTag$1);
}
var isArray$1 = Array.isArray;
function isArrayLike$2(value) {
  return value != null && isLength$2(value.length) && !isFunction$2(value);
}
function isArrayLikeObject$2(value) {
  return isObjectLike$2(value) && isArrayLike$2(value);
}
function isFunction$2(value) {
  var tag = isObject$3(value) ? objectToString$2.call(value) : "";
  return tag == funcTag$2 || tag == genTag$2;
}
function isLength$2(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}
function isObject$3(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike$2(value) {
  return !!value && typeof value == "object";
}
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike$2(value) && objectToString$2.call(value) == symbolTag$1;
}
function keysIn(object) {
  return isArrayLike$2(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
baseRest$2(function(object, props) {
  if (object == null) {
    return {};
  }
  props = arrayMap$2(baseFlatten$1(props, 1), toKey$1);
  return basePick$1(object, baseDifference(getAllKeysIn(object), props));
});
function stubArray() {
  return [];
}
var lodash_omitby = { exports: {} };
lodash_omitby.exports;
(function(module, exports) {
  var LARGE_ARRAY_SIZE2 = 200;
  var FUNC_ERROR_TEXT = "Expected a function";
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
  var INFINITY2 = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reEscapeChar = /\\(\\)?/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag2] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag2] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil = function() {
    try {
      return freeProcess && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function arrayPush2(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }
  function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  function baseProperty2(key) {
    return function(object) {
      return object == null ? void 0 : object[key];
    };
  }
  function baseTimes2(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function baseUnary2(func) {
    return function(value) {
      return func(value);
    };
  }
  function getValue2(object, key) {
    return object == null ? void 0 : object[key];
  }
  function isHostObject2(value) {
    var result = false;
    if (value != null && typeof value.toString != "function") {
      try {
        result = !!(value + "");
      } catch (e) {
      }
    }
    return result;
  }
  function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var objectToString2 = objectProto2.toString;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Symbol2 = root2.Symbol, Uint8Array = root2.Uint8Array, getPrototype2 = overArg2(Object.getPrototypeOf, Object), propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice;
  var nativeGetSymbols2 = Object.getOwnPropertySymbols, nativeKeys = overArg2(Object.keys, Object);
  var DataView = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString = toSource2(DataView), mapCtorString = toSource2(Map2), promiseCtorString = toSource2(Promise2), setCtorString = toSource2(Set), weakMapCtorString = toSource2(WeakMap2);
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0, symbolToString = symbolProto2 ? symbolProto2.toString : void 0;
  function Hash2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
  }
  function hashDelete2(key) {
    return this.has(key) && delete this.__data__[key];
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index, 1);
    }
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value) {
    var data = this.__data__, index = assocIndexOf2(data, key);
    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    return getMapData2(this, key)["delete"](key);
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value) {
    getMapData2(this, key).set(key, value);
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function SetCache2(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache2();
    while (++index < length) {
      this.add(values[index]);
    }
  }
  function setCacheAdd2(value) {
    this.__data__.set(value, HASH_UNDEFINED2);
    return this;
  }
  function setCacheHas2(value) {
    return this.__data__.has(value);
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  function Stack(entries) {
    this.__data__ = new ListCache2(entries);
  }
  function stackClear() {
    this.__data__ = new ListCache2();
  }
  function stackDelete(key) {
    return this.__data__["delete"](key);
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache2) {
      var pairs = cache.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value]);
        return this;
      }
      cache = this.__data__ = new MapCache2(pairs);
    }
    cache.set(key, value);
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys2(value, inherited) {
    var result = isArray2(value) || isArguments2(value) ? baseTimes2(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isIndex2(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf2(array, key) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseGet(object, path) {
    path = isKey(path, object) ? [path] : castPath(path);
    var index = 0, length = path.length;
    while (object != null && index < length) {
      object = object[toKey2(path[index++])];
    }
    return index && index == length ? object : void 0;
  }
  function baseGetAllKeys2(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray2(object) ? result : arrayPush2(result, symbolsFunc(object));
  }
  function baseGetTag(value) {
    return objectToString2.call(value);
  }
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObject2(value) && !isObjectLike2(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
  }
  function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
      objTag = getTag(object);
      objTag = objTag == argsTag2 ? objectTag : objTag;
    }
    if (!othIsArr) {
      othTag = getTag(other);
      othTag = othTag == argsTag2 ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject2(object), othIsObj = othTag == objectTag && !isHostObject2(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
  }
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0], objValue = object[key], srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === void 0 && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === void 0 ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) || isHostObject2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseIsTypedArray(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags[objectToString2.call(value)];
  }
  function baseIteratee(value) {
    if (typeof value == "function") {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if (typeof value == "object") {
      return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }
  function baseKeys(object) {
    if (!isPrototype2(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty2.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function baseKeysIn2(object) {
    if (!isObject2(object)) {
      return nativeKeysIn2(object);
    }
    var isProto = isPrototype2(object), result = [];
    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function(object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey2(path), srcValue);
    }
    return function(object) {
      var objValue = get(object, path);
      return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, void 0, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
  }
  function basePickBy2(object, props, predicate) {
    var index = -1, length = props.length, result = {};
    while (++index < length) {
      var key = props[index], value = object[key];
      if (predicate(value, key)) {
        result[key] = value;
      }
    }
    return result;
  }
  function basePropertyDeep(path) {
    return function(object) {
      return baseGet(object, path);
    };
  }
  function baseToString(value) {
    if (typeof value == "string") {
      return value;
    }
    if (isSymbol2(value)) {
      return symbolToString ? symbolToString.call(value) : "";
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY2 ? "-0" : result;
  }
  function castPath(value) {
    return isArray2(value) ? value : stringToPath(value);
  }
  function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache2() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!seen.has(othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, customizer, bitmask, stack))) {
            return seen.add(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq2(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        return object == other + "";
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= UNORDERED_COMPARE_FLAG;
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
        stack["delete"](object);
        return result;
      case symbolTag2:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  function getAllKeysIn2(object) {
    return baseGetAllKeys2(object, keysIn2, getSymbolsIn2);
  }
  function getMapData2(map, key) {
    var data = map.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getMatchData(object) {
    var result = keys(object), length = result.length;
    while (length--) {
      var key = result[length], value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }
  function getNative2(object, key) {
    var value = getValue2(object, key);
    return baseIsNative2(value) ? value : void 0;
  }
  var getSymbols2 = nativeGetSymbols2 ? overArg2(nativeGetSymbols2, Object) : stubArray2;
  var getSymbolsIn2 = !nativeGetSymbols2 ? stubArray2 : function(object) {
    var result = [];
    while (object) {
      arrayPush2(result, getSymbols2(object));
      object = getPrototype2(object);
    }
    return result;
  };
  var getTag = baseGetTag;
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
    getTag = function(value) {
      var result = objectToString2.call(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : void 0;
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [path] : castPath(path);
    var result, index = -1, length = path.length;
    while (++index < length) {
      var key = toKey2(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result) {
      return result;
    }
    var length = object ? object.length : 0;
    return !!length && isLength2(length) && isIndex2(key, length) && (isArray2(object) || isArguments2(object));
  }
  function isIndex2(value, length) {
    length = length == null ? MAX_SAFE_INTEGER2 : length;
    return !!length && (typeof value == "number" || reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isKey(value, object) {
    if (isArray2(value)) {
      return false;
    }
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function isStrictComparable(value) {
    return value === value && !isObject2(value);
  }
  function matchesStrictComparable(key, srcValue) {
    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
    };
  }
  function nativeKeysIn2(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }
  var stringToPath = memoize(function(string) {
    string = toString2(string);
    var result = [];
    if (reLeadingDot.test(string)) {
      result.push("");
    }
    string.replace(rePropName, function(match, number, quote, string2) {
      result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
  });
  function toKey2(value) {
    if (typeof value == "string" || isSymbol2(value)) {
      return value;
    }
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY2 ? "-0" : result;
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache2)();
    return memoized;
  }
  memoize.Cache = MapCache2;
  function negate(predicate) {
    if (typeof predicate != "function") {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return function() {
      var args = arguments;
      switch (args.length) {
        case 0:
          return !predicate.call(this);
        case 1:
          return !predicate.call(this, args[0]);
        case 2:
          return !predicate.call(this, args[0], args[1]);
        case 3:
          return !predicate.call(this, args[0], args[1], args[2]);
      }
      return !predicate.apply(this, args);
    };
  }
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  function isArguments2(value) {
    return isArrayLikeObject2(value) && hasOwnProperty2.call(value, "callee") && (!propertyIsEnumerable2.call(value, "callee") || objectToString2.call(value) == argsTag2);
  }
  var isArray2 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  function isArrayLikeObject2(value) {
    return isObjectLike2(value) && isArrayLike2(value);
  }
  function isFunction2(value) {
    var tag = isObject2(value) ? objectToString2.call(value) : "";
    return tag == funcTag2 || tag == genTag2;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return !!value && typeof value == "object";
  }
  function isSymbol2(value) {
    return typeof value == "symbol" || isObjectLike2(value) && objectToString2.call(value) == symbolTag2;
  }
  var isTypedArray = nodeIsTypedArray ? baseUnary2(nodeIsTypedArray) : baseIsTypedArray;
  function toString2(value) {
    return value == null ? "" : baseToString(value);
  }
  function get(object, path, defaultValue) {
    var result = object == null ? void 0 : baseGet(object, path);
    return result === void 0 ? defaultValue : result;
  }
  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }
  function keys(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object) : baseKeys(object);
  }
  function keysIn2(object) {
    return isArrayLike2(object) ? arrayLikeKeys2(object, true) : baseKeysIn2(object);
  }
  function omitBy(object, predicate) {
    return pickBy(object, negate(baseIteratee(predicate)));
  }
  function pickBy(object, predicate) {
    return object == null ? {} : basePickBy2(object, getAllKeysIn2(object), baseIteratee(predicate));
  }
  function identity(value) {
    return value;
  }
  function property(path) {
    return isKey(path) ? baseProperty2(toKey2(path)) : basePropertyDeep(path);
  }
  function stubArray2() {
    return [];
  }
  module.exports = omitBy;
})(lodash_omitby, lodash_omitby.exports);
var lodash_omitbyExports = lodash_omitby.exports;
const _omitBy = /* @__PURE__ */ getDefaultExportFromCjs(lodash_omitbyExports);
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")();
var Symbol$2 = root$1.Symbol;
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0;
symbolProto ? symbolProto.toString : void 0;
var INFINITY = 1 / 0, MAX_SAFE_INTEGER$1 = 9007199254740991;
var argsTag = "[object Arguments]", funcTag$1 = "[object Function]", genTag$1 = "[object GeneratorFunction]", symbolTag = "[object Symbol]";
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function arrayMap$1(array, iteratee) {
  var index = -1, length = array ? array.length : 0, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
function arrayPush(array, values) {
  var index = -1, length = values.length, offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var objectProto$1 = Object.prototype;
var hasOwnProperty = objectProto$1.hasOwnProperty;
var objectToString$1 = objectProto$1.toString;
var Symbol$1 = root.Symbol, propertyIsEnumerable = objectProto$1.propertyIsEnumerable, spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
var nativeMax$1 = Math.max;
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}
function basePickBy(object, props, predicate) {
  var index = -1, length = props.length, result = {};
  while (++index < length) {
    var key = props[index], value = object[key];
    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}
function baseRest$1(func, start) {
  start = nativeMax$1(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax$1(args.length - start, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply$1(func, this, otherArgs);
  };
}
function isFlattenable(value) {
  return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function isArguments(value) {
  return isArrayLikeObject$1(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString$1.call(value) == argsTag);
}
var isArray = Array.isArray;
function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}
function isArrayLikeObject$1(value) {
  return isObjectLike$1(value) && isArrayLike$1(value);
}
function isFunction$1(value) {
  var tag = isObject$2(value) ? objectToString$1.call(value) : "";
  return tag == funcTag$1 || tag == genTag$1;
}
function isLength$1(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike$1(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && objectToString$1.call(value) == symbolTag;
}
var pick = baseRest$1(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap$1(baseFlatten(props, 1), toKey));
});
var lodash_pick = pick;
const _pick = /* @__PURE__ */ getDefaultExportFromCjs(lodash_pick);
var MAX_SAFE_INTEGER = 9007199254740991;
var funcTag = "[object Function]", genTag = "[object GeneratorFunction]";
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function arrayFilter(array, predicate) {
  var index = -1, length = array ? array.length : 0, resIndex = 0, result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function arrayMap(array, iteratee) {
  var index = -1, length = array ? array.length : 0, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
function baseProperty(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
function baseTimes(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var nativeMax = Math.max;
function baseRest(func, start) {
  start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = arrayFilter(array, function(group) {
    if (isArrayLikeObject(group)) {
      length = nativeMax(group.length, length);
      return true;
    }
  });
  return baseTimes(length, function(index) {
    return arrayMap(array, baseProperty(index));
  });
}
baseRest(unzip);
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
function isFunction(value) {
  var tag = isObject$1(value) ? objectToString.call(value) : "";
  return tag == funcTag || tag == genTag;
}
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
const createSComponent = ({
  id: id2,
  title,
  type,
  props,
  children
}) => {
  const vNodeData = {
    props: _omitBy(
      {
        id: id2,
        componentTitle: title,
        ...props
      },
      isNull
    ),
    attrs: props
  };
  if (isNullish(children)) {
    return h(type, vNodeData, children);
  }
  return h(
    type,
    vNodeData,
    children.map((child) => {
      if (isString(child)) {
        return child;
      }
      if (isNullish(child)) {
        return h();
      }
      return createSComponent(child);
    })
  );
};
const CreateSComponent = defineComponent({
  functional: true,
  props: {
    id: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    type: {
      type: String,
      required: true
    },
    props: {
      type: Object,
      default: null
    },
    children: {
      type: Array,
      default: null
    }
  },
  render: render((props) => createSComponent(props))
});
const RenderVNode = defineComponent({
  functional: true,
  props: {
    vNode: {
      type: Object,
      default: null
    }
  },
  render: render((props) => props.vNode)
});
const RenderVNodes = defineComponent({
  functional: true,
  props: {
    vNodes: {
      type: Array,
      default: () => []
    }
  },
  render: render((props) => props.vNodes)
});
const borderRadius = {
  "none": "0px",
  "sm": ".2rem",
  "md": ".4rem",
  "lg": ".8rem",
  "xl": "1.2rem",
  "2xl": "1.6rem",
  "3xl": "2rem",
  "full": "9999px"
};
const borderWidth = {
  "0": "0",
  "1": "1px",
  "2": ".2rem",
  "DEFAULT": "1px"
};
const boxShadow = {
  "0": "none",
  "2": "0 0.2rem 0.4rem rgba(0, 0, 0, 0.05)",
  "4": "0 0.4rem 1rem rgba(0, 0, 0, 0.1)",
  "8": "0 0.8rem 2.4rem rgba(0, 0, 0, 0.15)",
  "12": "0 1.2rem 2.8rem rgba(0, 0, 0, 0.20)"
};
const breakpoint = {
  xs: "360px",
  sm: "768px",
  md: "1024px",
  lg: "1440px"
};
const globalColorToken = {
  "transparent": "transparent",
  "white": "#ffffff",
  "white/90": "rgba(255, 255, 255, 0.9)",
  "white/80": "rgba(255, 255, 255, 0.8)",
  "white/70": "rgba(255, 255, 255, 0.7)",
  "white/60": "rgba(255, 255, 255, 0.6)",
  "white/50": "rgba(255, 255, 255, 0.5)",
  "white/40": "rgba(255, 255, 255, 0.4)",
  "white/30": "rgba(255, 255, 255, 0.3)",
  "white/25": "rgba(255, 255, 255, 0.25)",
  "white/20": "rgba(255, 255, 255, 0.2)",
  "white/15": "rgba(255, 255, 255, 0.15)",
  "white/10": "rgba(255, 255, 255, 0.1)",
  "white/8": "rgba(255, 255, 255, 0.08)",
  "white/6": "rgba(255, 255, 255, 0.06)",
  "white/4": "rgba(255, 255, 255, 0.04)",
  "white/2": "rgba(255, 255, 255, 0.02)",
  "black": "#000000",
  "black/90": "rgba(0, 0, 0, 0.9)",
  "black/80": "rgba(0, 0, 0, 0.8)",
  "black/70": "rgba(0, 0, 0, 0.7)",
  "black/60": "rgba(0, 0, 0, 0.6)",
  "black/50": "rgba(0, 0, 0, 0.5)",
  "black/40": "rgba(0, 0, 0, 0.4)",
  "black/30": "rgba(0, 0, 0, 0.3)",
  "black/25": "rgba(0, 0, 0, 0.25)",
  "black/20": "rgba(0, 0, 0, 0.2)",
  "black/15": "rgba(0, 0, 0, 0.15)",
  "black/10": "rgba(0, 0, 0, 0.1)",
  "black/8": "rgba(0, 0, 0, 0.08)",
  "black/6": "rgba(0, 0, 0, 0.06)",
  "black/4": "rgba(0, 0, 0, 0.04)",
  "black/2": "rgba(0, 0, 0, 0.02)",
  "gray20": "#fafafa",
  "gray40": "#f5f5f5",
  "gray60": "#f0f0f0",
  "gray80": "#ebebeb",
  "gray100": "#e5e5e5",
  "gray150": "#d9d9d9",
  "gray200": "#cccccc",
  "gray300": "#b2b2b2",
  "gray400": "#999999",
  "gray500": "#7f7f7f",
  "gray600": "#666666",
  "gray650": "#595959",
  "gray700": "#4c4c4c",
  "gray750": "#404040",
  "gray780": "#383838",
  "gray800": "#333333",
  "gray820": "#2e2e2e",
  "gray840": "#292929",
  "gray860": "#232323",
  "gray880": "#1f1f1f",
  "gray900": "#191919",
  "gray940": "#0f0f0f",
  "orange50": "#fff9e9",
  "orange100": "#ffeac9",
  "orange200": "#ffcc98",
  "orange300": "#ff915a",
  "orange400": "#fd6734",
  "orange500": "#fc4420",
  "orange600": "#e83f1d",
  "orange700": "#d63a1b",
  "orange800": "#ca361a",
  "orange900": "#b03016",
  "navy50": "#e8f0ff",
  "navy100": "#ccd8ee",
  "navy200": "#abb9d2",
  "navy300": "#8c9dba",
  "navy400": "#7588a8",
  "navy500": "#5f7496",
  "navy600": "#506585",
  "navy700": "#40526e",
  "navy800": "#314058",
  "navy900": "#1e2c40",
  "blue50": "#e2eaff",
  "blue100": "#ceddff",
  "blue200": "#b1c8ff",
  "blue300": "#80a5ff",
  "blue400": "#598aff",
  "blue500": "#3c75ff",
  "blue600": "#3669e6",
  "blue700": "#3363d9",
  "blue800": "#2f5bc7",
  "blue900": "#2a52b3",
  "system-red": "#d53430",
  "system-yellow": "#f27d23",
  "system-green": "#37a458",
  "system-blue": "#1e88e5",
  "tint-red50": "#f9f1f2",
  "tint-red100": "#f1d2d1",
  "tint-red200": "#e8b4b6",
  "tint-red300": "#e19598",
  "tint-red400": "#da787f",
  "tint-red500": "#cb5967",
  "tint-red600": "#ae4855",
  "tint-red700": "#8e3846",
  "tint-red800": "#6f2a39",
  "tint-red900": "#52212d",
  "tint-red-a50": "#fdf0f1",
  "tint-red-a100": "#f6bab8",
  "tint-red-a200": "#f2878a",
  "tint-red-a400": "#ec3b47",
  "tint-red-a700": "#ac0822",
  "tint-orange50": "#f6f0e7",
  "tint-orange100": "#f1dbc3",
  "tint-orange200": "#ecc7a5",
  "tint-orange300": "#e6b285",
  "tint-orange400": "#e09964",
  "tint-orange500": "#d77e45",
  "tint-orange600": "#b96436",
  "tint-orange700": "#984b2b",
  "tint-orange800": "#793b24",
  "tint-orange900": "#5b2d1c",
  "tint-orange-a50": "#faf2e6",
  "tint-orange-a100": "#f6d1aa",
  "tint-orange-a200": "#f9b677",
  "tint-orange-a400": "#f27d23",
  "tint-orange-a700": "#b73700",
  "tint-yellow50": "#f8f5e8",
  "tint-yellow100": "#f1e9c3",
  "tint-yellow200": "#ecdea3",
  "tint-yellow300": "#e6d084",
  "tint-yellow400": "#e2bd65",
  "tint-yellow500": "#d9ab48",
  "tint-yellow600": "#b88c39",
  "tint-yellow700": "#986f2d",
  "tint-yellow800": "#7b5726",
  "tint-yellow900": "#5b3e1e",
  "tint-yellow-a50": "#fcf8e7",
  "tint-yellow-a100": "#f6e79d",
  "tint-yellow-a200": "#f6d860",
  "tint-yellow-a400": "#ffb412",
  "tint-yellow-a700": "#b77408",
  "tint-lime50": "#f3f6e7",
  "tint-lime100": "#e6f1c5",
  "tint-lime200": "#daeba6",
  "tint-lime300": "#c1da80",
  "tint-lime400": "#aaca60",
  "tint-lime500": "#93bc46",
  "tint-lime600": "#739e36",
  "tint-lime700": "#597c2b",
  "tint-lime800": "#425f22",
  "tint-lime900": "#2f411a",
  "tint-lime-a50": "#f6fae6",
  "tint-lime-a100": "#e3f6ac",
  "tint-lime-a200": "#d8f878",
  "tint-lime-a400": "#9bca2e",
  "tint-lime-a700": "#4f8409",
  "tint-green50": "#eef6f1",
  "tint-green100": "#d6e9dc",
  "tint-green200": "#b3d7c2",
  "tint-green300": "#8bc3a2",
  "tint-green400": "#65ab7e",
  "tint-green500": "#4b9663",
  "tint-green600": "#3d7d4d",
  "tint-green700": "#306339",
  "tint-green800": "#244c2b",
  "tint-green900": "#17361f",
  "tint-green-a50": "#edfaf2",
  "tint-green-a100": "#beeecd",
  "tint-green-a200": "#9ddcb7",
  "tint-green-a400": "#2b9450",
  "tint-green-a700": "#0f7021",
  "tint-teal50": "#ecf5f6",
  "tint-teal100": "#cae7e6",
  "tint-teal200": "#a3d2d6",
  "tint-teal300": "#7dbec3",
  "tint-teal400": "#5caab0",
  "tint-teal500": "#44949e",
  "tint-teal600": "#36777f",
  "tint-teal700": "#295d63",
  "tint-teal800": "#1d4448",
  "tint-teal900": "#152c2f",
  "tint-teal-a50": "#ebf9fa",
  "tint-teal-a100": "#bcecea",
  "tint-teal-a200": "#64d8e3",
  "tint-teal-a400": "#2bb8c2",
  "tint-teal-a700": "#087582",
  "tint-blue50": "#eaf3f7",
  "tint-blue100": "#cae3f2",
  "tint-blue200": "#abd0eb",
  "tint-blue300": "#8dbce5",
  "tint-blue400": "#70a7de",
  "tint-blue500": "#5793D8",
  "tint-blue600": "#4474b8",
  "tint-blue700": "#355b9a",
  "tint-blue800": "#2c477a",
  "tint-blue900": "#22355c",
  "tint-blue-a50": "#e9f6fb",
  "tint-blue-a100": "#b1dcf7",
  "tint-blue-a200": "#7ec5f8",
  "tint-blue-a400": "#3191f0",
  "tint-blue-a700": "#0047b9",
  "tint-dazzlingblue50": "#f5f5fa",
  "tint-dazzlingblue100": "#e4e1f7",
  "tint-dazzlingblue200": "#cdc8ee",
  "tint-dazzlingblue300": "#b0adea",
  "tint-dazzlingblue400": "#9090de",
  "tint-dazzlingblue500": "#7175d0",
  "tint-dazzlingblue600": "#575fb1",
  "tint-dazzlingblue700": "#424b90",
  "tint-dazzlingblue800": "#313b71",
  "tint-dazzlingblue900": "#242d52",
  "tint-dazzlingblue-a50": "#f4f4fe",
  "tint-dazzlingblue-a100": "#cfc7fc",
  "tint-dazzlingblue-a200": "#a89bfb",
  "tint-dazzlingblue-a400": "#5252eb",
  "tint-dazzlingblue-a700": "#1325af",
  "tint-indigo50": "#f1f4fa",
  "tint-indigo100": "#dde5f5",
  "tint-indigo200": "#bfcbee",
  "tint-indigo300": "#a0afe7",
  "tint-indigo400": "#7d8fd9",
  "tint-indigo500": "#5c6cc9",
  "tint-indigo600": "#4853a8",
  "tint-indigo700": "#373e8a",
  "tint-indigo800": "#282c6b",
  "tint-indigo900": "#20204d",
  "tint-indigo-a50": "#f0f4fe",
  "tint-indigo-a100": "#c4d6fa",
  "tint-indigo-a200": "#92acfb",
  "tint-indigo-a400": "#4163eb",
  "tint-indigo-a700": "#0816a9",
  "tint-purple50": "#f6f4f9",
  "tint-purple100": "#ebdff5",
  "tint-purple200": "#dac4eb",
  "tint-purple300": "#c7a6e6",
  "tint-purple400": "#ad88da",
  "tint-purple500": "#946bcd",
  "tint-purple600": "#7a4eb2",
  "tint-purple700": "#5d398b",
  "tint-purple800": "#482475",
  "tint-purple900": "#350f64",
  "tint-purple-a50": "#f7f3fd",
  "tint-purple-a100": "#e3c6fa",
  "tint-purple-a200": "#d4a4fa",
  "tint-purple-a400": "#9f53fc",
  "tint-purple-a700": "#6a1ec7",
  "tint-magenta50": "#f9f1f5",
  "tint-magenta100": "#f5dce9",
  "tint-magenta200": "#ebbed5",
  "tint-magenta300": "#e29dc6",
  "tint-magenta400": "#d27ab2",
  "tint-magenta500": "#c45da0",
  "tint-magenta600": "#a24987",
  "tint-magenta700": "#83386e",
  "tint-magenta800": "#662a58",
  "tint-magenta900": "#492141",
  "tint-magenta-a50": "#fdf0f6",
  "tint-magenta-a100": "#f5b7d7",
  "tint-magenta-a200": "#f595c7",
  "tint-magenta-a400": "#e440a8",
  "tint-magenta-a700": "#a20c77",
  "tint-pink50": "#f9f0f3",
  "tint-pink100": "#f6dce2",
  "tint-pink200": "#edbfc9",
  "tint-pink300": "#e79db4",
  "tint-pink400": "#d97a9b",
  "tint-pink500": "#cd5d84",
  "tint-pink600": "#ab496f",
  "tint-pink700": "#8c385a",
  "tint-pink800": "#6e2948",
  "tint-pink900": "#4e2036",
  "tint-pink-a50": "#fdf0f6",
  "tint-pink-a100": "#fbc2d0",
  "tint-pink-a200": "#fa92a9",
  "tint-pink-a400": "#eb3e7a",
  "tint-pink-a700": "#ab0949"
};
const LINE_ICONS = [
  "ic-v2-sample",
  "ic-v2-navigation-alarm-line",
  "ic-v2-navigation-alarm-disabled-line",
  "ic-v2-navigation-language-line",
  "ic-v2-navigation-menu-line",
  "ic-v2-navigation-search-line",
  "ic-v2-navigation-home-line",
  "ic-v2-navigation-setting-line",
  "ic-v2-navigation-sub-menu-line",
  "ic-v2-navigation-login-line",
  "ic-v2-navigation-logout-line",
  "ic-v2-navigation-coupon-line",
  "ic-v2-navigation-message-line",
  "ic-v2-navigation-security-line",
  "ic-v2-navigation-cart-line",
  "ic-v2-navigation-cart-selected-line",
  "ic-v2-navigation-profile-line",
  "ic-v2-navigation-board-timeline-line",
  "ic-v2-navigation-authenticator-line",
  "ic-v2-navigation-community-line",
  "ic-v2-navigation-toonspoon-line",
  "ic-v2-navigation-my-activity-line",
  "ic-v2-navigation-shop-line",
  "ic-v2-navigation-store-line",
  "ic-v2-navigation-point-line",
  "ic-v2-navigation-community-event-line",
  "ic-v2-navigation-streaming-line",
  "ic-v2-navigation-studio-test-line",
  "ic-v2-navigation-game-info-line",
  "ic-v2-navigation-pcbang-line",
  "ic-v2-navigation-bank-line",
  "ic-v2-control-refresh-line",
  "ic-v2-control-update-line",
  "ic-v2-control-close-line",
  "ic-v2-control-close-circle-line",
  "ic-v2-control-add-line",
  "ic-v2-control-add-circle-line",
  "ic-v2-control-minus-line",
  "ic-v2-control-minus-circle-line",
  "ic-v2-control-sum-line",
  "ic-v2-control-long-arrow-left-line",
  "ic-v2-control-long-arrow-right-line",
  "ic-v2-control-long-arrow-up-line",
  "ic-v2-control-long-arrow-down-line",
  "ic-v2-control-arrow-left-line",
  "ic-v2-control-arrow-right-line",
  "ic-v2-control-arrow-up-line",
  "ic-v2-control-arrow-down-line",
  "ic-v2-control-double-arrow-left-line",
  "ic-v2-control-double-arrow-right-line",
  "ic-v2-control-arrow-left-circle-line",
  "ic-v2-control-arrow-right-circle-line",
  "ic-v2-control-double-arrow-left-circle-line",
  "ic-v2-control-double-arrow-right-circle-line",
  "ic-v2-control-web-link-line",
  "ic-v2-control-minimize-line",
  "ic-v2-control-maximize-line",
  "ic-v2-control-enlarge-line",
  "ic-v2-control-preview-line",
  "ic-v2-control-top-line",
  "ic-v2-control-bottom-line",
  "ic-v2-control-check-line",
  "ic-v2-control-check-bold-line",
  "ic-v2-control-check-circle-line",
  "ic-v2-control-long-arrow-left-circle-line",
  "ic-v2-control-long-arrow-right-circle-line",
  "ic-v2-control-long-arrow-up-circle-line",
  "ic-v2-control-long-arrow-down-circle-line",
  "ic-v2-control-undo-line",
  "ic-v2-control-redo-line",
  "ic-v2-control-recover-line",
  "ic-v2-control-sync-line",
  "ic-v2-control-waiting-circle-line",
  "ic-v2-control-sort-line",
  "ic-v2-control-sort-arrow-line",
  "ic-v2-community-share-line",
  "ic-v2-community-thumbs-up-line",
  "ic-v2-community-thumbs-down-line",
  "ic-v2-community-group-line",
  "ic-v2-community-group-add-line",
  "ic-v2-community-group-now-line",
  "ic-v2-community-person-line",
  "ic-v2-community-friend-add-line",
  "ic-v2-community-friend-now-line",
  "ic-v2-community-friend-cancel-line",
  "ic-v2-community-friend-acceptance-line",
  "ic-v2-community-friend-shared-line",
  "ic-v2-community-friend-setting-list-line",
  "ic-v2-community-star-line",
  "ic-v2-community-star-half-line",
  "ic-v2-community-bookmark-line",
  "ic-v2-community-favorite-line",
  "ic-v2-community-like-line",
  "ic-v2-community-pin-line",
  "ic-v2-community-write-line",
  "ic-v2-community-pencil-line",
  "ic-v2-community-number-of-view-line",
  "ic-v2-community-hashtag-line",
  "ic-v2-community-view-card-line",
  "ic-v2-community-view-webzine-line",
  "ic-v2-community-view-photo-line",
  "ic-v2-community-view-thread-line",
  "ic-v2-community-filter-line",
  "ic-v2-community-reply-line",
  "ic-v2-community-link-line",
  "ic-v2-community-unlink-line",
  "ic-v2-community-send-line",
  "ic-v2-community-calendar-line",
  "ic-v2-community-attach-file-line",
  "ic-v2-community-approve-line",
  "ic-v2-community-oppose-line",
  "ic-v2-community-attach-video-line",
  "ic-v2-community-attach-image-line",
  "ic-v2-community-attach-emoji-line",
  "ic-v2-community-attach-survey-line",
  "ic-v2-community-attach-music-line",
  "ic-v2-community-attach-quotation-line",
  "ic-v2-community-thumbnail-video-line",
  "ic-v2-community-thumbnail-survey-line",
  "ic-v2-community-thumbnail-music-line",
  "ic-v2-community-thumbnail-pin-line",
  "ic-v2-community-thumbnail-lock-line",
  "ic-v2-community-sort-ascending-line",
  "ic-v2-community-sort-descending-line",
  "ic-v2-community-forum-line",
  "ic-v2-community-board-line",
  "ic-v2-community-board-all-line",
  "ic-v2-community-requotation-line",
  "ic-v2-community-public-line",
  "ic-v2-community-random-line",
  "ic-v2-community-copy-line",
  "ic-v2-community-comment-line",
  "ic-v2-community-view-update-line",
  "ic-v2-community-pin-off-line",
  "ic-v2-community-chat-add-line",
  "ic-v2-community-chat-broken-image-line",
  "ic-v2-community-comments-line",
  "ic-v2-community-capture-line",
  "ic-v2-community-internet-line",
  "ic-v2-object-cash-stove-line",
  "ic-v2-object-game-line",
  "ic-v2-object-download-line",
  "ic-v2-object-payment-line",
  "ic-v2-object-delete-line",
  "ic-v2-object-trophy-line",
  "ic-v2-object-coin-line",
  "ic-v2-object-cash-circle-line",
  "ic-v2-object-notice-line",
  "ic-v2-object-lock-line",
  "ic-v2-object-unlock-line",
  "ic-v2-object-lock-check-line",
  "ic-v2-object-clock-line",
  "ic-v2-object-cabinet-line",
  "ic-v2-object-help-center-line",
  "ic-v2-object-report-line",
  "ic-v2-object-tag-line",
  "ic-v2-object-crown-line",
  "ic-v2-object-indi-game-line",
  "ic-v2-object-collection-line",
  "ic-v2-object-early-line",
  "ic-v2-object-widget-line",
  "ic-v2-object-fire-line",
  "ic-v2-object-pen-line",
  "ic-v2-object-notice-off-line",
  "ic-v2-object-sea-line",
  "ic-v2-object-game-cut-line",
  "ic-v2-object-graph-line",
  "ic-v2-object-cloud-save-line",
  "ic-v2-object-compass-line",
  "ic-v2-object-cloud-line",
  "ic-v2-object-upload-line",
  "ic-v2-object-rating-line",
  "ic-v2-media-av-play-line",
  "ic-v2-media-av-volume-line",
  "ic-v2-media-av-volume-auto-line",
  "ic-v2-media-av-video-add-line",
  "ic-v2-media-av-closed-caption-line",
  "ic-v2-media-av-mic-line",
  "ic-v2-media-av-mic-off-line",
  "ic-v2-media-av-volume-off-line",
  "ic-v2-media-image-flash-on-line",
  "ic-v2-media-image-camera-line",
  "ic-v2-media-view-down-line",
  "ic-v2-media-view-up-line",
  "ic-v2-media-av-sound-line",
  "ic-v2-media-av-sound-off-line",
  "ic-v2-media-view-full-line",
  "ic-v2-state-warning-circle-line",
  "ic-v2-state-help-circle-line",
  "ic-v2-state-block-line",
  "ic-v2-state-info-circle-line",
  "ic-v2-hardware-desktop-line",
  "ic-v2-hardware-smartphone-line",
  "ic-v2-hardware-desktop-smartphone-line",
  "ic-v2-hardware-inspection-line",
  "ic-v2-hardware-print-line",
  "ic-v2-hardware-mouse-line",
  "ic-v2-hardware-power-line",
  "ic-v2-stove-symbol-line",
  "ic-v2-stove-flake-line",
  "ic-v2-stove-ppool-app-line",
  "ic-v2-content-folder-line",
  "ic-v2-content-folder-open-line",
  "ic-v2-content-folder-add-line",
  "ic-v2-content-folder-move-line",
  "ic-v2-communication-translate-line",
  "ic-v2-editor-reflect-line",
  "ic-v2-editor-rotation-line",
  "ic-v2-editor-opacity-line",
  "ic-v2-editor-color-picker-line",
  "ic-v2-editor-crop-line",
  "ic-v2-editor-bold-line",
  "ic-v2-editor-italic-line",
  "ic-v2-editor-underline-line",
  "ic-v2-editor-strikethrough-line",
  "ic-v2-editor-font-size-line",
  "ic-v2-editor-font-color-line",
  "ic-v2-editor-quotation-line",
  "ic-v2-editor-table-line",
  "ic-v2-editor-align-left-line",
  "ic-v2-editor-align-right-line",
  "ic-v2-editor-align-center-line",
  "ic-v2-editor-align-justify-line",
  "ic-v2-editor-list-ordered-line",
  "ic-v2-editor-list-unordered-line",
  "ic-v2-editor-separator-line",
  "ic-v2-editor-link-line",
  "ic-v2-editor-emoji-line",
  "ic-v2-editor-image-line",
  "ic-v2-editor-video-line",
  "ic-v2-editor-attach-file-line",
  "ic-v2-editor-code-line",
  "ic-v2-editor-indent-increase-line",
  "ic-v2-editor-indent-decrease-line",
  "ic-v2-editor-mark-pen-line"
];
const FILL_ICONS = [
  "ic-v2-navigation-alarm-fill",
  "ic-v2-navigation-alarm-disabled-fill",
  "ic-v2-navigation-language-fill",
  "ic-v2-navigation-apps-fill",
  "ic-v2-navigation-option-vertical-fill",
  "ic-v2-navigation-option-horizontal-fill",
  "ic-v2-navigation-home-fill",
  "ic-v2-navigation-setting-fill",
  "ic-v2-navigation-coupon-fill",
  "ic-v2-navigation-message-fill",
  "ic-v2-navigation-security-fill",
  "ic-v2-navigation-cart-fill",
  "ic-v2-navigation-cart-selected-fill",
  "ic-v2-navigation-profile-fill",
  "ic-v2-navigation-board-timeline-fill",
  "ic-v2-navigation-authenticator-fill",
  "ic-v2-navigation-community-fill",
  "ic-v2-navigation-toonspoon-fill",
  "ic-v2-navigation-my-activity-fill",
  "ic-v2-navigation-shop-fill",
  "ic-v2-navigation-store-fill",
  "ic-v2-navigation-point-fill",
  "ic-v2-navigation-community-event-fill",
  "ic-v2-navigation-streaming-fill",
  "ic-v2-navigation-studio-test-fill",
  "ic-v2-navigation-game-info-fill",
  "ic-v2-navigation-link-fill",
  "ic-v2-navigation-pcbang-fill",
  "ic-v2-control-close-circle-fill",
  "ic-v2-control-add-circle-fill",
  "ic-v2-control-minus-circle-fill",
  "ic-v2-control-arrow-left-circle-fill",
  "ic-v2-control-arrow-right-circle-fill",
  "ic-v2-control-double-arrow-left-circle-fill",
  "ic-v2-control-double-arrow-right-circle-fill",
  "ic-v2-control-check-circle-fill",
  "ic-v2-control-select-arrow-up-fill",
  "ic-v2-control-select-arrow-down-fill",
  "ic-v2-control-long-arrow-left-circle-fill",
  "ic-v2-control-long-arrow-right-circle-fill",
  "ic-v2-control-long-arrow-up-circle-fill",
  "ic-v2-control-long-arrow-down-circle-fill",
  "ic-v2-control-waiting-circle-fill",
  "ic-v2-control-required-fill",
  "ic-v2-community-share-fill",
  "ic-v2-community-thumbs-up-fill",
  "ic-v2-community-thumbs-down-fill",
  "ic-v2-community-group-fill",
  "ic-v2-community-group-add-fill",
  "ic-v2-community-group-now-fill",
  "ic-v2-community-person-fill",
  "ic-v2-community-friend-add-fill",
  "ic-v2-community-friend-now-fill",
  "ic-v2-community-friend-cancel-fill",
  "ic-v2-community-friend-acceptance-fill",
  "ic-v2-community-friend-shared-fill",
  "ic-v2-community-friend-setting-list-fill",
  "ic-v2-community-star-fill",
  "ic-v2-community-bookmark-fill",
  "ic-v2-community-favorite-fill",
  "ic-v2-community-like-fill",
  "ic-v2-community-pin-fill",
  "ic-v2-community-write-fill",
  "ic-v2-community-pencil-fill",
  "ic-v2-community-number-of-view-fill",
  "ic-v2-community-view-list-fill",
  "ic-v2-community-view-card-fill",
  "ic-v2-community-view-webzine-fill",
  "ic-v2-community-view-photo-fill",
  "ic-v2-community-view-thread-fill",
  "ic-v2-community-reply-fill",
  "ic-v2-community-send-fill",
  "ic-v2-community-calendar-fill",
  "ic-v2-community-approve-fill",
  "ic-v2-community-oppose-fill",
  "ic-v2-community-attach-video-fill",
  "ic-v2-community-attach-image-fill",
  "ic-v2-community-attach-emoji-fill",
  "ic-v2-community-attach-survey-fill",
  "ic-v2-community-attach-music-fill",
  "ic-v2-community-attach-quotation-fill",
  "ic-v2-community-thumbnail-video-fill",
  "ic-v2-community-thumbnail-survey-fill",
  "ic-v2-community-thumbnail-music-fill",
  "ic-v2-community-thumbnail-pin-fill",
  "ic-v2-community-thumbnail-lock-fill",
  "ic-v2-community-forum-fill",
  "ic-v2-community-board-fill",
  "ic-v2-community-board-all-fill",
  "ic-v2-community-quotation-fill",
  "ic-v2-community-requotation-fill",
  "ic-v2-community-public-fill",
  "ic-v2-community-copy-fill",
  "ic-v2-community-comment-fill",
  "ic-v2-community-view-update-fill",
  "ic-v2-community-pin-off-fill",
  "ic-v2-community-chat-add-fill",
  "ic-v2-community-chat-broken-image-fill",
  "ic-v2-community-internet-fill",
  "ic-v2-object-cash-stove-fill",
  "ic-v2-object-game-fill",
  "ic-v2-object-payment-fill",
  "ic-v2-object-delete-fill",
  "ic-v2-object-trophy-fill",
  "ic-v2-object-coin-fill",
  "ic-v2-object-cash-circle-fill",
  "ic-v2-object-notice-fill",
  "ic-v2-object-lock-fill",
  "ic-v2-object-unlock-fill",
  "ic-v2-object-lock-check-fill",
  "ic-v2-object-clock-fill",
  "ic-v2-object-cabinet-fill",
  "ic-v2-object-help-center-fill",
  "ic-v2-object-report-fill",
  "ic-v2-object-tag-fill",
  "ic-v2-object-crown-fill",
  "ic-v2-object-indi-game-fill",
  "ic-v2-object-collection-fill",
  "ic-v2-object-early-fill",
  "ic-v2-object-vr-fill",
  "ic-v2-object-widget-fill",
  "ic-v2-object-fire-fill",
  "ic-v2-object-pen-fill",
  "ic-v2-object-notice-off-fill",
  "ic-v2-object-game-cut-fill",
  "ic-v2-object-graph-fill",
  "ic-v2-object-cloud-save-fill",
  "ic-v2-object-compass-fill",
  "ic-v2-object-cloud-fill",
  "ic-v2-media-av-play-fill",
  "ic-v2-media-av-play-round-fill",
  "ic-v2-media-av-pause-fill",
  "ic-v2-media-av-volume-fill",
  "ic-v2-media-av-volume-auto-fill",
  "ic-v2-media-av-video-add-fill",
  "ic-v2-media-av-fullscreen-fill",
  "ic-v2-media-av-fullscreen-exit-fill",
  "ic-v2-media-av-closed-caption-fill",
  "ic-v2-media-av-mic-fill",
  "ic-v2-media-av-mic-off-fill",
  "ic-v2-media-av-volume-off-fill",
  "ic-v2-media-image-flash-on-fill",
  "ic-v2-media-image-camera-fill",
  "ic-v2-media-view-down-fill",
  "ic-v2-media-view-up-fill",
  "ic-v2-media-av-sound-fill",
  "ic-v2-media-av-sound-off-fill",
  "ic-v2-content-option-vertical-fill",
  "ic-v2-content-option-horizontal-fill",
  "ic-v2-state-warning-circle-fill",
  "ic-v2-state-help-circle-fill",
  "ic-v2-state-block-fill",
  "ic-v2-state-info-circle-fill",
  "ic-v2-hardware-desktop-fill",
  "ic-v2-hardware-smartphone-fill",
  "ic-v2-hardware-desktop-smartphone-fill",
  "ic-v2-hardware-inspection-fill",
  "ic-v2-hardware-qr-code-fill",
  "ic-v2-hardware-print-fill",
  "ic-v2-hardware-mouse-fill",
  "ic-v2-logo-window-fill",
  "ic-v2-logo-apple-fill",
  "ic-v2-logo-facebook-fill",
  "ic-v2-logo-twitter-X-fill",
  "ic-v2-logo-twitter-fill",
  "ic-v2-logo-google-playstore-fill",
  "ic-v2-logo-google-fill",
  "ic-v2-logo-instagram-fill",
  "ic-v2-logo-youtube-fill",
  "ic-v2-logo-kakaotalk-fill",
  "ic-v2-logo-naver-fill",
  "ic-v2-logo-discord-fill",
  "ic-v2-logo-onestore-fill",
  "ic-v2-logo-toss-fill",
  "ic-v2-logo-galaxystore-fill",
  "ic-v2-logo-amazonstore-fill",
  "ic-v2-logo-huaweiappgallery-fill",
  "ic-v2-badge-stove-official-fill",
  "ic-v2-badge-update-round-fill",
  "ic-v2-badge-new-round-fill",
  "ic-v2-badge-ownd-round-fill",
  "ic-v2-stove-symbol-fill",
  "ic-v2-stove-wordtype-fill",
  "ic-v2-stove-ppool-wordtype-fill",
  "ic-v2-stove-ppool-pp-fill",
  "ic-v2-stove-ppool-app-fill",
  "ic-v2-stove-indie-wordtype-fill",
  "ic-v2-content-folder-fill",
  "ic-v2-content-folder-open-fill",
  "ic-v2-stove-s-fill",
  "ic-v2-communication-translate-fill",
  "ic-v2-editor-survey-fill"
];
const COLOR_ICONS = [
  "ic-v2-logo-window-color",
  "ic-v2-logo-apple-color",
  "ic-v2-logo-facebook-color",
  "ic-v2-logo-twitter-color",
  "ic-v2-logo-google-playstore-color",
  "ic-v2-logo-google-color",
  "ic-v2-logo-instagram-color",
  "ic-v2-logo-youtube-color",
  "ic-v2-logo-kakaotalk-color",
  "ic-v2-logo-naver-color",
  "ic-v2-logo-discord-color",
  "ic-v2-logo-onestore-color",
  "ic-v2-logo-toss-color",
  "ic-v2-logo-galaxystore-color",
  "ic-v2-logo-amazonstore-color",
  "ic-v2-logo-huaweiappgallery-color",
  "ic-v2-badge-update-round-color",
  "ic-v2-badge-update-text-color",
  "ic-v2-badge-new-round-color",
  "ic-v2-badge-ownd-round-color",
  "ic-v2-badge-early-round-color",
  "ic-v2-stove-symbol-color",
  "ic-v2-stove-wordtype-color",
  "ic-v2-stove-cash-color",
  "ic-v2-stove-point-color",
  "ic-v2-stove-flake-color",
  "ic-v2-stove-ppool-wordtype-color",
  "ic-v2-stove-ppool-pp-color",
  "ic-v2-stove-ppool-app-color"
];
const ALL_ICONS = [
  ...LINE_ICONS,
  ...FILL_ICONS,
  ...COLOR_ICONS
];
const SAMPLE_ICON_VARIANTS_BY_NAME = {
  sample: {
    line: "ic-v2-sample"
  }
};
const SAMPLE_ICON_NAMES = objectKeys(SAMPLE_ICON_VARIANTS_BY_NAME);
const NAVIGATION_ICON_VARIANTS_BY_NAME = {
  "alarm": {
    line: "ic-v2-navigation-alarm-line",
    fill: "ic-v2-navigation-alarm-fill"
  },
  "alarm-disabled": {
    line: "ic-v2-navigation-alarm-disabled-line",
    fill: "ic-v2-navigation-alarm-disabled-fill"
  },
  "language": {
    line: "ic-v2-navigation-language-line",
    fill: "ic-v2-navigation-language-fill"
  },
  "apps": {
    fill: "ic-v2-navigation-apps-fill"
  },
  "menu": {
    line: "ic-v2-navigation-menu-line"
  },
  "option-vertical": {
    fill: "ic-v2-navigation-option-vertical-fill"
  },
  "option-horizontal": {
    fill: "ic-v2-navigation-option-horizontal-fill"
  },
  "search": {
    line: "ic-v2-navigation-search-line"
  },
  "home": {
    line: "ic-v2-navigation-home-line",
    fill: "ic-v2-navigation-home-fill"
  },
  "setting": {
    line: "ic-v2-navigation-setting-line",
    fill: "ic-v2-navigation-setting-fill"
  },
  "sub-menu": {
    line: "ic-v2-navigation-sub-menu-line"
  },
  "login": {
    line: "ic-v2-navigation-login-line"
  },
  "logout": {
    line: "ic-v2-navigation-logout-line"
  },
  "coupon": {
    line: "ic-v2-navigation-coupon-line",
    fill: "ic-v2-navigation-coupon-fill"
  },
  "message": {
    line: "ic-v2-navigation-message-line",
    fill: "ic-v2-navigation-message-fill"
  },
  "security": {
    line: "ic-v2-navigation-security-line",
    fill: "ic-v2-navigation-security-fill"
  },
  "cart": {
    line: "ic-v2-navigation-cart-line",
    fill: "ic-v2-navigation-cart-fill"
  },
  "cart-selected": {
    line: "ic-v2-navigation-cart-selected-line",
    fill: "ic-v2-navigation-cart-selected-fill"
  },
  "profile": {
    line: "ic-v2-navigation-profile-line",
    fill: "ic-v2-navigation-profile-fill"
  },
  "board-timeline": {
    line: "ic-v2-navigation-board-timeline-line",
    fill: "ic-v2-navigation-board-timeline-fill"
  },
  "authenticator": {
    line: "ic-v2-navigation-authenticator-line",
    fill: "ic-v2-navigation-authenticator-fill"
  },
  "community": {
    line: "ic-v2-navigation-community-line",
    fill: "ic-v2-navigation-community-fill"
  },
  "toonspoon": {
    line: "ic-v2-navigation-toonspoon-line",
    fill: "ic-v2-navigation-toonspoon-fill"
  },
  "my-activity": {
    line: "ic-v2-navigation-my-activity-line",
    fill: "ic-v2-navigation-my-activity-fill"
  },
  "shop": {
    line: "ic-v2-navigation-shop-line",
    fill: "ic-v2-navigation-shop-fill"
  },
  "store": {
    line: "ic-v2-navigation-store-line",
    fill: "ic-v2-navigation-store-fill"
  },
  "point": {
    line: "ic-v2-navigation-point-line",
    fill: "ic-v2-navigation-point-fill"
  },
  "community-event": {
    line: "ic-v2-navigation-community-event-line",
    fill: "ic-v2-navigation-community-event-fill"
  },
  "streaming": {
    line: "ic-v2-navigation-streaming-line",
    fill: "ic-v2-navigation-streaming-fill"
  },
  "studio-test": {
    line: "ic-v2-navigation-studio-test-line",
    fill: "ic-v2-navigation-studio-test-fill"
  },
  "game-info": {
    line: "ic-v2-navigation-game-info-line",
    fill: "ic-v2-navigation-game-info-fill"
  },
  "link": {
    fill: "ic-v2-navigation-link-fill"
  },
  "pcbang": {
    line: "ic-v2-navigation-pcbang-line",
    fill: "ic-v2-navigation-pcbang-fill"
  },
  "bank": {
    line: "ic-v2-navigation-bank-line"
  }
};
const NAVIGATION_ICON_NAMES = objectKeys(
  NAVIGATION_ICON_VARIANTS_BY_NAME
);
const CONTROL_ICON_VARIANTS_BY_NAME = {
  "refresh": {
    line: "ic-v2-control-refresh-line"
  },
  "update": {
    line: "ic-v2-control-update-line"
  },
  "close": {
    line: "ic-v2-control-close-line"
  },
  "close-circle": {
    line: "ic-v2-control-close-circle-line",
    fill: "ic-v2-control-close-circle-fill"
  },
  "add": {
    line: "ic-v2-control-add-line"
  },
  "add-circle": {
    line: "ic-v2-control-add-circle-line",
    fill: "ic-v2-control-add-circle-fill"
  },
  "minus": {
    line: "ic-v2-control-minus-line"
  },
  "minus-circle": {
    line: "ic-v2-control-minus-circle-line",
    fill: "ic-v2-control-minus-circle-fill"
  },
  "sum": {
    line: "ic-v2-control-sum-line"
  },
  "long-arrow-left": {
    line: "ic-v2-control-long-arrow-left-line"
  },
  "long-arrow-right": {
    line: "ic-v2-control-long-arrow-right-line"
  },
  "long-arrow-up": {
    line: "ic-v2-control-long-arrow-up-line"
  },
  "long-arrow-down": {
    line: "ic-v2-control-long-arrow-down-line"
  },
  "arrow-left": {
    line: "ic-v2-control-arrow-left-line"
  },
  "arrow-right": {
    line: "ic-v2-control-arrow-right-line"
  },
  "arrow-up": {
    line: "ic-v2-control-arrow-up-line"
  },
  "arrow-down": {
    line: "ic-v2-control-arrow-down-line"
  },
  "double-arrow-left": {
    line: "ic-v2-control-double-arrow-left-line"
  },
  "double-arrow-right": {
    line: "ic-v2-control-double-arrow-right-line"
  },
  "arrow-left-circle": {
    line: "ic-v2-control-arrow-left-circle-line",
    fill: "ic-v2-control-arrow-left-circle-fill"
  },
  "arrow-right-circle": {
    line: "ic-v2-control-arrow-right-circle-line",
    fill: "ic-v2-control-arrow-right-circle-fill"
  },
  "double-arrow-left-circle": {
    line: "ic-v2-control-double-arrow-left-circle-line",
    fill: "ic-v2-control-double-arrow-left-circle-fill"
  },
  "double-arrow-right-circle": {
    line: "ic-v2-control-double-arrow-right-circle-line",
    fill: "ic-v2-control-double-arrow-right-circle-fill"
  },
  "web-link": {
    line: "ic-v2-control-web-link-line"
  },
  "minimize": {
    line: "ic-v2-control-minimize-line"
  },
  "maximize": {
    line: "ic-v2-control-maximize-line"
  },
  "enlarge": {
    line: "ic-v2-control-enlarge-line"
  },
  "preview": {
    line: "ic-v2-control-preview-line"
  },
  "top": {
    line: "ic-v2-control-top-line"
  },
  "bottom": {
    line: "ic-v2-control-bottom-line"
  },
  "check": {
    line: "ic-v2-control-check-line"
  },
  "check-bold": {
    line: "ic-v2-control-check-bold-line"
  },
  "check-circle": {
    line: "ic-v2-control-check-circle-line",
    fill: "ic-v2-control-check-circle-fill"
  },
  "select-arrow-up": {
    fill: "ic-v2-control-select-arrow-up-fill"
  },
  "select-arrow-down": {
    fill: "ic-v2-control-select-arrow-down-fill"
  },
  "long-arrow-left-circle": {
    line: "ic-v2-control-long-arrow-left-circle-line",
    fill: "ic-v2-control-long-arrow-left-circle-fill"
  },
  "long-arrow-right-circle": {
    line: "ic-v2-control-long-arrow-right-circle-line",
    fill: "ic-v2-control-long-arrow-right-circle-fill"
  },
  "long-arrow-down-circle": {
    line: "ic-v2-control-long-arrow-down-circle-line",
    fill: "ic-v2-control-long-arrow-down-circle-fill"
  },
  "long-arrow-up-circle": {
    line: "ic-v2-control-long-arrow-up-circle-line",
    fill: "ic-v2-control-long-arrow-up-circle-fill"
  },
  "undo": {
    line: "ic-v2-control-undo-line"
  },
  "redo": {
    line: "ic-v2-control-redo-line"
  },
  "recover": {
    line: "ic-v2-control-recover-line"
  },
  "sync": {
    line: "ic-v2-control-sync-line"
  },
  "waiting-circle": {
    line: "ic-v2-control-waiting-circle-line",
    fill: "ic-v2-control-waiting-circle-fill"
  },
  "sort": {
    line: "ic-v2-control-sort-line"
  },
  "sort-arrow": {
    line: "ic-v2-control-sort-arrow-line"
  },
  "required": {
    fill: "ic-v2-control-required-fill"
  }
};
const CONTROL_ICON_NAMES = objectKeys(CONTROL_ICON_VARIANTS_BY_NAME);
const COMMUNITY_ICON_VARIANTS_BY_NAME = {
  "attach-file": {
    line: "ic-v2-community-attach-file-line"
  },
  "share": {
    line: "ic-v2-community-share-line",
    fill: "ic-v2-community-share-fill"
  },
  "thumbs-up": {
    line: "ic-v2-community-thumbs-up-line",
    fill: "ic-v2-community-thumbs-up-fill"
  },
  "thumbs-down": {
    line: "ic-v2-community-thumbs-down-line",
    fill: "ic-v2-community-thumbs-down-fill"
  },
  "group": {
    line: "ic-v2-community-group-line",
    fill: "ic-v2-community-group-fill"
  },
  "group-add": {
    line: "ic-v2-community-group-add-line",
    fill: "ic-v2-community-group-add-fill"
  },
  "group-now": {
    line: "ic-v2-community-group-now-line",
    fill: "ic-v2-community-group-now-fill"
  },
  "person": {
    line: "ic-v2-community-person-line",
    fill: "ic-v2-community-person-fill"
  },
  "friend-add": {
    line: "ic-v2-community-friend-add-line",
    fill: "ic-v2-community-friend-add-fill"
  },
  "friend-now": {
    line: "ic-v2-community-friend-now-line",
    fill: "ic-v2-community-friend-now-fill"
  },
  "friend-cancel": {
    line: "ic-v2-community-friend-cancel-line",
    fill: "ic-v2-community-friend-cancel-fill"
  },
  "friend-acceptance": {
    line: "ic-v2-community-friend-acceptance-line",
    fill: "ic-v2-community-friend-acceptance-fill"
  },
  "friend-shared": {
    line: "ic-v2-community-friend-shared-line",
    fill: "ic-v2-community-friend-shared-fill"
  },
  "friend-setting-list": {
    line: "ic-v2-community-friend-setting-list-line",
    fill: "ic-v2-community-friend-setting-list-fill"
  },
  "star": {
    line: "ic-v2-community-star-line",
    fill: "ic-v2-community-star-fill"
  },
  "star-half": {
    line: "ic-v2-community-star-half-line"
  },
  "bookmark": {
    line: "ic-v2-community-bookmark-line",
    fill: "ic-v2-community-bookmark-fill"
  },
  "favorite": {
    line: "ic-v2-community-favorite-line",
    fill: "ic-v2-community-favorite-fill"
  },
  "like": {
    line: "ic-v2-community-like-line",
    fill: "ic-v2-community-like-fill"
  },
  "pin": {
    line: "ic-v2-community-pin-line",
    fill: "ic-v2-community-pin-fill"
  },
  "write": {
    line: "ic-v2-community-write-line",
    fill: "ic-v2-community-write-fill"
  },
  "pencil": {
    line: "ic-v2-community-pencil-line",
    fill: "ic-v2-community-pencil-fill"
  },
  "number-of-view": {
    line: "ic-v2-community-number-of-view-line",
    fill: "ic-v2-community-number-of-view-fill"
  },
  "hashtag": {
    line: "ic-v2-community-hashtag-line"
  },
  "view-list": {
    fill: "ic-v2-community-view-list-fill"
  },
  "view-card": {
    line: "ic-v2-community-view-card-line",
    fill: "ic-v2-community-view-card-fill"
  },
  "view-webzine": {
    line: "ic-v2-community-view-webzine-line",
    fill: "ic-v2-community-view-webzine-fill"
  },
  "view-photo": {
    line: "ic-v2-community-view-photo-line",
    fill: "ic-v2-community-view-photo-fill"
  },
  "view-thread": {
    line: "ic-v2-community-view-thread-line",
    fill: "ic-v2-community-view-thread-fill"
  },
  "filter": {
    line: "ic-v2-community-filter-line"
  },
  "reply": {
    line: "ic-v2-community-reply-line",
    fill: "ic-v2-community-reply-fill"
  },
  "link": {
    line: "ic-v2-community-link-line"
  },
  "unlink": {
    line: "ic-v2-community-unlink-line"
  },
  "send": {
    line: "ic-v2-community-send-line",
    fill: "ic-v2-community-send-fill"
  },
  "calendar": {
    line: "ic-v2-community-calendar-line",
    fill: "ic-v2-community-calendar-fill"
  },
  "approve": {
    line: "ic-v2-community-approve-line",
    fill: "ic-v2-community-approve-fill"
  },
  "oppose": {
    line: "ic-v2-community-oppose-line",
    fill: "ic-v2-community-oppose-fill"
  },
  "attach-video": {
    line: "ic-v2-community-attach-video-line",
    fill: "ic-v2-community-attach-video-fill"
  },
  "attach-image": {
    line: "ic-v2-community-attach-image-line",
    fill: "ic-v2-community-attach-image-fill"
  },
  "attach-emoji": {
    line: "ic-v2-community-attach-emoji-line",
    fill: "ic-v2-community-attach-emoji-fill"
  },
  "attach-survey": {
    line: "ic-v2-community-attach-survey-line",
    fill: "ic-v2-community-attach-survey-fill"
  },
  "attach-music": {
    line: "ic-v2-community-attach-music-line",
    fill: "ic-v2-community-attach-music-fill"
  },
  "attach-quotation": {
    line: "ic-v2-community-attach-quotation-line",
    fill: "ic-v2-community-attach-quotation-fill"
  },
  "thumbnail-video": {
    line: "ic-v2-community-thumbnail-video-line",
    fill: "ic-v2-community-thumbnail-video-fill"
  },
  "thumbnail-survey": {
    line: "ic-v2-community-thumbnail-survey-line",
    fill: "ic-v2-community-thumbnail-survey-fill"
  },
  "thumbnail-music": {
    line: "ic-v2-community-thumbnail-music-line",
    fill: "ic-v2-community-thumbnail-music-fill"
  },
  "thumbnail-lock": {
    line: "ic-v2-community-thumbnail-lock-line",
    fill: "ic-v2-community-thumbnail-lock-fill"
  },
  "thumbnail-pin": {
    line: "ic-v2-community-thumbnail-pin-line",
    fill: "ic-v2-community-thumbnail-pin-fill"
  },
  "sort-ascending": {
    line: "ic-v2-community-sort-ascending-line"
  },
  "sort-descending": {
    line: "ic-v2-community-sort-descending-line"
  },
  "forum": {
    line: "ic-v2-community-forum-line",
    fill: "ic-v2-community-forum-fill"
  },
  "board": {
    line: "ic-v2-community-board-line",
    fill: "ic-v2-community-board-fill"
  },
  "board-all": {
    line: "ic-v2-community-board-all-line",
    fill: "ic-v2-community-board-all-fill"
  },
  "quotation": {
    fill: "ic-v2-community-quotation-fill"
  },
  "requotation": {
    line: "ic-v2-community-requotation-line",
    fill: "ic-v2-community-requotation-fill"
  },
  "public": {
    line: "ic-v2-community-public-line",
    fill: "ic-v2-community-public-fill"
  },
  "random": {
    line: "ic-v2-community-random-line"
  },
  "copy": {
    line: "ic-v2-community-copy-line",
    fill: "ic-v2-community-copy-fill"
  },
  "comment": {
    line: "ic-v2-community-comment-line",
    fill: "ic-v2-community-comment-fill"
  },
  "view-update": {
    line: "ic-v2-community-view-update-line",
    fill: "ic-v2-community-view-update-fill"
  },
  "pin-off": {
    line: "ic-v2-community-pin-off-line",
    fill: "ic-v2-community-pin-off-fill"
  },
  "chat-add": {
    line: "ic-v2-community-chat-add-line",
    fill: "ic-v2-community-chat-add-fill"
  },
  "chat-broken-image": {
    line: "ic-v2-community-chat-broken-image-line",
    fill: "ic-v2-community-chat-broken-image-fill"
  },
  "comments": {
    line: "ic-v2-community-comments-line"
  },
  "capture": {
    line: "ic-v2-community-capture-line"
  },
  "internet": {
    line: "ic-v2-community-internet-line",
    fill: "ic-v2-community-internet-fill"
  }
};
const COMMUNITY_ICON_NAMES = objectKeys(COMMUNITY_ICON_VARIANTS_BY_NAME);
const OBJECT_ICON_VARIANTS_BY_NAME = {
  "cash-stove": {
    line: "ic-v2-object-cash-stove-line",
    fill: "ic-v2-object-cash-stove-fill"
  },
  "game": {
    line: "ic-v2-object-game-line",
    fill: "ic-v2-object-game-fill"
  },
  "download": {
    line: "ic-v2-object-download-line"
  },
  "payment": {
    line: "ic-v2-object-payment-line",
    fill: "ic-v2-object-payment-fill"
  },
  "delete": {
    line: "ic-v2-object-delete-line",
    fill: "ic-v2-object-delete-fill"
  },
  "trophy": {
    line: "ic-v2-object-trophy-line",
    fill: "ic-v2-object-trophy-fill"
  },
  "coin": {
    line: "ic-v2-object-coin-line",
    fill: "ic-v2-object-coin-fill"
  },
  "cash-circle": {
    line: "ic-v2-object-cash-circle-line",
    fill: "ic-v2-object-cash-circle-fill"
  },
  "notice": {
    line: "ic-v2-object-notice-line",
    fill: "ic-v2-object-notice-fill"
  },
  "lock": {
    line: "ic-v2-object-lock-line",
    fill: "ic-v2-object-lock-fill"
  },
  "unlock": {
    line: "ic-v2-object-unlock-line",
    fill: "ic-v2-object-unlock-fill"
  },
  "lock_check": {
    line: "ic-v2-object-lock-check-line",
    fill: "ic-v2-object-lock-check-fill"
  },
  "clock": {
    line: "ic-v2-object-clock-line",
    fill: "ic-v2-object-clock-fill"
  },
  "cabinet": {
    line: "ic-v2-object-cabinet-line",
    fill: "ic-v2-object-cabinet-fill"
  },
  "help-center": {
    line: "ic-v2-object-help-center-line",
    fill: "ic-v2-object-help-center-fill"
  },
  "report": {
    line: "ic-v2-object-report-line",
    fill: "ic-v2-object-report-fill"
  },
  "tag": {
    line: "ic-v2-object-tag-line",
    fill: "ic-v2-object-tag-fill"
  },
  "crown": {
    line: "ic-v2-object-crown-line",
    fill: "ic-v2-object-crown-fill"
  },
  "indi-game": {
    line: "ic-v2-object-indi-game-line",
    fill: "ic-v2-object-indi-game-fill"
  },
  "collection": {
    line: "ic-v2-object-collection-line",
    fill: "ic-v2-object-collection-fill"
  },
  "early": {
    line: "ic-v2-object-early-line",
    fill: "ic-v2-object-early-fill"
  },
  "vr": {
    fill: "ic-v2-object-vr-fill"
  },
  "widget": {
    line: "ic-v2-object-widget-line",
    fill: "ic-v2-object-widget-fill"
  },
  "fire": {
    line: "ic-v2-object-fire-line",
    fill: "ic-v2-object-fire-fill"
  },
  "pen": {
    line: "ic-v2-object-pen-line",
    fill: "ic-v2-object-pen-fill"
  },
  "notice-off": {
    line: "ic-v2-object-notice-off-line",
    fill: "ic-v2-object-notice-off-fill"
  },
  "sea": {
    line: "ic-v2-object-sea-line"
  },
  "game-cut": {
    line: "ic-v2-object-game-cut-line",
    fill: "ic-v2-object-game-cut-fill"
  },
  "graph": {
    line: "ic-v2-object-graph-line",
    fill: "ic-v2-object-graph-fill"
  },
  "cloud-save": {
    line: "ic-v2-object-cloud-save-line",
    fill: "ic-v2-object-cloud-save-fill"
  },
  "compass": {
    line: "ic-v2-object-compass-line",
    fill: "ic-v2-object-compass-fill"
  },
  "cloud": {
    line: "ic-v2-object-cloud-line",
    fill: "ic-v2-object-cloud-fill"
  },
  "upload": {
    line: "ic-v2-object-upload-line"
  },
  "rating": {
    line: "ic-v2-object-rating-line"
  }
};
const OBJECT_ICON_NAMES = objectKeys(OBJECT_ICON_VARIANTS_BY_NAME);
const MEDIA_AV_ICON_VARIANTS_BY_NAME = {
  "play": {
    line: "ic-v2-media-av-play-line",
    fill: "ic-v2-media-av-play-fill"
  },
  "play-round": {
    fill: "ic-v2-media-av-play-round-fill"
  },
  "pause": {
    fill: "ic-v2-media-av-pause-fill"
  },
  "volume": {
    line: "ic-v2-media-av-volume-line",
    fill: "ic-v2-media-av-volume-fill"
  },
  "volume-auto": {
    line: "ic-v2-media-av-volume-auto-line",
    fill: "ic-v2-media-av-volume-auto-fill"
  },
  "video-add": {
    line: "ic-v2-media-av-video-add-line",
    fill: "ic-v2-media-av-video-add-fill"
  },
  "fullscreen": {
    fill: "ic-v2-media-av-fullscreen-fill"
  },
  "fullscreen-exit": {
    fill: "ic-v2-media-av-fullscreen-exit-fill"
  },
  "closed-caption": {
    line: "ic-v2-media-av-closed-caption-line",
    fill: "ic-v2-media-av-closed-caption-fill"
  },
  "mic": {
    line: "ic-v2-media-av-mic-line",
    fill: "ic-v2-media-av-mic-fill"
  },
  "mic-off": {
    line: "ic-v2-media-av-mic-off-line",
    fill: "ic-v2-media-av-mic-off-fill"
  },
  "volume-off": {
    line: "ic-v2-media-av-volume-off-line",
    fill: "ic-v2-media-av-volume-off-fill"
  },
  "sound": {
    line: "ic-v2-media-av-sound-line",
    fill: "ic-v2-media-av-sound-fill"
  },
  "sound-off": {
    line: "ic-v2-media-av-sound-off-line",
    fill: "ic-v2-media-av-sound-off-fill"
  }
};
const MEDIA_AV_ICON_NAMES = objectKeys(MEDIA_AV_ICON_VARIANTS_BY_NAME);
const MEDIA_IMAGE_ICON_VARIANTS_BY_NAME = {
  "flash-on": {
    line: "ic-v2-media-image-flash-on-line",
    fill: "ic-v2-media-image-flash-on-fill"
  },
  "camera": {
    line: "ic-v2-media-image-camera-line",
    fill: "ic-v2-media-image-camera-fill"
  },
  "view-down": {
    line: "ic-v2-media-view-down-line",
    fill: "ic-v2-media-view-down-fill"
  },
  "view-up": {
    line: "ic-v2-media-view-up-line",
    fill: "ic-v2-media-view-up-fill"
  },
  "view-full": {
    line: "ic-v2-media-view-full-line"
  }
};
const MEDIA_IMAGE_ICON_NAMES = objectKeys(
  MEDIA_IMAGE_ICON_VARIANTS_BY_NAME
);
const STATE_ICON_VARIANTS_BY_NAME = {
  "warning-circle": {
    line: "ic-v2-state-warning-circle-line",
    fill: "ic-v2-state-warning-circle-fill"
  },
  "help-circle": {
    line: "ic-v2-state-help-circle-line",
    fill: "ic-v2-state-help-circle-fill"
  },
  "block": {
    line: "ic-v2-state-block-line",
    fill: "ic-v2-state-block-fill"
  },
  "info-circle": {
    line: "ic-v2-state-info-circle-line",
    fill: "ic-v2-state-info-circle-fill"
  }
};
const STATE_ICON_NAMES = objectKeys(STATE_ICON_VARIANTS_BY_NAME);
const HARDWARE_ICON_VARIANTS_BY_NAME = {
  "desktop": {
    line: "ic-v2-hardware-desktop-line",
    fill: "ic-v2-hardware-desktop-fill"
  },
  "smartphone": {
    line: "ic-v2-hardware-smartphone-line",
    fill: "ic-v2-hardware-smartphone-fill"
  },
  "desktop-smartphone": {
    line: "ic-v2-hardware-desktop-smartphone-line",
    fill: "ic-v2-hardware-desktop-smartphone-fill"
  },
  "Inspection": {
    line: "ic-v2-hardware-inspection-line",
    fill: "ic-v2-hardware-inspection-fill"
  },
  "qr-code": {
    fill: "ic-v2-hardware-qr-code-fill"
  },
  "print": {
    line: "ic-v2-hardware-print-line",
    fill: "ic-v2-hardware-print-fill"
  },
  "mouse": {
    line: "ic-v2-hardware-mouse-line",
    fill: "ic-v2-hardware-mouse-fill"
  },
  "power": {
    line: "ic-v2-hardware-power-line"
  }
};
const HARDWARE_ICON_NAMES = objectKeys(HARDWARE_ICON_VARIANTS_BY_NAME);
const LOGO_ICON_VARIANTS_BY_NAME = {
  "window": {
    fill: "ic-v2-logo-window-fill",
    color: "ic-v2-logo-window-color"
  },
  "Apple": {
    fill: "ic-v2-logo-apple-fill",
    color: "ic-v2-logo-apple-color"
  },
  "facebook": {
    fill: "ic-v2-logo-facebook-fill",
    color: "ic-v2-logo-facebook-color"
  },
  "x": {
    fill: "ic-v2-logo-twitter-X-fill"
  },
  "twitter": {
    fill: "ic-v2-logo-twitter-fill",
    color: "ic-v2-logo-twitter-color"
  },
  "google-playstore": {
    fill: "ic-v2-logo-google-playstore-fill",
    color: "ic-v2-logo-google-playstore-color"
  },
  "google": {
    fill: "ic-v2-logo-google-fill",
    color: "ic-v2-logo-google-color"
  },
  "instagram": {
    fill: "ic-v2-logo-instagram-fill",
    color: "ic-v2-logo-instagram-color"
  },
  "youtube": {
    fill: "ic-v2-logo-youtube-fill",
    color: "ic-v2-logo-youtube-color"
  },
  "kakaotalk": {
    fill: "ic-v2-logo-kakaotalk-fill",
    color: "ic-v2-logo-kakaotalk-color"
  },
  "naver": {
    fill: "ic-v2-logo-naver-fill",
    color: "ic-v2-logo-naver-color"
  },
  "discord": {
    fill: "ic-v2-logo-discord-fill",
    color: "ic-v2-logo-discord-color"
  },
  "onestore": {
    fill: "ic-v2-logo-onestore-fill",
    color: "ic-v2-logo-onestore-color"
  },
  "toss": {
    fill: "ic-v2-logo-toss-fill",
    color: "ic-v2-logo-toss-color"
  },
  "galaxystore": {
    fill: "ic-v2-logo-galaxystore-fill",
    color: "ic-v2-logo-galaxystore-color"
  },
  "amazonstore": {
    fill: "ic-v2-logo-amazonstore-fill",
    color: "ic-v2-logo-amazonstore-color"
  },
  "huaweiappgallery": {
    fill: "ic-v2-logo-huaweiappgallery-fill",
    color: "ic-v2-logo-huaweiappgallery-color"
  }
};
const LOGO_ICON_NAMES = objectKeys(LOGO_ICON_VARIANTS_BY_NAME);
const BADGE_ICON_VARIANTS_BY_NAME = {
  "stove-official": {
    fill: "ic-v2-badge-stove-official-fill"
  },
  "update-round": {
    fill: "ic-v2-badge-update-round-fill",
    color: "ic-v2-badge-update-round-color"
  },
  "update-text": {
    color: "ic-v2-badge-update-text-color"
  },
  "new-round": {
    fill: "ic-v2-badge-new-round-fill",
    color: "ic-v2-badge-new-round-color"
  },
  "ownd-round": {
    fill: "ic-v2-badge-ownd-round-fill",
    color: "ic-v2-badge-ownd-round-color"
  },
  "early-round": {
    color: "ic-v2-badge-early-round-color"
  }
};
const BADGE_ICON_NAMES = objectKeys(BADGE_ICON_VARIANTS_BY_NAME);
const STOVE_ICON_VARIANTS_BY_NAME = {
  "symbol": {
    line: "ic-v2-stove-symbol-line",
    fill: "ic-v2-stove-symbol-fill",
    color: "ic-v2-stove-symbol-color"
  },
  "wordtype": {
    fill: "ic-v2-stove-wordtype-fill",
    color: "ic-v2-stove-wordtype-color"
  },
  "cash": {
    color: "ic-v2-stove-cash-color"
  },
  "point": {
    color: "ic-v2-stove-point-color"
  },
  "flake": {
    line: "ic-v2-stove-flake-line",
    color: "ic-v2-stove-flake-color"
  },
  "ppool-wordtype": {
    fill: "ic-v2-stove-ppool-wordtype-fill",
    color: "ic-v2-stove-ppool-wordtype-color"
  },
  "ppool-pp": {
    fill: "ic-v2-stove-ppool-pp-fill",
    color: "ic-v2-stove-ppool-pp-color"
  },
  "ppool-app": {
    line: "ic-v2-stove-ppool-app-line",
    fill: "ic-v2-stove-ppool-app-fill",
    color: "ic-v2-stove-ppool-app-color"
  },
  "indie-wordtype": {
    fill: "ic-v2-stove-indie-wordtype-fill"
  },
  "s": {
    fill: "ic-v2-stove-s-fill"
  }
};
const STOVE_ICON_NAMES = objectKeys(STOVE_ICON_VARIANTS_BY_NAME);
const COMMUNICATION_ICON_VARIANTS_BY_NAME = {
  translate: {
    line: "ic-v2-communication-translate-line",
    fill: "ic-v2-communication-translate-fill"
  }
};
const COMMUNICATION_ICON_NAMES = objectKeys(
  COMMUNICATION_ICON_VARIANTS_BY_NAME
);
const CONTENT_ICON_VARIANTS_BY_NAME = {
  "folder": {
    line: "ic-v2-content-folder-line",
    fill: "ic-v2-content-folder-fill"
  },
  "folder-open": {
    line: "ic-v2-content-folder-open-line",
    fill: "ic-v2-content-folder-open-fill"
  },
  "folder-add": {
    line: "ic-v2-content-folder-add-line"
  },
  "folder-move": {
    line: "ic-v2-content-folder-move-line"
  },
  "option-vertical": {
    fill: "ic-v2-content-option-vertical-fill"
  },
  "option-horizontal": {
    fill: "ic-v2-content-option-horizontal-fill"
  }
};
const CONTENT_ICON_NAMES = objectKeys(CONTENT_ICON_VARIANTS_BY_NAME);
const EDITOR_ICON_VARIANTS_BY_NAME = {
  "reflect": {
    line: "ic-v2-editor-reflect-line"
  },
  "rotation": {
    line: "ic-v2-editor-rotation-line"
  },
  "opacity": {
    line: "ic-v2-editor-opacity-line"
  },
  "color-picker": {
    line: "ic-v2-editor-color-picker-line"
  },
  "crop": {
    line: "ic-v2-editor-crop-line"
  },
  "bold": {
    line: "ic-v2-editor-bold-line"
  },
  "italic": {
    line: "ic-v2-editor-italic-line"
  },
  "underline": {
    line: "ic-v2-editor-underline-line"
  },
  "strikethrough": {
    line: "ic-v2-editor-strikethrough-line"
  },
  "font-size": {
    line: "ic-v2-editor-font-size-line"
  },
  "font-color": {
    line: "ic-v2-editor-font-color-line"
  },
  "quotation": {
    line: "ic-v2-editor-quotation-line"
  },
  "table": {
    line: "ic-v2-editor-table-line"
  },
  "align-left": {
    line: "ic-v2-editor-align-left-line"
  },
  "align-right": {
    line: "ic-v2-editor-align-right-line"
  },
  "align-center": {
    line: "ic-v2-editor-align-center-line"
  },
  "align-justify": {
    line: "ic-v2-editor-align-justify-line"
  },
  "list-ordered": {
    line: "ic-v2-editor-list-ordered-line"
  },
  "list-unordered": {
    line: "ic-v2-editor-list-unordered-line"
  },
  "separator": {
    line: "ic-v2-editor-separator-line"
  },
  "link": {
    line: "ic-v2-editor-link-line"
  },
  "emoji": {
    line: "ic-v2-editor-emoji-line"
  },
  "image": {
    line: "ic-v2-editor-image-line"
  },
  "video": {
    line: "ic-v2-editor-video-line"
  },
  "survey": {
    fill: "ic-v2-editor-survey-fill"
  },
  "attach-file": {
    line: "ic-v2-editor-attach-file-line"
  },
  "code": {
    line: "ic-v2-editor-code-line"
  },
  "indent-increase": {
    line: "ic-v2-editor-indent-increase-line"
  },
  "indent-decrease": {
    line: "ic-v2-editor-indent-decrease-line"
  },
  "mark-pen": {
    line: "ic-v2-editor-mark-pen-line"
  }
};
const EDITOR_ICON_NAMES = objectKeys(EDITOR_ICON_VARIANTS_BY_NAME);
const icon = {
  "sample": SAMPLE_ICON_VARIANTS_BY_NAME,
  "navigation": NAVIGATION_ICON_VARIANTS_BY_NAME,
  "control": CONTROL_ICON_VARIANTS_BY_NAME,
  "community": COMMUNITY_ICON_VARIANTS_BY_NAME,
  "object": OBJECT_ICON_VARIANTS_BY_NAME,
  "media/av": MEDIA_AV_ICON_VARIANTS_BY_NAME,
  "media/image": MEDIA_IMAGE_ICON_VARIANTS_BY_NAME,
  "state": STATE_ICON_VARIANTS_BY_NAME,
  "hardware": HARDWARE_ICON_VARIANTS_BY_NAME,
  "logo": LOGO_ICON_VARIANTS_BY_NAME,
  "badge": BADGE_ICON_VARIANTS_BY_NAME,
  "stove": STOVE_ICON_VARIANTS_BY_NAME,
  "communication": COMMUNICATION_ICON_VARIANTS_BY_NAME,
  "content": CONTENT_ICON_VARIANTS_BY_NAME,
  "editor": EDITOR_ICON_VARIANTS_BY_NAME
};
const size = {
  "0": "0px",
  "2": ".2rem",
  "4": ".4rem",
  "8": ".8rem",
  "11": "1.1rem",
  "12": "1.2rem",
  "16": "1.6rem",
  "20": "2rem",
  "24": "2.4rem",
  "28": "2.8rem",
  "32": "3.2rem",
  "36": "3.6rem",
  "40": "4rem",
  "44": "4.4rem",
  "48": "4.8rem",
  "52": "5.2rem",
  "56": "5.6rem",
  "60": "6rem",
  "64": "6.4rem",
  "68": "6.8rem",
  "72": "7.2rem",
  "76": "7.6rem",
  "80": "8rem",
  "84": "8.4rem",
  "88": "8.8rem",
  "92": "9.2rem",
  "96": "9.6rem",
  "100": "10rem",
  "104": "10.4rem",
  "108": "10.8rem",
  "112": "11.2rem",
  "116": "11.6rem",
  "120": "12rem",
  "124": "12.4rem",
  "128": "12.8rem",
  "132": "13.2rem",
  "136": "13.6rem",
  "140": "14rem",
  "144": "14.4rem",
  "148": "14.8rem",
  "152": "15.2rem",
  "156": "15.6rem",
  "160": "16rem",
  "164": "16.4rem",
  "168": "16.8rem",
  "172": "17.2rem",
  "176": "17.6rem",
  "180": "18rem",
  "184": "18.4rem",
  "188": "18.8rem",
  "192": "19.2rem",
  "196": "19.6rem",
  "200": "20rem",
  "204": "20.4rem",
  "208": "20.8rem",
  "212": "21.2rem",
  "216": "21.6rem",
  "220": "22rem",
  "224": "22.4rem",
  "228": "22.8rem",
  "232": "23.2rem",
  "236": "23.6rem",
  "240": "24rem",
  "244": "24.4rem",
  "248": "24.8rem",
  "252": "25.2rem",
  "256": "25.6rem",
  "260": "26rem",
  "264": "26.4rem",
  "268": "26.8rem",
  "272": "27.2rem",
  "276": "27.6rem",
  "280": "28rem",
  "284": "28.4rem",
  "288": "28.8rem",
  "292": "29.2rem",
  "296": "29.6rem",
  "300": "30rem",
  "304": "30.4rem",
  "308": "30.8rem",
  "312": "31.2rem",
  "316": "31.6rem",
  "320": "32rem",
  "324": "32.4rem",
  "328": "32.8rem",
  "332": "33.2rem",
  "336": "33.6rem",
  "340": "34rem",
  "344": "34.4rem",
  "348": "34.8rem",
  "352": "35.2rem",
  "356": "35.6rem",
  "360": "36rem",
  "364": "36.4rem",
  "368": "36.8rem",
  "372": "37.2rem",
  "376": "37.6rem",
  "380": "38rem"
};
const spacing = {
  "0": "0px",
  "2": ".2rem",
  "4": ".4rem",
  "8": ".8rem",
  "12": "1.2rem",
  "16": "1.6rem",
  "20": "2rem",
  "24": "2.4rem",
  "28": "2.8rem",
  "32": "3.2rem",
  "36": "3.6rem",
  "40": "4rem",
  "48": "4.8rem",
  "56": "5.6rem",
  "64": "6.4rem",
  "80": "8rem",
  "200": "20rem"
};
const fontSize = {
  "none": "0",
  "2xs": "1.1rem",
  "xs": "1.2rem",
  "sm": "1.3rem",
  "md": "1.4rem",
  "lg": "1.5rem",
  "xl": "1.6rem",
  "2xl": "1.8rem",
  "3xl": "2.0rem",
  "4xl": "2.4rem",
  "5xl": "3.2rem",
  "6xl": "4.2rem",
  "7xl": "5rem"
};
const lineHeight = {
  "xs": "1.8rem",
  "sm": "2.0rem",
  "md": "2.2rem",
  "lg": "2.4rem",
  "xl": "2.6rem",
  "2xl": "3.0rem",
  "3xl": "3.4rem",
  "4xl": "4.4rem",
  "5xl": "5.6rem",
  "6xl": "7rem"
};
const fontWeight = {
  regular: "400",
  medium: "500",
  bold: "700"
};
const globalTypographyToken = {
  fontSize,
  lineHeight,
  fontWeight
};
const zIndex = {
  base: "0",
  docked: "10",
  dropdown: "500",
  tooltip: "600",
  sticky: "1000",
  overlay: "2000",
  modal: "2500",
  toast: "3000"
};
const breakpoints = objectKeys(breakpoint);
const stdsGlobalToken = {
  borderRadius,
  borderWidth,
  boxShadow,
  breakpoint,
  color: globalColorToken,
  icon,
  spacing,
  size,
  typography: globalTypographyToken,
  zIndex
};
const lightThemeColorTokenByRole = {
  "brand-primary": "orange500",
  "brand-primary-pressed": "orange700",
  "brand-secondary": "navy500",
  "brand-blue": "blue500",
  "brand-blue-pressed": "blue700",
  "background-variant-1": "gray60",
  "background-variant-2": "white",
  "surface-layer": "white",
  "surface-elevation-1": "white",
  "surface-elevation-2": "gray20",
  "surface-elevation-3": "gray40",
  "surface-gnb": "white",
  "surface-gnb-gray": "gray900",
  "surface-footer": "gray880",
  "surface-highlight": "orange50",
  "surface-fab": "white",
  "surface-fab-pressed": "gray100",
  "surface-variant-1": "white",
  "surface-variant-2": "gray20",
  "inverse-elevation-1": "black/30",
  "inverse-elevation-2": "black/15",
  "inverse-elevation-3": "black/10",
  "inverse-elevation-4": "black/8",
  "inverse-elevation-5": "black/6",
  "inverse-elevation-6": "black/4",
  "inverse-elevation-7": "black/10",
  "inverse-elevation-8": "black/2",
  "inverse-variant-1": "black/30",
  "inverse-variant-2": "black/15",
  "inverse-variant-3": "black/6",
  "interaction-pressed": "black/10",
  "interaction-selected": "black/8",
  "interaction-focused": "black/8",
  "interaction-hover": "black/4",
  "disabled-variant-1": "gray200",
  "disabled-variant-2": "gray150",
  "disabled-variant-3": "gray80",
  "disabled-variant-4": "gray40",
  "disabled-variant-5": "gray200",
  "disabled-variant-6": "gray80",
  "disabled-variant-7": "white/20",
  "disabled-variant-8": "black/8",
  "on-surface-elevation-1": "gray880",
  "on-surface-elevation-1-pressed": "black",
  "on-surface-elevation-2": "gray800",
  "on-surface-elevation-2-pressed": "gray880",
  "on-surface-elevation-3": "gray600",
  "on-surface-elevation-3-pressed": "gray700",
  "on-surface-elevation-4": "gray400",
  "on-surface-elevation-4-pressed": "gray500",
  "neutral-variant-1": "gray700",
  "neutral-variant-1-pressed": "gray800",
  "neutral-variant-2": "gray40",
  "neutral-variant-2-pressed": "gray80",
  "neutral-variant-3": "white",
  "neutral-variant-3-pressed": "gray40",
  "neutral-variant-4": "gray150",
  "border": "gray150",
  "placeholder": "gray300",
  "error": "system-red",
  "warning": "system-yellow",
  "success": "system-green",
  "information": "system-blue"
};
const darkThemeColorTokenByRole = {
  "brand-primary": "orange500",
  "brand-primary-pressed": "orange300",
  "brand-secondary": "navy500",
  "brand-blue": "blue500",
  "brand-blue-pressed": "blue300",
  "background-variant-1": "gray900",
  "background-variant-2": "gray880",
  "surface-layer": "gray780",
  "surface-elevation-1": "gray840",
  "surface-elevation-2": "gray820",
  "surface-elevation-3": "gray800",
  "surface-gnb": "gray900",
  "surface-gnb-gray": "gray900",
  "surface-footer": "black",
  "surface-highlight": "white/10",
  "surface-fab": "gray750",
  "surface-fab-pressed": "gray650",
  "surface-variant-1": "gray860",
  "surface-variant-2": "gray840",
  "inverse-elevation-1": "white/30",
  "inverse-elevation-2": "white/15",
  "inverse-elevation-3": "white/10",
  "inverse-elevation-4": "white/8",
  "inverse-elevation-5": "white/6",
  "inverse-elevation-6": "white/4",
  "inverse-elevation-7": "white/4",
  "inverse-elevation-8": "white/2",
  "inverse-variant-1": "white/15",
  "inverse-variant-2": "white/6",
  "inverse-variant-3": "white/4",
  "interaction-pressed": "white/10",
  "interaction-selected": "white/8",
  "interaction-focused": "white/8",
  "interaction-hover": "white/4",
  "disabled-variant-1": "gray600",
  "disabled-variant-2": "gray600",
  "disabled-variant-3": "gray750",
  "disabled-variant-4": "gray500",
  "disabled-variant-5": "gray200",
  "disabled-variant-6": "gray80",
  "disabled-variant-7": "white/20",
  "disabled-variant-8": "white/10",
  "on-surface-elevation-1": "gray80",
  "on-surface-elevation-1-pressed": "white",
  "on-surface-elevation-2": "gray200",
  "on-surface-elevation-2-pressed": "gray80",
  "on-surface-elevation-3": "gray300",
  "on-surface-elevation-3-pressed": "gray100",
  "on-surface-elevation-4": "gray500",
  "on-surface-elevation-4-pressed": "gray300",
  "neutral-variant-1": "gray600",
  "neutral-variant-1-pressed": "gray400",
  "neutral-variant-2": "gray800",
  "neutral-variant-2-pressed": "gray700",
  "neutral-variant-3": "gray840",
  "neutral-variant-3-pressed": "gray750",
  "neutral-variant-4": "gray650",
  "border": "gray650",
  "placeholder": "gray600",
  "error": "system-red",
  "warning": "system-yellow",
  "success": "system-green",
  "information": "system-blue"
};
const getSemanticColorToken = (args) => {
  const { colorTheme = "light" } = args ?? {};
  return colorTheme === "dark" ? darkThemeColorTokenByRole : lightThemeColorTokenByRole;
};
const typographyRoleNameByRole = {
  title1: "Title 1",
  title2: "Title 2",
  title3: "Title 3",
  title4: "Title 4",
  title5: "Title 5",
  title6: "Title 6",
  title7: "Title 7",
  title8: "Title 8",
  text1: "Text 1",
  text2: "Text 2",
  text3: "Text 3",
  text4: "Text 4",
  btn1: "Button 1",
  btn2: "Button 2",
  btn3: "Button 3",
  cap1: "Caption 1",
  cap2: "Caption 2"
};
const title1 = {
  fontSize: "7xl",
  lineHeight: "6xl",
  fontWeight: "medium"
};
const title2 = {
  fontSize: "6xl",
  lineHeight: "5xl",
  fontWeight: "medium"
};
const title3 = {
  fontSize: "5xl",
  lineHeight: "4xl",
  fontWeight: "medium"
};
const title4 = {
  fontSize: "4xl",
  lineHeight: "3xl",
  fontWeight: "medium"
};
const title5 = {
  fontSize: "3xl",
  lineHeight: "2xl",
  fontWeight: "medium"
};
const title6 = {
  fontSize: "2xl",
  lineHeight: "xl",
  fontWeight: "medium"
};
const title7 = {
  fontSize: "xl",
  lineHeight: "lg",
  fontWeight: "medium"
};
const title8 = {
  fontSize: "md",
  lineHeight: "sm",
  fontWeight: "medium"
};
const text1 = {
  fontSize: "xl",
  lineHeight: "xl"
};
const text2 = {
  fontSize: "lg",
  lineHeight: "lg"
};
const text3 = {
  fontSize: "md",
  lineHeight: "lg"
};
const text4 = {
  fontSize: "sm",
  lineHeight: "md"
};
const btn1 = {
  fontSize: "xl",
  lineHeight: "lg",
  fontWeight: "medium"
};
const btn2 = {
  fontSize: "md",
  lineHeight: "sm",
  fontWeight: "medium"
};
const btn3 = {
  fontSize: "xs",
  lineHeight: "xs",
  fontWeight: "medium"
};
const cap1 = {
  fontSize: "xs",
  lineHeight: "xs",
  fontWeight: "regular"
};
const cap2 = {
  fontSize: "2xs",
  lineHeight: "xs",
  fontWeight: "regular"
};
const semanticTypographyTokenByRole = {
  title1,
  title2,
  title3,
  title4,
  title5,
  title6,
  title7,
  title8,
  text1,
  text2,
  text3,
  text4,
  btn1,
  btn2,
  btn3,
  cap1,
  cap2
};
const stdsSemanticToken = {
  color: getSemanticColorToken,
  typography: semanticTypographyTokenByRole
};
const stds = {
  glob: stdsGlobalToken,
  sem: stdsSemanticToken
};
function parseResponsiveProp(prop) {
  if (isArray$2(prop)) {
    return prop.length > 0 ? _omitBy(
      objectFromEntries([
        ["default", prop[0]],
        ...prop.map(
          (value, index) => [breakpoints[index], value]
        )
      ]),
      isNullish
    ) : {};
  }
  if (isObject$4(prop)) {
    return _omitBy(prop, isNullish);
  }
  if (isString(prop)) {
    return { default: prop };
  }
  return {};
}
function mapResponsiveClasses(prop, mapper) {
  const parsedProp = parseResponsiveProp(prop);
  return objectEntries(parsedProp).map(([key, value]) => {
    if (isUndefined(value)) {
      return;
    }
    return key === "default" ? `${mapper(value)}` : `${key}:${mapper(value)}`;
  });
}
const useBackgroundImageStyle = (backgroundImageProp) => {
  const parsedProp = computed(
    () => parseResponsiveProp(backgroundImageProp == null ? void 0 : backgroundImageProp.value)
  );
  const classes = computed(
    () => objectKeys(parsedProp.value).map(
      (key) => ({
        xs: "xs:bg-[image:var(--xs-image-url)]",
        sm: "sm:bg-[image:var(--sm-image-url)]",
        md: "md:bg-[image:var(--md-image-url)]",
        lg: "lg:bg-[image:var(--lg-image-url)]",
        default: "bg-[image:var(--default-image-url)]"
      })[key]
    )
  );
  const styles = computed(
    () => objectFromEntries(
      objectEntries(parsedProp.value).map(([key, value]) => [
        {
          xs: "--xs-image-url",
          sm: "--sm-image-url",
          md: "--md-image-url",
          lg: "--lg-image-url",
          default: "--default-image-url"
        }[key],
        `url('${value}')`
      ])
    )
  );
  return { classes, styles };
};
const CONTEXT_KEYS = {
  SCheckbox: Symbol("SCheckboxContext"),
  SContentsPopup: Symbol("SContentsPopupContext"),
  SDialog: Symbol("SDialogContext"),
  SDropdown: Symbol("SDropdownContext"),
  SRadio: Symbol("SRadioContext"),
  SSearchField: Symbol("SSearchFieldContext"),
  STabs: Symbol("STabs")
};
const getContextKey = (component) => {
  if (!objectHasOwn(CONTEXT_KEYS, component))
    ;
  return CONTEXT_KEYS[component];
};
const useContext = (parent) => {
  const context = inject(getContextKey(parent), null);
  const currentComponentTagName = getCurrentComponentTagName();
  if (context === null) {
    const err = new Error(
      `<${currentComponentTagName} /> is missing a parent <${parent} /> component.`
    );
    if (Error.captureStackTrace)
      Error.captureStackTrace(err, useContext);
    throw err;
  }
  return context;
};
const useDefaultSlots = () => {
  var _a, _b;
  return ((_b = (_a = useSlots()).default) == null ? void 0 : _b.call(_a)) ?? [];
};
let id = 0;
const useId = (prefix) => [prefix, String(id++)].filter(isString).join("-");
const tailwindClassByStyleProp = {
  borderWidth: "border",
  borderStyle: "border",
  borderColor: "border",
  borderTopWidth: "border-t",
  borderTopStyle: "border-t",
  borderTopColor: "border-t",
  borderRightWidth: "border-r",
  borderRightStyle: "border-r",
  borderRightColor: "border-r",
  borderBottomWidth: "border-b",
  borderBottomStyle: "border-b",
  borderBottomColor: "border-b",
  borderLeftWidth: "border-l",
  borderLeftStyle: "border-l",
  borderLeftColor: "border-l",
  radius: "rounded",
  topRadius: "rounded-t",
  rightRadius: "rounded-r",
  bottomRadius: "rounded-b",
  leftRadius: "rounded-l",
  topLeftRadius: "rounded-tl",
  topRightRadius: "rounded-tr",
  bottomRightRadius: "rounded-br",
  bottomLeftRadius: "rounded-bl",
  margin: "m",
  m: "m",
  marginTop: "mt",
  mt: "mt",
  marginRight: "mr",
  mr: "mr",
  marginBottom: "mb",
  mb: "mb",
  marginLeft: "ml",
  ml: "ml",
  marginX: "mx",
  mx: "mx",
  marginY: "my",
  my: "my",
  padding: "p",
  p: "p",
  paddingTop: "pt",
  pt: "pt",
  paddingRight: "pr",
  pr: "pr",
  paddingBottom: "pb",
  pb: "pb",
  paddingLeft: "pl",
  pl: "pl",
  paddingX: "px",
  px: "px",
  paddingY: "py",
  py: "py",
  width: "w",
  w: "w",
  height: "h",
  h: "h",
  minWidth: "min-w",
  minW: "min-w",
  maxWidth: "max-w",
  maxW: "max-w",
  minHeight: "min-h",
  minH: "min-h",
  maxHeight: "max-h",
  maxH: "max-h",
  backgroundImage: "",
  bgImage: "",
  backgroundSize: "bg",
  bgSize: "bg",
  backgroundPosition: "bg",
  bgPosition: "bg",
  backgroundRepeat: "bg",
  bgRepeat: "bg",
  backgroundAttachment: "bg",
  bgAttachment: "bg",
  fontSize: "text",
  lineHeight: "leading",
  fontWeight: "font",
  color: "text",
  backgroundColor: "bg"
};
const passStyleProps = ["backgroundImage"];
const useStyle = (props) => computed(
  () => objectEntries(props).filter(([key]) => key in tailwindClassByStyleProp).filter(([key]) => !passStyleProps.includes(key)).map(
    ([key, value]) => mapResponsiveClasses(
      value,
      (value2) => value2.startsWith("-") ? `-${tailwindClassByStyleProp[key]}-${value2.slice(1)}` : `${tailwindClassByStyleProp[key]}-${value2}`
    )
  ).flat().filter(isString)
);
const SlimComponent = defineComponent({
  name: "SlimComponent",
  setup() {
    const slots = useDefaultSlots();
    return () => slots[0];
  }
});
const core = {
  CreateSComponent,
  RenderVNode,
  RenderVNodes,
  SlimComponent
};
const BADGE_VARIANTS = {
  fill: "fill",
  outline: "outline"
};
const BADGE_SIZES = {
  sm: "sm",
  md: "md",
  lg: "lg"
};
const BADGE_COLORS = {
  brand: "brand",
  red: "red",
  purple: "purple",
  blue: "blue",
  gray: "gray",
  magenta: "magenta"
};
const _sfc_main$T = defineComponent({
  name: "SBadge",
  props: {
    /**
     * 뱃지 변형
     */
    variant: {
      type: String,
      default: BADGE_VARIANTS.fill,
      validator: (value) => objectKeys(BADGE_VARIANTS).includes(value)
    },
    /**
     * 뱃지 사이즈
     */
    size: {
      type: String,
      default: BADGE_SIZES.md,
      validator: (value) => objectKeys(BADGE_SIZES).includes(value)
    },
    /**
     * 뱃지 색상
     */
    colorScheme: {
      type: String,
      default: BADGE_COLORS.brand,
      validator: (value) => objectKeys(BADGE_COLORS).includes(value)
    }
  },
  setup(props) {
    const colorClassesByVariantByColor = {
      brand: {
        outline: "text-brand-primary border-brand-primary",
        fill: "bg-brand-primary"
      },
      red: {
        outline: "text-tint-red-a400 border-tint-red-a400",
        fill: "bg-tint-red-a400"
      },
      purple: {
        outline: "text-tint-purple-a400 border-tint-purple-a400",
        fill: "bg-tint-purple-a400"
      },
      blue: {
        outline: "text-tint-blue-a400 border-tint-blue-a400",
        fill: "bg-tint-blue-a400"
      },
      gray: {
        outline: "text-on-surface-elevation-2 border-on-surface-elevation-2",
        fill: "bg-neutral-variant-1"
      },
      magenta: {
        outline: "text-tint-magenta-a400 border-tint-magenta-a400",
        fill: "bg-tint-magenta-a400"
      }
    };
    const variantClasses = {
      fill: "border-0 focus-within:border-1 border-transparent text-white",
      outline: "border bg-transparent"
    };
    const sizeClasses = {
      sm: "h-20 px-4 text-xs leading-sm",
      md: "h-24 px-8 text-md leading-lg",
      lg: "h-28 px-8 text-md leading-lg"
    };
    return {
      classes: computed(() => [
        "stds-badge",
        colorClassesByVariantByColor[props.colorScheme][props.variant],
        variantClasses[props.variant],
        sizeClasses[props.size]
      ])
    };
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
function _sfc_render$T(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: normalizeClass(_ctx.classes)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
const SBadge = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["render", _sfc_render$T]]);
const stylePropOptions = {
  type: [String, Array, Object],
  required: false
};
const styleProps = {
  borderWidth: stylePropOptions,
  borderStyle: stylePropOptions,
  borderColor: stylePropOptions,
  borderTopWidth: stylePropOptions,
  borderTopStyle: stylePropOptions,
  borderTopColor: stylePropOptions,
  borderRightWidth: stylePropOptions,
  borderRightStyle: stylePropOptions,
  borderRightColor: stylePropOptions,
  borderBottomWidth: stylePropOptions,
  borderBottomStyle: stylePropOptions,
  borderBottomColor: stylePropOptions,
  borderLeftWidth: stylePropOptions,
  borderLeftStyle: stylePropOptions,
  borderLeftColor: stylePropOptions,
  radius: stylePropOptions,
  topRadius: stylePropOptions,
  rightRadius: stylePropOptions,
  bottomRadius: stylePropOptions,
  leftRadius: stylePropOptions,
  topLeftRadius: stylePropOptions,
  topRightRadius: stylePropOptions,
  bottomRightRadius: stylePropOptions,
  bottomLeftRadius: stylePropOptions,
  margin: stylePropOptions,
  m: stylePropOptions,
  marginTop: stylePropOptions,
  mt: stylePropOptions,
  marginRight: stylePropOptions,
  mr: stylePropOptions,
  marginBottom: stylePropOptions,
  mb: stylePropOptions,
  marginLeft: stylePropOptions,
  ml: stylePropOptions,
  marginX: stylePropOptions,
  mx: stylePropOptions,
  marginY: stylePropOptions,
  my: stylePropOptions,
  padding: stylePropOptions,
  p: stylePropOptions,
  paddingTop: stylePropOptions,
  pt: stylePropOptions,
  paddingRight: stylePropOptions,
  pr: stylePropOptions,
  paddingBottom: stylePropOptions,
  pb: stylePropOptions,
  paddingLeft: stylePropOptions,
  pl: stylePropOptions,
  paddingX: stylePropOptions,
  px: stylePropOptions,
  paddingY: stylePropOptions,
  py: stylePropOptions,
  width: stylePropOptions,
  w: stylePropOptions,
  height: stylePropOptions,
  h: stylePropOptions,
  minWidth: stylePropOptions,
  minW: stylePropOptions,
  maxWidth: stylePropOptions,
  maxW: stylePropOptions,
  minHeight: stylePropOptions,
  minH: stylePropOptions,
  maxHeight: stylePropOptions,
  maxH: stylePropOptions,
  backgroundImage: stylePropOptions,
  bgImage: stylePropOptions,
  backgroundSize: stylePropOptions,
  bgSize: stylePropOptions,
  backgroundPosition: stylePropOptions,
  bgPosition: stylePropOptions,
  backgroundRepeat: stylePropOptions,
  bgRepeat: stylePropOptions,
  backgroundAttachment: stylePropOptions,
  bgAttachment: stylePropOptions,
  fontSize: stylePropOptions,
  lineHeight: stylePropOptions,
  fontWeight: stylePropOptions,
  color: stylePropOptions,
  backgroundColor: stylePropOptions
};
const _sfc_main$S = defineComponent({
  name: "SBox",
  props: {
    /**
     * 렌더링할 HTML 태그 또는 컴포넌트
     */
    as: {
      type: [String, Object],
      default: "div"
    },
    ...styleProps
  },
  setup(props) {
    const classes = useStyle(props);
    const { classes: backgroundImageClasses, styles: backgroundImageStyles } = useBackgroundImageStyle(toRef(props, "backgroundImage"));
    const boxClasses = computed(() => [
      "stds-box",
      ...classes.value,
      ...backgroundImageClasses.value
    ]);
    return {
      boxClasses,
      backgroundImageStyles
    };
  }
});
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), {
    style: normalizeStyle(_ctx.backgroundImageStyles),
    class: normalizeClass(_ctx.boxClasses)
  }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["style", "class"]);
}
const SBox = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["render", _sfc_render$S]]);
const BUTTON_VARIANTS = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  outline: "outline",
  white: "white",
  ghost: "ghost",
  blue: "blue",
  red: "red"
};
const BUTTON_SIZES = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg"
};
const SVG_ICON_COMPONENTS = {
  "ic-v2-logo-window-color": defineAsyncComponent(() => import("./ic-v2-logo-window-color-Bm_mALwk.mjs").then((i) => i.default)),
  "ic-v2-logo-apple-color": defineAsyncComponent(() => import("./ic-v2-logo-apple-color-BYAA-Rwi.mjs").then((i) => i.default)),
  "ic-v2-logo-facebook-color": defineAsyncComponent(() => import("./ic-v2-logo-facebook-color-BRqOHCPx.mjs").then((i) => i.default)),
  "ic-v2-logo-twitter-color": defineAsyncComponent(() => import("./ic-v2-logo-twitter-color-CM2_zqoe.mjs").then((i) => i.default)),
  "ic-v2-logo-google-playstore-color": defineAsyncComponent(() => import("./ic-v2-logo-google-playstore-color-oZvPoHh8.mjs").then((i) => i.default)),
  "ic-v2-logo-google-color": defineAsyncComponent(() => import("./ic-v2-logo-google-color-CqjHWAm4.mjs").then((i) => i.default)),
  "ic-v2-logo-instagram-color": defineAsyncComponent(() => import("./ic-v2-logo-instagram-color-BB1Ov3Qt.mjs").then((i) => i.default)),
  "ic-v2-logo-youtube-color": defineAsyncComponent(() => import("./ic-v2-logo-youtube-color-_zTLx7ze.mjs").then((i) => i.default)),
  "ic-v2-logo-kakaotalk-color": defineAsyncComponent(() => import("./ic-v2-logo-kakaotalk-color--KLp5ajx.mjs").then((i) => i.default)),
  "ic-v2-logo-naver-color": defineAsyncComponent(() => import("./ic-v2-logo-naver-color-DFk1Vxvq.mjs").then((i) => i.default)),
  "ic-v2-logo-discord-color": defineAsyncComponent(() => import("./ic-v2-logo-discord-color-Ca5xoAPf.mjs").then((i) => i.default)),
  "ic-v2-logo-onestore-color": defineAsyncComponent(() => import("./ic-v2-logo-onestore-color-CsN2dSPO.mjs").then((i) => i.default)),
  "ic-v2-logo-toss-color": defineAsyncComponent(() => import("./ic-v2-logo-toss-color-Csngeo18.mjs").then((i) => i.default)),
  "ic-v2-logo-galaxystore-color": defineAsyncComponent(() => import("./ic-v2-logo-galaxystore-color-DCVx0EYn.mjs").then((i) => i.default)),
  "ic-v2-logo-amazonstore-color": defineAsyncComponent(() => import("./ic-v2-logo-amazonstore-color-DeseZPQe.mjs").then((i) => i.default)),
  "ic-v2-logo-huaweiappgallery-color": defineAsyncComponent(() => import("./ic-v2-logo-huaweiappgallery-color-bMBNVakP.mjs").then((i) => i.default)),
  "ic-v2-badge-update-round-color": defineAsyncComponent(() => import("./ic-v2-badge-update-round-color-J-Uel5ry.mjs").then((i) => i.default)),
  "ic-v2-badge-update-text-color": defineAsyncComponent(() => import("./ic-v2-badge-update-text-color-AcF6HIWs.mjs").then((i) => i.default)),
  "ic-v2-badge-new-round-color": defineAsyncComponent(() => import("./ic-v2-badge-new-round-color-BLt6Vgp3.mjs").then((i) => i.default)),
  "ic-v2-badge-ownd-round-color": defineAsyncComponent(() => import("./ic-v2-badge-ownd-round-color-DVWpZiPS.mjs").then((i) => i.default)),
  "ic-v2-badge-early-round-color": defineAsyncComponent(() => import("./ic-v2-badge-early-round-color-B5cSESH0.mjs").then((i) => i.default)),
  "ic-v2-stove-symbol-color": defineAsyncComponent(() => import("./ic-v2-stove-symbol-color-C5aQ34GH.mjs").then((i) => i.default)),
  "ic-v2-stove-wordtype-color": defineAsyncComponent(() => import("./ic-v2-stove-wordtype-color-DR16N0Zw.mjs").then((i) => i.default)),
  "ic-v2-stove-cash-color": defineAsyncComponent(() => import("./ic-v2-stove-cash-color-BbKIn7fB.mjs").then((i) => i.default)),
  "ic-v2-stove-point-color": defineAsyncComponent(() => import("./ic-v2-stove-point-color-C3DJEMmn.mjs").then((i) => i.default)),
  "ic-v2-stove-flake-color": defineAsyncComponent(() => import("./ic-v2-stove-flake-color-B1BrMl_e.mjs").then((i) => i.default)),
  "ic-v2-stove-ppool-wordtype-color": defineAsyncComponent(() => import("./ic-v2-stove-ppool-wordtype-color-BjkOiFHz.mjs").then((i) => i.default)),
  "ic-v2-stove-ppool-pp-color": defineAsyncComponent(() => import("./ic-v2-stove-ppool-pp-color-Beq9oWNe.mjs").then((i) => i.default)),
  "ic-v2-stove-ppool-app-color": defineAsyncComponent(() => import("./ic-v2-stove-ppool-app-color-FfAfnM_M.mjs").then((i) => i.default))
};
const _sfc_main$R = defineComponent({
  name: "SIcon",
  components: {
    ...SVG_ICON_COMPONENTS
  },
  props: {
    /**
     * Icon 이름
     */
    icon: {
      type: String,
      default: ALL_ICONS[0],
      validator: (value) => arrayIncludes$1(ALL_ICONS, value)
    },
    /**
     * Icon 사이즈
     */
    size: {
      type: String,
      default: "xl"
    },
    /**
     * 스크린 리더 텍스트
     */
    srOnlyText: {
      type: String,
      default: void 0
    }
  },
  emits: ["click"],
  setup(props) {
    const sizeByToken = {
      "auto": null,
      "xs": 12,
      "sm": 13,
      "md": 14,
      "lg": 15,
      "xl": 16,
      "2xl": 18,
      "3xl": 20,
      "4xl": 24,
      "5xl": 32,
      "6xl": 42,
      "7xl": 50
    };
    const fontSizeClassByToken = {
      "auto": "",
      "xs": "h-12 w-12 text-xs",
      "sm": "h-[1.3rem] w-[1.3rem] text-sm",
      "md": "h-[1.4rem] w-[1.4rem] text-md",
      "lg": "h-[1.5rem] w-[1.5rem] text-lg",
      "xl": "h-16 w-16 text-xl",
      "2xl": "h-[1.8rem] w-[1.8rem] text-2xl",
      "3xl": "h-20 w-20 text-3xl",
      "4xl": "h-24 w-24 text-4xl",
      "5xl": "h-32 w-32 text-5xl",
      "6xl": "h-[4.2rem] w-[4.2rem] text-6xl",
      "7xl": "h-[5rem] w-[5rem] text-7xl"
    };
    return {
      svgIconSize: computed(() => sizeByToken[props.size]),
      fontIconClasses: computed(() => [
        "stove-ui-icon",
        fontSizeClassByToken[props.size],
        `before:${props.icon}`
      ]),
      isSvgIcon: computed(() => arrayIncludes$1(COLOR_ICONS, props.icon))
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
});
const _hoisted_1$s = {
  key: 0,
  class: "sr-only"
};
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.isSvgIcon ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.icon), {
    key: 0,
    role: "presentation",
    width: _ctx.svgIconSize,
    height: _ctx.svgIconSize,
    "aria-labelledby": _ctx.icon,
    onClick: _ctx.onClick
  }, null, 8, ["width", "height", "aria-labelledby", "onClick"])) : (openBlock(), createElementBlock("i", {
    key: 1,
    class: normalizeClass(_ctx.fontIconClasses),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    _ctx.srOnlyText ? (openBlock(), createElementBlock("span", _hoisted_1$s, toDisplayString(_ctx.srOnlyText), 1)) : createCommentVNode("", true)
  ], 2));
}
const SIcon = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["render", _sfc_render$R]]);
const ICON_SIZES = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl",
  "3xl",
  "4xl",
  "5xl",
  "6xl",
  "7xl"
];
const _sfc_main$Q = defineComponent({
  name: "SButton",
  components: {
    SIcon
  },
  props: {
    /**
     * Button 타입
     */
    variant: {
      type: String,
      default: BUTTON_VARIANTS.primary,
      validator: (value) => objectKeys(BUTTON_VARIANTS).includes(value)
    },
    /**
     * Button 좌측 아이콘
     */
    icon: {
      type: String,
      default: void 0,
      validator: (value) => arrayIncludes$1(ALL_ICONS, value)
    },
    /**
     * Button 좌측 아이콘 class
     */
    iconClass: {
      type: String,
      default: null
    },
    /**
     * Button 크기
     */
    size: {
      type: String,
      default: "md",
      validator: (value) => objectKeys(BUTTON_SIZES).includes(value)
    },
    /**
     * Button 활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Button 우측 화살표 아이콘 여부
     */
    hasArrow: {
      type: Boolean,
      default: false
    }
  },
  /**
   * To avoid triggering the click event twice when using @click for SButton.
   * @see https://v3-migration.vuejs.org/breaking-changes/emits-option.html#migration-strategy
   */
  emits: ["click"],
  setup(props, { slots }) {
    const isIconOnly = computed(
      () => !isNullish(props.icon) && isUndefined(slots.default)
    );
    const SOLID_BUTTON_VARIANTS = [
      BUTTON_VARIANTS.primary,
      BUTTON_VARIANTS.secondary,
      BUTTON_VARIANTS.tertiary,
      BUTTON_VARIANTS.white,
      BUTTON_VARIANTS.blue,
      BUTTON_VARIANTS.red
    ];
    const isSolid = computed(
      () => arrayIncludes$1(SOLID_BUTTON_VARIANTS, props.variant)
    );
    const variantClasses = {
      primary: "stds-button-primary",
      secondary: "stds-button-secondary",
      tertiary: "stds-button-tertiary",
      outline: "stds-button-outline",
      white: "stds-button-white",
      ghost: "stds-button-ghost",
      blue: "stds-button-blue",
      red: "stds-button-red"
    };
    return {
      isIconOnly,
      buttonClasses: computed(() => ({
        xs: [
          "stds-button",
          variantClasses[props.variant],
          "rounded-md",
          "min-w-24",
          isIconOnly.value ? "p-0 min-h-24" : "px-8",
          !isIconOnly.value && (isSolid.value ? "min-h-22" : "min-h-[2.4rem]")
        ].filter(isString),
        sm: [
          "stds-button",
          variantClasses[props.variant],
          "rounded-lg",
          "min-w-32",
          isIconOnly.value ? "p-0 min-h-32" : "px-12",
          !isIconOnly.value && (isSolid.value ? "min-h-30" : "min-h-[3.2rem]")
        ].filter(isString),
        md: [
          "stds-button",
          variantClasses[props.variant],
          "rounded-lg",
          "min-w-44",
          isIconOnly.value ? "p-0 min-h-44" : "px-20",
          !isIconOnly.value && (isSolid.value ? "min-h-42" : "min-h-[4.4rem]")
        ].filter(isString),
        lg: [
          "stds-button",
          variantClasses[props.variant],
          "rounded-lg",
          "min-w-56",
          isIconOnly.value ? "p-0 min-h-56" : "px-24",
          !isIconOnly.value && (isSolid.value ? "min-h-54" : "min-h-[5.6rem]")
        ].filter(isString)
      })),
      iconClassesBySize: computed(
        () => isIconOnly.value ? {} : {
          xs: "mr-4",
          sm: "mr-4",
          md: "mr-8",
          lg: "mr-8"
        }
      ),
      iconSizes: computed(
        () => isIconOnly.value ? {
          xs: "xl",
          sm: "xl",
          md: "3xl",
          lg: "4xl"
        } : {
          xs: "xl",
          sm: "xl",
          md: "3xl",
          lg: "3xl"
        }
      ),
      textClasses: computed(() => ({
        xs: "py-[0.1rem] text-btn3 leading-btn3",
        sm: "py-[0.5rem] text-btn3 leading-btn3",
        md: "py-[1.0rem] text-btn2 leading-btn2",
        lg: "py-[1.4rem] text-btn1 leading-btn1"
      })),
      arrowIconClasses: computed(() => ({
        xs: "ml-2 -mr-4",
        sm: "ml-2 -mr-4",
        md: "ml-4 -mr-8",
        lg: "ml-4 -mr-8"
      })),
      arrowIconSizes: computed(() => ({
        xs: "xl",
        sm: "xl",
        md: "3xl",
        lg: "3xl"
      }))
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
});
const _hoisted_1$r = ["disabled"];
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("button", {
    type: "button",
    class: normalizeClass(_ctx.buttonClasses[_ctx.size]),
    disabled: _ctx.isDisabled,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    _ctx.icon ? (openBlock(), createBlock(_component_SIcon, {
      key: 0,
      icon: _ctx.icon,
      size: _ctx.iconSizes[_ctx.size],
      class: normalizeClass([_ctx.iconClassesBySize[_ctx.size], _ctx.iconClass])
    }, null, 8, ["icon", "size", "class"])) : createCommentVNode("", true),
    createElementVNode("span", {
      class: normalizeClass(_ctx.textClasses[_ctx.size])
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2),
    _ctx.hasArrow ? (openBlock(), createBlock(_component_SIcon, {
      key: 1,
      icon: "ic-v2-control-arrow-right-line",
      size: _ctx.arrowIconSizes[_ctx.size],
      class: normalizeClass(_ctx.arrowIconClasses[_ctx.size])
    }, null, 8, ["size", "class"])) : createCommentVNode("", true)
  ], 10, _hoisted_1$r);
}
const SButton = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["render", _sfc_render$Q]]);
function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose(fn);
    return true;
  }
  return false;
}
const localProvidedStateMap = /* @__PURE__ */ new WeakMap();
const provideLocal = (key, value) => {
  var _a;
  const instance = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy;
  if (instance == null)
    throw new Error("provideLocal must be called in setup");
  if (!localProvidedStateMap.has(instance))
    localProvidedStateMap.set(instance, /* @__PURE__ */ Object.create(null));
  const localProvidedState = localProvidedStateMap.get(instance);
  localProvidedState[key] = value;
  provide(key, value);
};
const injectLocal = (...args) => {
  var _a;
  const key = args[0];
  const instance = (_a = getCurrentInstance()) == null ? void 0 : _a.proxy;
  if (instance == null)
    throw new Error("injectLocal must be called in setup");
  if (localProvidedStateMap.has(instance) && key in localProvidedStateMap.get(instance))
    return localProvidedStateMap.get(instance)[key];
  return inject(...args);
};
function createInjectionState(composable, options) {
  const key = (options == null ? void 0 : options.injectionKey) || Symbol(composable.name || "InjectionState");
  const useProvidingState = (...args) => {
    const state = composable(...args);
    provideLocal(key, state);
    return state;
  };
  const useInjectedState = () => injectLocal(key);
  return [useProvidingState, useInjectedState];
}
function toValue(r) {
  return typeof r === "function" ? r() : unref(r);
}
const isClient = typeof window !== "undefined" && typeof document !== "undefined";
typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const isDef = (val) => typeof val !== "undefined";
const toString = Object.prototype.toString;
const isObject = (val) => toString.call(val) === "[object Object]";
const noop = () => {
};
const isIOS = /* @__PURE__ */ getIsIOS();
function getIsIOS() {
  var _a, _b;
  return isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function increaseWithUnit(target, delta) {
  var _a;
  if (typeof target === "number")
    return target + delta;
  const value = ((_a = target.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : _a[0]) || "";
  const unit = target.slice(value.length);
  const result = Number.parseFloat(value) + delta;
  if (Number.isNaN(result))
    return target;
  return result + unit;
}
function unrefElement(elRef) {
  var _a;
  const plain = toValue(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
const defaultWindow = isClient ? window : void 0;
function useEventListener(...args) {
  let target;
  let events;
  let listeners;
  let options;
  if (typeof args[0] === "string" || Array.isArray(args[0])) {
    [events, listeners, options] = args;
    target = defaultWindow;
  } else {
    [target, events, listeners, options] = args;
  }
  if (!target)
    return noop;
  if (!Array.isArray(events))
    events = [events];
  if (!Array.isArray(listeners))
    listeners = [listeners];
  const cleanups = [];
  const cleanup = () => {
    cleanups.forEach((fn) => fn());
    cleanups.length = 0;
  };
  const register = (el, event, listener, options2) => {
    el.addEventListener(event, listener, options2);
    return () => el.removeEventListener(event, listener, options2);
  };
  const stopWatch = watch(
    () => [unrefElement(target), toValue(options)],
    ([el, options2]) => {
      cleanup();
      if (!el)
        return;
      const optionsClone = isObject(options2) ? { ...options2 } : options2;
      cleanups.push(
        ...events.flatMap((event) => {
          return listeners.map((listener) => register(el, event, listener, optionsClone));
        })
      );
    },
    { immediate: true, flush: "post" }
  );
  const stop = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(stop);
  return stop;
}
let _iOSWorkaround = false;
function onClickOutside(target, handler, options = {}) {
  const { window: window2 = defaultWindow, ignore = [], capture = true, detectIframe = false } = options;
  if (!window2)
    return noop;
  if (isIOS && !_iOSWorkaround) {
    _iOSWorkaround = true;
    Array.from(window2.document.body.children).forEach((el) => el.addEventListener("click", noop));
    window2.document.documentElement.addEventListener("click", noop);
  }
  let shouldListen = true;
  const shouldIgnore = (event) => {
    return ignore.some((target2) => {
      if (typeof target2 === "string") {
        return Array.from(window2.document.querySelectorAll(target2)).some((el) => el === event.target || event.composedPath().includes(el));
      } else {
        const el = unrefElement(target2);
        return el && (event.target === el || event.composedPath().includes(el));
      }
    });
  };
  const listener = (event) => {
    const el = unrefElement(target);
    if (!el || el === event.target || event.composedPath().includes(el))
      return;
    if (event.detail === 0)
      shouldListen = !shouldIgnore(event);
    if (!shouldListen) {
      shouldListen = true;
      return;
    }
    handler(event);
  };
  const cleanup = [
    useEventListener(window2, "click", listener, { passive: true, capture }),
    useEventListener(window2, "pointerdown", (e) => {
      const el = unrefElement(target);
      shouldListen = !shouldIgnore(e) && !!(el && !e.composedPath().includes(el));
    }, { passive: true }),
    detectIframe && useEventListener(window2, "blur", (event) => {
      setTimeout(() => {
        var _a;
        const el = unrefElement(target);
        if (((_a = window2.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window2.document.activeElement)))
          handler(event);
      }, 0);
    })
  ].filter(Boolean);
  const stop = () => cleanup.forEach((fn) => fn());
  return stop;
}
function useMounted() {
  const isMounted = ref(false);
  const instance = getCurrentInstance();
  if (instance) {
    onMounted(() => {
      isMounted.value = true;
    }, isVue2 ? null : instance);
  }
  return isMounted;
}
function useSupported(callback) {
  const isMounted = useMounted();
  return computed(() => {
    isMounted.value;
    return Boolean(callback());
  });
}
function useMediaQuery(query, options = {}) {
  const { window: window2 = defaultWindow } = options;
  const isSupported = useSupported(() => window2 && "matchMedia" in window2 && typeof window2.matchMedia === "function");
  let mediaQuery;
  const matches = ref(false);
  const handler = (event) => {
    matches.value = event.matches;
  };
  const cleanup = () => {
    if (!mediaQuery)
      return;
    if ("removeEventListener" in mediaQuery)
      mediaQuery.removeEventListener("change", handler);
    else
      mediaQuery.removeListener(handler);
  };
  const stopWatch = watchEffect(() => {
    if (!isSupported.value)
      return;
    cleanup();
    mediaQuery = window2.matchMedia(toValue(query));
    if ("addEventListener" in mediaQuery)
      mediaQuery.addEventListener("change", handler);
    else
      mediaQuery.addListener(handler);
    matches.value = mediaQuery.matches;
  });
  tryOnScopeDispose(() => {
    stopWatch();
    cleanup();
    mediaQuery = void 0;
  });
  return matches;
}
function useBreakpoints(breakpoints2, options = {}) {
  function getValue2(k, delta) {
    let v = toValue(breakpoints2[toValue(k)]);
    if (delta != null)
      v = increaseWithUnit(v, delta);
    if (typeof v === "number")
      v = `${v}px`;
    return v;
  }
  const { window: window2 = defaultWindow, strategy = "min-width" } = options;
  function match(query) {
    if (!window2)
      return false;
    return window2.matchMedia(query).matches;
  }
  const greaterOrEqual = (k) => {
    return useMediaQuery(() => `(min-width: ${getValue2(k)})`, options);
  };
  const smallerOrEqual = (k) => {
    return useMediaQuery(() => `(max-width: ${getValue2(k)})`, options);
  };
  const shortcutMethods = Object.keys(breakpoints2).reduce((shortcuts, k) => {
    Object.defineProperty(shortcuts, k, {
      get: () => strategy === "min-width" ? greaterOrEqual(k) : smallerOrEqual(k),
      enumerable: true,
      configurable: true
    });
    return shortcuts;
  }, {});
  function current() {
    const points = Object.keys(breakpoints2).map((i) => [i, greaterOrEqual(i)]);
    return computed(() => points.filter(([, v]) => v.value).map(([k]) => k));
  }
  return Object.assign(shortcutMethods, {
    greaterOrEqual,
    smallerOrEqual,
    greater(k) {
      return useMediaQuery(() => `(min-width: ${getValue2(k, 0.1)})`, options);
    },
    smaller(k) {
      return useMediaQuery(() => `(max-width: ${getValue2(k, -0.1)})`, options);
    },
    between(a, b) {
      return useMediaQuery(() => `(min-width: ${getValue2(a)}) and (max-width: ${getValue2(b, -0.1)})`, options);
    },
    isGreater(k) {
      return match(`(min-width: ${getValue2(k, 0.1)})`);
    },
    isGreaterOrEqual(k) {
      return match(`(min-width: ${getValue2(k)})`);
    },
    isSmaller(k) {
      return match(`(max-width: ${getValue2(k, -0.1)})`);
    },
    isSmallerOrEqual(k) {
      return match(`(max-width: ${getValue2(k)})`);
    },
    isInBetween(a, b) {
      return match(`(min-width: ${getValue2(a)}) and (max-width: ${getValue2(b, -0.1)})`);
    },
    current,
    active() {
      const bps = current();
      return computed(() => bps.value.length === 0 ? "" : bps.value.at(-1));
    }
  });
}
function cloneFnJSON(source) {
  return JSON.parse(JSON.stringify(source));
}
function useVModel(props, key, emit, options = {}) {
  var _a, _b, _c, _d, _e;
  const {
    clone = false,
    passive = false,
    eventName,
    deep = false,
    defaultValue,
    shouldEmit
  } = options;
  const vm = getCurrentInstance();
  const _emit = emit || (vm == null ? void 0 : vm.emit) || ((_a = vm == null ? void 0 : vm.$emit) == null ? void 0 : _a.bind(vm)) || ((_c = (_b = vm == null ? void 0 : vm.proxy) == null ? void 0 : _b.$emit) == null ? void 0 : _c.bind(vm == null ? void 0 : vm.proxy));
  let event = eventName;
  if (!key) {
    if (isVue2) {
      const modelOptions = (_e = (_d = vm == null ? void 0 : vm.proxy) == null ? void 0 : _d.$options) == null ? void 0 : _e.model;
      key = (modelOptions == null ? void 0 : modelOptions.value) || "value";
      if (!eventName)
        event = (modelOptions == null ? void 0 : modelOptions.event) || "input";
    } else {
      key = "modelValue";
    }
  }
  event = event || `update:${key.toString()}`;
  const cloneFn = (val) => !clone ? val : typeof clone === "function" ? clone(val) : cloneFnJSON(val);
  const getValue2 = () => isDef(props[key]) ? cloneFn(props[key]) : defaultValue;
  const triggerEmit = (value) => {
    if (shouldEmit) {
      if (shouldEmit(value))
        _emit(event, value);
    } else {
      _emit(event, value);
    }
  };
  if (passive) {
    const initialValue = getValue2();
    const proxy = ref(initialValue);
    let isUpdating = false;
    watch(
      () => props[key],
      (v) => {
        if (!isUpdating) {
          isUpdating = true;
          proxy.value = cloneFn(v);
          nextTick(() => isUpdating = false);
        }
      }
    );
    watch(
      proxy,
      (v) => {
        if (!isUpdating && (v !== props[key] || deep))
          triggerEmit(v);
      },
      { deep }
    );
    return proxy;
  } else {
    return computed({
      get() {
        return getValue2();
      },
      set(value) {
        triggerEmit(value);
      }
    });
  }
}
function useWindowScroll(options = {}) {
  const { window: window2 = defaultWindow, behavior = "auto" } = options;
  if (!window2) {
    return {
      x: ref(0),
      y: ref(0)
    };
  }
  const internalX = ref(window2.scrollX);
  const internalY = ref(window2.scrollY);
  const x = computed({
    get() {
      return internalX.value;
    },
    set(x2) {
      scrollTo({ left: x2, behavior });
    }
  });
  const y = computed({
    get() {
      return internalY.value;
    },
    set(y2) {
      scrollTo({ top: y2, behavior });
    }
  });
  useEventListener(
    window2,
    "scroll",
    () => {
      internalX.value = window2.scrollX;
      internalY.value = window2.scrollY;
    },
    {
      capture: false,
      passive: true
    }
  );
  return { x, y };
}
const CHECKBOX_SIZES = {
  sm: "sm",
  md: "md",
  lg: "lg"
};
const CHECKBOX_ALIGNS = {
  top: "top",
  middle: "middle"
};
const [useProvideCheckboxContext, useCheckboxContext] = createInjectionState(
  (context) => context,
  { injectionKey: CONTEXT_KEYS.SCheckbox }
);
const useCheckboxContextWithDefaultValue = () => {
  return useCheckboxContext() ?? {
    hasCheckboxGroup: false,
    name: "",
    modelValue: [],
    size: CHECKBOX_SIZES.md,
    isDisabled: false,
    onChange: noop
  };
};
const _sfc_main$P = defineComponent({
  name: "SCheckbox",
  /**
   * @see https://v3-migration.vuejs.org/breaking-changes/v-model.html
   */
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Checkbox Id
     */
    id: {
      type: String,
      default: void 0
    },
    /**
     * Checkbox 이름
     */
    name: {
      type: String,
      default: void 0
    },
    /**
     * Checkbox 값
     */
    value: {
      type: [String, Boolean, Number],
      default: false
    },
    /**
     * Checkbox 사이즈
     */
    size: {
      type: String,
      default: CHECKBOX_SIZES.md,
      validator: (value) => objectKeys(CHECKBOX_SIZES).includes(value)
    },
    /**
     * Checkbox 텍스트 정렬
     */
    align: {
      type: String,
      default: CHECKBOX_ALIGNS.middle,
      validator: (value) => objectKeys(CHECKBOX_ALIGNS).includes(value)
    },
    /**
     * Checkbox 체크 여부
     */
    modelValue: {
      type: Boolean,
      default: false
    },
    /**
     * Checkbox 비활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { slots }) {
    const rootContext = useCheckboxContextWithDefaultValue();
    const id2 = computed(() => props.id ?? useId(rootContext.name));
    const context = reactive({
      id: id2,
      name: computed(() => props.name ?? id2.value),
      modelValue: computed(
        () => rootContext.hasCheckboxGroup ? rootContext.modelValue.includes(props.value) : props.modelValue
      ),
      size: computed(() => props.size ?? rootContext.size),
      isDisabled: computed(() => props.isDisabled || rootContext.isDisabled),
      hasText: computed(() => !isUndefined(slots.default))
    });
    return {
      rootContext,
      context,
      checkboxContainerClasses: computed(() => ({
        "stds-checkbox-container": true,
        "items-start": props.align === CHECKBOX_ALIGNS.top,
        "items-center": props.align === CHECKBOX_ALIGNS.middle,
        "min-h-16 min-w-16": context.size === CHECKBOX_SIZES.sm,
        "min-h-20 min-w-20": context.size === CHECKBOX_SIZES.md,
        "min-h-24 min-w-24": context.size === CHECKBOX_SIZES.lg
      })),
      checkboxClasses: computed(() => ({
        "stds-checkbox peer": true,
        "h-16 w-16 after:text-xs focus-visible:border-1": context.size === CHECKBOX_SIZES.sm,
        "h-20 w-20 after:text-xl focus-visible:border-2": context.size === CHECKBOX_SIZES.md,
        "h-24 w-24 after:text-3xl focus-visible:border-2": context.size === CHECKBOX_SIZES.lg
      })),
      labelClasses: computed(() => ({
        "stds-checkbox-label": context.hasText,
        "stds-checkbox-label-sr-only": !context.hasText,
        "text-text3": context.hasText && (context.size === CHECKBOX_SIZES.sm || context.size === CHECKBOX_SIZES.md),
        "text-text1": context.hasText && context.size === CHECKBOX_SIZES.lg
      }))
    };
  },
  methods: {
    onChange(event) {
      if (isHTMLElement(event.target, HTMLInputElement)) {
        this.$emit("update:modelValue", !this.context.modelValue, event);
        this.rootContext.onChange(!this.context.modelValue, this.value);
      }
    }
  }
});
const _hoisted_1$q = ["id", "name", "value", "checked", "disabled"];
const _hoisted_2$e = ["for"];
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createElementVNode("div", {
      class: normalizeClass(_ctx.checkboxContainerClasses)
    }, [
      createElementVNode("input", {
        id: _ctx.context.id,
        name: _ctx.context.name,
        class: normalizeClass(_ctx.checkboxClasses),
        type: "checkbox",
        value: String(_ctx.value),
        checked: _ctx.context.modelValue,
        disabled: _ctx.context.isDisabled,
        onChange: _cache[0] || (_cache[0] = (...args) => _ctx.onChange && _ctx.onChange(...args))
      }, null, 42, _hoisted_1$q),
      createElementVNode("label", {
        class: normalizeClass(_ctx.labelClasses),
        for: _ctx.context.id
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_2$e)
    ], 2)
  ]);
}
const SCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["render", _sfc_render$P]]);
const _sfc_main$O = defineComponent({
  name: "SCheckboxGroup",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Checkbox 이름
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Checkbox 값
     */
    modelValue: {
      type: Array,
      default: void 0
    },
    /**
     * Checkbox 초기값
     */
    defaultValue: {
      type: Array,
      default: () => []
    },
    /**
     * Checkbox 사이즈
     */
    size: {
      type: String,
      default: CHECKBOX_SIZES.md,
      validator: (value) => objectKeys(CHECKBOX_SIZES).includes(value)
    },
    /**
     * Checkbox 비활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const onChange = (isChecked, value) => {
      modelValue.value = isChecked ? [...modelValue.value, value] : modelValue.value.filter((checkListValue) => checkListValue !== value);
    };
    const rootContext = reactive({
      hasCheckboxGroup: true,
      name: computed(() => props.name),
      modelValue,
      size: computed(() => props.size),
      isDisabled: computed(() => props.isDisabled),
      onChange
    });
    useProvideCheckboxContext(rootContext);
    return {
      rootContext
    };
  },
  methods: {
    onChange(isChecked, value) {
      const checkList = isChecked ? [...this.modelValue, value] : this.modelValue.filter((checkListValue) => checkListValue !== value);
      this.$emit("update:modelValue", checkList);
    }
  }
});
const _hoisted_1$p = { role: "group" };
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$p, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const SCheckboxGroup = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["render", _sfc_render$O]]);
const CHIPS_VARIANTS = {
  fill: "fill",
  outline: "outline"
};
const CHIPS_SIZES = {
  sm: "sm",
  md: "md"
};
const _sfc_main$N = defineComponent({
  name: "SChips",
  components: {
    SIcon
  },
  props: {
    /**
     *  Chips 타입
     */
    variant: {
      type: String,
      default: CHIPS_VARIANTS.fill,
      validator: (value) => objectKeys(CHIPS_VARIANTS).includes(value)
    },
    /**
     *  Chips 사이즈
     */
    size: {
      type: String,
      default: CHIPS_SIZES.sm,
      validator: (value) => objectKeys(CHIPS_SIZES).includes(value)
    },
    /**
     *  Chips 우측 닫기 아이콘 여부
     */
    hasCloseIcon: {
      type: Boolean,
      default: false
    },
    /**
     *  Chips 활성화 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click", "close"],
  setup(props) {
    return {
      classes: computed(() => {
        const variantClasses = {
          fill: "border-transparent bg-inverse-elevation-6 focus-visible:bg-inverse-elevation-6 focus-visible:border-gray400 active:border-transparent active:bg-inverse-elevation-4 disabled:bg-disabled-variant-8",
          outline: "bg-neutral-variant-3 border-border focus-visible:bg-neutral-variant-3 focus-visible:border-gray400 active:border-gray400 active:bg-neutral-variant-3-pressed disabled:border-border disabled:bg-disabled-variant-3"
        };
        const sizeClasses = {
          sm: "px-8 h-28",
          md: "px-12 h-32"
        };
        return [
          "stds-chips",
          variantClasses[props.variant],
          sizeClasses[props.size]
        ];
      })
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
    onClose(event) {
      this.$emit("close", event);
    }
  }
});
const _hoisted_1$o = ["disabled"];
const _hoisted_2$d = { class: "text-xs leading-sm" };
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("button", {
    type: "button",
    class: normalizeClass(_ctx.classes),
    disabled: _ctx.isDisabled,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    createElementVNode("span", _hoisted_2$d, [
      renderSlot(_ctx.$slots, "default")
    ]),
    _ctx.hasCloseIcon ? (openBlock(), createBlock(_component_SIcon, {
      key: 0,
      class: "ml-4 text-on-surface-elevation-4",
      size: "xl",
      icon: "ic-v2-control-close-circle-fill",
      srOnlyText: "Close",
      onClick: withModifiers(_ctx.onClose, ["stop"])
    }, null, 8, ["onClick"])) : createCommentVNode("", true)
  ], 10, _hoisted_1$o);
}
const SChips = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$N]]);
const CIRCULAR_PROGRESS_SIZES = {
  sm: "sm",
  lg: "lg"
};
const _sfc_main$M = defineComponent({
  name: "SCircularProgress",
  props: {
    /**
     * Circular Progress 사이즈
     *
     * @values sm, lg
     */
    size: {
      type: String,
      default: CIRCULAR_PROGRESS_SIZES.sm,
      validator: (value) => objectKeys(CIRCULAR_PROGRESS_SIZES).includes(value)
    }
  },
  setup(props) {
    return {
      circularProgressClasses: computed(() => ({
        "stds-circular-progress-sm": props.size === CIRCULAR_PROGRESS_SIZES.sm,
        "stds-circular-progress-lg": props.size === CIRCULAR_PROGRESS_SIZES.lg
      }))
    };
  }
});
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["stds-circular-progress", _ctx.circularProgressClasses])
  }, null, 2);
}
const SCircularProgress = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["render", _sfc_render$M]]);
const TOOLTIP_PLACEMENTS = {
  "top": "top",
  "top-start": "top-start",
  "top-end": "top-end",
  "bottom": "bottom",
  "bottom-start": "bottom-start",
  "bottom-end": "bottom-end",
  "left": "left",
  "right": "right"
};
const _sfc_main$L = defineComponent({
  name: "STooltip",
  components: {
    tippy: defineAsyncComponent(
      () => isVue2 ? import("./vue-tippy.esm-Dd7iqdOb.mjs").then(
        (module) => module.TippyComponent
      ) : import("./vue-tippy.esm-browser-CfzW7acc.mjs").then((module) => module.Tippy)
    )
  },
  /**
   * @/s-tooltip은 내부적으로 vue-tippy v6를 사용합니다.
   *
   * vue-tippy의 옵션을 커스텀하여 props로 제공합니다.
   *
   * @see https://vue-tippy.netlify.app/props
   * https://github.com/KABBOUCHI/vue-tippy/blob/v6.4.1/src/components/Tippy.ts#L27-L88
   */
  props: {
    /**
     * 툴팁 화살표 표시 여부
     */
    arrow: {
      type: Boolean,
      default: true
    },
    /**
     * 툴팁 내용.
     *
     * 문자열이나 HTML 요소, 내용을 반환하는 함수를 사용할 수 있습니다.
     */
    content: {
      type: isClient ? [String, Element, DocumentFragment, Function] : [String, Function],
      default: void 0
    },
    /**
     * 툴팁을 표시할 CSS transition 애니메이션 ms 단위 시간
     */
    duration: {
      type: [Number, Array],
      default: 0
    },
    /**
     * 자동 툴팁 뒤집기 여부.
     *
     * 공간이 충분하지 않은 경우, 자동으로 가능한 뷰포트 내에 배치되도록 팁이 뒤집을지 여부를 설정합니다.
     * vue-tippy@v6 has removed this attribute, so we need to write logic for the popperOptions to configure it
     */
    useFlip: {
      type: Boolean,
      default: true
    },
    /**
     * 위치가 업데이트되는 경우(예: 스크롤, 크기 조정 또는 도구 설명의 크기가 변경된 경우) 툴팁을 뒤집을지 여부를 설정합니다.
     * vue-tippy@v6 has removed this attribute, so we need to write logic for the popperOptions to configure it
     */
    flipOnUpdate: {
      type: Boolean,
      default: true
    },
    /**
     * 툴팁 방향
     *
     * 참조 요소를 기준으로 툴팁을 배치할 방향을 설정합니다.
     */
    placement: {
      type: String,
      default: TOOLTIP_PLACEMENTS.bottom,
      validator: (value) => objectKeys(TOOLTIP_PLACEMENTS).includes(value)
    },
    /**
     * 툴팁을 표시하게 하는 이벤트 (공백으로 구분되는 문자열)
     */
    trigger: {
      type: String,
      default: "mouseenter focus"
    },
    /**
     * z-index
     *
     * 툴팁의 z-index를 설정합니다.
     */
    zIndex: {
      type: Number,
      default: 600
    },
    /**
     * 툴팁과 타겟 요소 간의 거리
     */
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    /**
     * 툴팁과 타겟 요소 간의 거리
     */
    distance: {
      type: Number,
      default: void 0
    },
    /**
     * 사용자 지정 Popper.js 옵션을 지정합니다.
     *
     * Vue 2 - [Popper.js 문서](https://popper.js.org/docs/v1/)
     * Vue 3 - [Popper.js 문서](https://popper.js.org/docs/v2/)
     */
    popperOptions: {
      type: Object,
      default: null
    }
  },
  emits: ["hidden", "hide", "mount", "show", "shown"],
  setup(props) {
    const tippyRef = ref(null);
    const computedOffset = computed(
      () => isVue2 ? props.offset.join(", ") : props.distance ? [props.offset[0], props.distance] : props.offset
    );
    const computedPopperOptions = computed(() => {
      let modifiers = [];
      if (props.useFlip) {
        if (!props.flipOnUpdate) {
          modifiers = [
            {
              name: "flip",
              enabled: false
            }
          ];
        } else {
          modifiers = [
            {
              name: "flip",
              enabled: true,
              options: {
                flipVariations: true
              }
            },
            {
              name: "preventOverflow",
              options: {
                mainAxis: true,
                altAxis: true
              }
            }
          ];
        }
      }
      return _merge({}, { modifiers }, props.popperOptions);
    });
    return {
      isVue2,
      isVue3,
      tippyRef,
      computedOffset,
      popperOptionsComputed: computedPopperOptions
    };
  },
  methods: {
    onHidden(instance) {
      this.$emit("hidden", instance);
    },
    onHide(instance) {
      this.$emit("hide", instance);
    },
    onMount(instance) {
      this.$emit("mount", instance);
    },
    onShow(instance) {
      this.$emit("show", instance);
    },
    onShown(instance) {
      this.$emit("shown", instance);
    }
  }
});
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tippy = resolveComponent("tippy");
  return _ctx.isVue2 ? (openBlock(), createBlock(_component_tippy, mergeProps({
    key: 0,
    ref: "tippyRef",
    class: "stds-tooltip"
  }, _ctx.$attrs, {
    arrow: _ctx.arrow,
    content: _ctx.content,
    duration: _ctx.duration,
    flip: _ctx.useFlip,
    flipOnUpdate: _ctx.flipOnUpdate,
    placement: _ctx.placement,
    trigger: _ctx.trigger,
    zIndex: _ctx.zIndex,
    offset: _ctx.computedOffset,
    distance: _ctx.distance ?? 10,
    onHidden: _ctx.onHidden,
    onHide: _ctx.onHide,
    onMount: _ctx.onMount,
    onShow: _ctx.onShow,
    onShown: _ctx.onShown
  }), {
    trigger: withCtx(() => [
      renderSlot(_ctx.$slots, "target")
    ]),
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["arrow", "content", "duration", "flip", "flipOnUpdate", "placement", "trigger", "zIndex", "offset", "distance", "onHidden", "onHide", "onMount", "onShow", "onShown"])) : _ctx.isVue3 ? (openBlock(), createBlock(_component_tippy, mergeProps({
    key: 1,
    ref: "tippyRef",
    class: "stds-tooltip"
  }, _ctx.$attrs, {
    arrow: _ctx.arrow,
    content: _ctx.content,
    duration: _ctx.duration,
    placement: _ctx.placement,
    trigger: _ctx.trigger,
    zIndex: _ctx.zIndex,
    offset: _ctx.computedOffset,
    popperOptions: _ctx.popperOptionsComputed,
    onHidden: _ctx.onHidden,
    onHide: _ctx.onHide,
    onMount: _ctx.onMount,
    onShow: _ctx.onShow,
    onShown: _ctx.onShown
  }), createSlots({
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "target")
    ]),
    _: 2
  }, [
    !_ctx.content ? {
      name: "content",
      fn: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      key: "0"
    } : void 0
  ]), 1040, ["arrow", "content", "duration", "placement", "trigger", "zIndex", "offset", "popperOptions", "onHidden", "onHide", "onMount", "onShow", "onShown"])) : createCommentVNode("", true);
}
const STooltip = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["render", _sfc_render$L]]);
const _sfc_main$K = defineComponent({
  name: "SContentsPopup",
  components: {
    STooltip
  },
  props: {
    /**
     * ContentsPopup과 타겟 요소 간의 거리
     */
    distance: {
      type: Number,
      default: 12
    },
    /**
     * ContentsPopup과 타겟 요소 간의 거리를 `[x, y]` 형으로 설정
     */
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    /**
     * ContentsPopup 방향
     *
     * 참조 요소를 기준으로 툴팁을 배치할 방향을 설정합니다.
     */
    placement: {
      type: String,
      default: TOOLTIP_PLACEMENTS["bottom-start"],
      validator: (value) => objectKeys(TOOLTIP_PLACEMENTS).includes(value)
    },
    /**
     * ContentsPopup을 표시하게 하는 이벤트 (공백으로 구분되는 문자열)
     */
    trigger: {
      type: String,
      default: "click"
    },
    /**
     * ContentsPopup 컨테이너의 최소 너비
     */
    minWidth: {
      type: [String, Number],
      default: 328
    },
    /**
     * 위치가 업데이트되는 경우(예: 스크롤, 크기 조정 또는 도구 설명의 크기가 변경된 경우) ContentsPopup을 뒤집을지 여부를 설정합니다.
     */
    flipOnUpdate: {
      type: Boolean,
      default: false
    },
    /**
     * 사용자 지정 Popper.js 옵션을 지정합니다.
     *
     * Vue 2 - [Popper.js 문서](https://popper.js.org/docs/v1/)
     * Vue 3 - [Popper.js 문서](https://popper.js.org/docs/v2/)
     */
    popperOptions: {
      type: Object,
      default: null
    }
  },
  setup(props, { slots }) {
    const hasHeader = computed(() => !isUndefined(slots.header));
    const hasContents = computed(() => !isUndefined(slots.contents));
    const tooltipRef = ref(null);
    const hideContentsPopup = () => {
      var _a;
      if (tooltipRef.value && tooltipRef.value.tippyRef) {
        if (isVue2) {
          tooltipRef.value.tippyRef.tippy().hide();
        }
        if (isVue3) {
          (_a = tooltipRef.value) == null ? void 0 : _a.tippyRef.tippy.hide();
        }
      }
    };
    const context = reactive({
      hideContentsPopup,
      hasHeader,
      hasContents
    });
    const containerStyles = computed(
      () => props.minWidth ? { minWidth: `${props.minWidth}px` } : {}
    );
    const defaultPopperOptions = {
      vue2: {
        modifiers: {
          hide: {
            enabled: false
          },
          preventOverflow: {
            enabled: false
          }
        }
      },
      vue3: {
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              altAxis: true,
              tether: false
            }
          },
          {
            name: "hide",
            enabled: false
          }
        ]
      }
    };
    provide(CONTEXT_KEYS.SContentsPopup, context);
    return {
      isVue2,
      isVue3,
      tooltipRef,
      containerStyles,
      defaultPopperOptions
    };
  }
});
const _hoisted_1$n = { class: "z-dropdown" };
const _hoisted_2$c = {
  key: 1,
  class: "stds-contents-popup"
};
const _hoisted_3$8 = { class: "z-dropdown" };
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_STooltip = resolveComponent("STooltip");
  return _ctx.isVue2 ? (openBlock(), createBlock(_component_STooltip, mergeProps({
    key: 0,
    ref: "tooltipRef",
    class: "stds-contents-popup",
    appendTo: "parent"
  }, _ctx.$attrs, {
    flipOnUpdate: _ctx.flipOnUpdate,
    popperOptions: _ctx.popperOptions || _ctx.defaultPopperOptions.vue2,
    placement: _ctx.placement,
    interactive: true,
    animateFill: false,
    arrow: false,
    distance: _ctx.distance,
    offset: _ctx.offset,
    trigger: _ctx.trigger
  }, toHandlers(_ctx.$listeners)), {
    target: withCtx(() => [
      renderSlot(_ctx.$slots, "target")
    ]),
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$n, [
        createElementVNode("div", {
          class: "stds-contents-popup-container",
          style: normalizeStyle(_ctx.containerStyles)
        }, [
          renderSlot(_ctx.$slots, "header"),
          renderSlot(_ctx.$slots, "contents")
        ], 4)
      ])
    ]),
    _: 3
  }, 16, ["flipOnUpdate", "popperOptions", "placement", "distance", "offset", "trigger"])) : _ctx.isVue3 ? (openBlock(), createElementBlock("div", _hoisted_2$c, [
    createVNode(_component_STooltip, mergeProps({ ref: "tooltipRef" }, _ctx.$attrs, {
      flipOnUpdate: _ctx.flipOnUpdate,
      popperOptions: _ctx.popperOptions || _ctx.defaultPopperOptions.vue3,
      placement: _ctx.placement,
      interactive: true,
      appendTo: "parent",
      animateFill: false,
      arrow: false,
      distance: _ctx.distance,
      offset: _ctx.offset,
      trigger: _ctx.trigger,
      tag: "div",
      "content-tag": "div"
    }), {
      target: withCtx(() => [
        renderSlot(_ctx.$slots, "target")
      ]),
      default: withCtx(() => [
        createElementVNode("div", _hoisted_3$8, [
          createElementVNode("div", {
            class: "stds-contents-popup-container",
            style: normalizeStyle(_ctx.containerStyles)
          }, [
            renderSlot(_ctx.$slots, "header"),
            renderSlot(_ctx.$slots, "contents")
          ], 4)
        ])
      ]),
      _: 3
    }, 16, ["flipOnUpdate", "popperOptions", "placement", "distance", "offset", "trigger"])
  ])) : createCommentVNode("", true);
}
const SContentsPopup = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["render", _sfc_render$K]]);
const useContentsPopupContext = () => useContext("SContentsPopup");
const _sfc_main$J = defineComponent({
  name: "SContentsPopupContentBody",
  setup() {
    const context = useContentsPopupContext();
    return {
      contentsBodyClasses: computed(() => ({
        "stds-contents-popup-body scrollbar-form-1 my-24": true,
        "mb-24 mt-8 pt-0": context.hasHeader
      }))
    };
  }
});
function _sfc_render$J(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.contentsBodyClasses)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
const SContentsPopupContentBody = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["render", _sfc_render$J]]);
const _sfc_main$I = defineComponent({
  name: "SContentsPopupHeader",
  props: {
    hasCloseButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ["clickCloseButton"],
  setup() {
    const context = useContentsPopupContext();
    return {
      hideContentsPopup: context.hideContentsPopup
    };
  },
  methods: {
    onClickCloseButton(event) {
      this.hideContentsPopup();
      this.$emit("clickCloseButton", event);
    }
  }
});
const _hoisted_1$m = { class: "stds-contents-popup-header" };
const _hoisted_2$b = { class: "text-xl font-medium leading-xl text-on-surface-elevation-1" };
const _hoisted_3$7 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "창닫기", -1);
const _hoisted_4$5 = [
  _hoisted_3$7
];
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$m, [
    createElementVNode("h1", _hoisted_2$b, [
      renderSlot(_ctx.$slots, "default")
    ]),
    _ctx.hasCloseButton ? (openBlock(), createElementBlock("button", {
      key: 0,
      class: "stove-ui-icon text-4xl text-neutral-variant-1-pressed before:ic-v2-control-close-line",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClickCloseButton && _ctx.onClickCloseButton(...args))
    }, _hoisted_4$5)) : createCommentVNode("", true)
  ]);
}
const SContentsPopupHeader = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["render", _sfc_render$I]]);
var locale = { exports: {} };
(function(module, exports) {
  !function(e, r) {
    r(exports);
  }(commonjsGlobal, function(e) {
    function r(e2, r2) {
      for (var a2 = 0; a2 < r2.length; a2++) {
        var n2 = r2[a2];
        n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e2, n2.key, n2);
      }
    }
    var a = function() {
      function e2(r2, a3, n3, u2) {
        !function(e3, r3) {
          if (!(e3 instanceof r3))
            throw new TypeError("Cannot call a class as a function");
        }(this, e2), this.language = r2, this.months = a3, this.monthsAbbr = n3, this.days = u2, this.rtl = false, this.ymd = false, this.yearSuffix = "";
      }
      var a2, n2;
      return a2 = e2, (n2 = [{ key: "language", get: function() {
        return this._language;
      }, set: function(e3) {
        if ("string" != typeof e3)
          throw new TypeError("Language must be a string");
        this._language = e3;
      } }, { key: "months", get: function() {
        return this._months;
      }, set: function(e3) {
        if (12 !== e3.length)
          throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
        this._months = e3;
      } }, { key: "monthsAbbr", get: function() {
        return this._monthsAbbr;
      }, set: function(e3) {
        if (12 !== e3.length)
          throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
        this._monthsAbbr = e3;
      } }, { key: "days", get: function() {
        return this._days;
      }, set: function(e3) {
        if (7 !== e3.length)
          throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
        this._days = e3;
      } }]) && r(a2.prototype, n2), e2;
    }(), n = new a("Afrikaans", ["Januarie", "Februarie", "Maart", "April", "Mei", "Junie", "Julie", "Augustus", "September", "Oktober", "November", "Desember"], ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"], ["So.", "Ma.", "Di.", "Wo.", "Do.", "Vr.", "Sa."]), u = new a("Arabic", ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوڤمبر", "ديسمبر"], ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوڤمبر", "ديسمبر"], ["أحد", "إثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"]);
    u.rtl = true;
    var i = new a("Bulgarian", ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"], ["Ян", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"], ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]), t = new a("Bosnian", ["Januar", "Februar", "Mart", "April", "Maj", "Juni", "Juli", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"], ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"]), o = new a("Catalan", ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"], ["Gen", "Feb", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Des"], ["Diu", "Dil", "Dmr", "Dmc", "Dij", "Div", "Dis"]), s = new a("Czech", ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"], ["led", "úno", "bře", "dub", "kvě", "čer", "čec", "srp", "zář", "říj", "lis", "pro"], ["ne", "po", "út", "st", "čt", "pá", "so"]), b = new a("Danish", ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"], ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"]), l = new a("German", ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"], ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."]), m = new a("Estonian", ["Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember"], ["Jaan", "Veebr", "Märts", "Apr", "Mai", "Juuni", "Juuli", "Aug", "Sept", "Okt", "Nov", "Dets"], ["P", "E", "T", "K", "N", "R", "L"]), M = new a("Greek", ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάϊος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"], ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαι", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"], ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"]), p = new a("English", ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]), J = new a("Spanish", ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"], ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]), g = new a("Persian", ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"], ["فرو", "ارد", "خرد", "تیر", "مرد", "شهر", "مهر", "آبا", "آذر", "دی", "بهم", "اسف"], ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"]), S = new a("Finnish", ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"], ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"], ["su", "ma", "ti", "ke", "to", "pe", "la"]), c = new a("Faroese", ["Januar", "Februar", "Mars", "Apríl", "Mai", "Juni", "Juli", "August", "Septembur", "Oktobur", "Novembur", "Desembur"], ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"], ["Sun", "Mán", "Týs", "Mik", "Hós", "Frí", "Ley"]), A = new a("French", ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"], ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"], ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]), v = new a("Georgia", ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"], ["იან", "თებ", "მარ", "აპრ", "მაი", "ივნ", "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"], ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"]), h2 = new a("Galician", ["Xaneiro", "Febreiro", "Marzo", "Abril", "Maio", "Xuño", "Xullo", "Agosto", "Setembro", "Outubro", "Novembro", "Decembro"], ["Xan", "Feb", "Mar", "Abr", "Mai", "Xuñ", "Xul", "Ago", "Set", "Out", "Nov", "Dec"], ["Dom", "Lun", "Mar", "Mér", "Xov", "Ven", "Sáb"]), k = new a("Hebrew", ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"], ["ינו", "פבר", "מרץ", "אפר", "מאי", "יונ", "יול", "אוג", "ספט", "אוק", "נוב", "דצמ"], ["א", "ב", "ג", "ד", "ה", "ו", "ש"]);
    k.rtl = true;
    var w = new a("Croatian", ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"], ["Sij", "Velj", "Ožu", "Tra", "Svi", "Lip", "Srp", "Kol", "Ruj", "Lis", "Stu", "Pro"], ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"]), D = new a("Hungarian", ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"], ["Jan", "Febr", "Márc", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szept", "Okt", "Nov", "Dec"], ["Vas", "Hét", "Ke", "Sze", "Csü", "Pén", "Szo"]), f = new a("Indonesian", ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"], ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"], ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"]), N = new a("Icelandic", ["Janúar", "Febrúar", "Mars", "Apríl", "Maí", "Júní", "Júlí", "Ágúst", "September", "Október", "Nóvember", "Desember"], ["Jan", "Feb", "Mars", "Apr", "Maí", "Jún", "Júl", "Ágú", "Sep", "Okt", "Nóv", "Des"], ["Sun", "Mán", "Þri", "Mið", "Fim", "Fös", "Lau"]), O = new a("Italian", ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"], ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"], ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"]), j = new a("Japanese", ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"], ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"], ["日", "月", "火", "水", "木", "金", "土"]);
    j.yearSuffix = "年", j.ymd = true;
    var F = new a("Kazakh", ["Қаңтар", "Ақпан", "Наурыз", "Сәуір", "Мамыр", "Маусым", "Шілде", "Тамыз", "Қыркүйек", "Қазан", "Қараша", "Желтоқсан"], ["Қаң", "Ақп", "Нау", "Сәу", "Мам", "Мау", "Шіл", "Там", "Қыр", "Қаз", "Қар", "Жел"], ["Жк", "Дй", "Сй", "Ср", "Бй", "Жм", "Сн"]), d = new a("Korean", ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"], ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"], ["일", "월", "화", "수", "목", "금", "토"]);
    d.yearSuffix = "년", d.ymd = true;
    var T = new a("Luxembourgish", ["Januar", "Februar", "Mäerz", "Abrëll", "Mee", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], ["Jan", "Feb", "Mäe", "Abr", "Mee", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"], ["So.", "Mé.", "Dë.", "Më.", "Do.", "Fr.", "Sa."]), y = new a("Lithuanian", ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"], ["Sau", "Vas", "Kov", "Bal", "Geg", "Bir", "Lie", "Rugp", "Rugs", "Spa", "Lap", "Gru"], ["Sek", "Pir", "Ant", "Tre", "Ket", "Pen", "Šeš"]);
    y.ymd = true;
    var z = new a("Latvian", ["Janvāris", "Februāris", "Marts", "Aprīlis", "Maijs", "Jūnijs", "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"], ["Jan", "Feb", "Mar", "Apr", "Mai", "Jūn", "Jūl", "Aug", "Sep", "Okt", "Nov", "Dec"], ["Sv", "Pr", "Ot", "Tr", "Ce", "Pk", "Se"]), L = new a("Macedonian", ["Јануари", "Февруари", "Март", "Април", "Мај", "Јуни", "Јули", "Август", "Септември", "Октомври", "Ноември", "Декември"], ["Јан", "Фев", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Ное", "Дек"], ["Нед", "Пон", "Вто", "Сре", "Чет", "Пет", "Саб"]), P = new a("Mongolia", ["1 дүгээр сар", "2 дугаар сар", "3 дугаар сар", "4 дүгээр сар", "5 дугаар сар", "6 дугаар сар", "7 дугаар сар", "8 дугаар сар", "9 дүгээр сар", "10 дугаар сар", "11 дүгээр сар", "12 дугаар сар"], ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"], ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"]);
    P.ymd = true;
    var G = new a("Norwegian Bokmål", ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"], ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"], ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"]), C = new a("Dutch", ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"], ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"], ["zo", "ma", "di", "wo", "do", "vr", "za"]), K = new a("Polish", ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"], ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"], ["Nd", "Pn", "Wt", "Śr", "Czw", "Pt", "Sob"]), R = new a("Brazilian", ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"], ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"], ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]), E = new a("Romanian", ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"], ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"], ["D", "L", "Ma", "Mi", "J", "V", "S"]), V = new a("Russian", ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"], ["Янв", "Февр", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сент", "Окт", "Нояб", "Дек"], ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]), _ = new a("Slovakian", ["január", "február", "marec", "apríl", "máj", "jún", "júl", "august", "september", "október", "november", "december"], ["jan", "feb", "mar", "apr", "máj", "jún", "júl", "aug", "sep", "okt", "nov", "dec"], ["ne", "po", "ut", "st", "št", "pi", "so"]), x = new a("Sloveian", ["Januar", "Februar", "Marec", "April", "Maj", "Junij", "Julij", "Avgust", "September", "Oktober", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"], ["Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob"]), I = new a("Serbian in Cyrillic script", ["Јануар", "Фебруар", "Март", "Април", "Мај", "Јун", "Јул", "Август", "Септембар", "Октобар", "Новембар", "Децембар"], ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"], ["Нед", "Пон", "Уто", "Сре", "Чет", "Пет", "Суб"]), B = new a("Serbian", ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"], ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"]), H = new a("Swedish", ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"], ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"]), X = new a("Thai", ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"], ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."], ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"]), U = new a("Turkish", ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"], ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"], ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"]), W = new a("Ukraine", ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"], ["Січ", "Лют", "Бер", "Квіт", "Трав", "Чер", "Лип", "Серп", "Вер", "Жовт", "Лист", "Груд"], ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]), Q = new a("Urdu", ["جنوری", "فروری", "مارچ", "اپریل", "مئی", "جون", "جولائی", "اگست", "سپتمبر", "اکتوبر", "نومبر", "دسمبر"], ["جنوری", "فروری", "مارچ", "اپریل", "مئی", "جون", "جولائی", "اگست", "سپتمبر", "اکتوبر", "نومبر", "دسمبر"], ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"]);
    Q.rtl = true;
    var Y = new a("Vietnamese", ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"], ["T 01", "T 02", "T 03", "T 04", "T 05", "T 06", "T 07", "T 08", "T 09", "T 10", "T 11", "T 12"], ["CN", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"]), q = new a("Chinese", ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], ["日", "一", "二", "三", "四", "五", "六"]);
    q.yearSuffix = "年";
    var Z = new a("Chinese_HK", ["壹月", "贰月", "叁月", "肆月", "伍月", "陆月", "柒月", "捌月", "玖月", "拾月", "拾壹月", "拾贰月"], ["壹月", "贰月", "叁月", "肆月", "伍月", "陆月", "柒月", "捌月", "玖月", "拾月", "拾壹月", "拾贰月"], ["日", "壹", "贰", "叁", "肆", "伍", "陆"]);
    Z.yearSuffix = "年", e.af = n, e.ar = u, e.bg = i, e.bs = t, e.ca = o, e.cs = s, e.da = b, e.de = l, e.ee = m, e.el = M, e.en = p, e.es = J, e.fa = g, e.fi = S, e.fo = c, e.fr = A, e.ge = v, e.gl = h2, e.he = k, e.hr = w, e.hu = D, e.id = f, e.is = N, e.it = O, e.ja = j, e.kk = F, e.ko = d, e.lb = T, e.lt = y, e.lv = z, e.mk = L, e.mn = P, e.nbNO = G, e.nl = C, e.pl = K, e.ptBR = R, e.ro = E, e.ru = V, e.sk = _, e.slSI = x, e.sr = B, e.srCYRL = I, e.sv = H, e.th = X, e.tr = U, e.uk = W, e.ur = Q, e.vi = Y, e.zh = q, e.zhHK = Z, Object.defineProperty(e, "__esModule", { value: true });
  });
})(locale, locale.exports);
var localeExports = locale.exports;
const INPUT_SIZES = {
  sm: "sm",
  lg: "lg"
};
const INPUT_VARIANTS = {
  fill: "fill",
  outline: "outline"
};
const INPUT_VALIDATION_STATES = {
  none: "none",
  error: "error",
  warning: "warning",
  success: "success",
  informational: "informational"
};
const _sfc_main$H = defineComponent({
  name: "SInput",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Input 값
     */
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    /**
     * Input 초기 값
     */
    defaultValue: {
      type: [String, Number],
      default: ""
    },
    /**
     * Input 타입
     */
    variant: {
      type: String,
      default: INPUT_VARIANTS.outline,
      validator: (value) => objectKeys(INPUT_VARIANTS).includes(value)
    },
    /**
     * Input 사이즈
     */
    size: {
      type: String,
      default: INPUT_SIZES.sm,
      validator: (value) => objectKeys(INPUT_SIZES).includes(value)
    },
    /**
     * 유효성 검사 상태
     */
    validationState: {
      type: String,
      default: "none",
      required: false,
      validator: (value) => objectKeys(INPUT_VALIDATION_STATES).includes(value)
    },
    /**
     * Input 비활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Input 요소 class
     */
    inputClass: {
      type: String,
      default: null
    }
  },
  emits: [
    "input",
    "update:modelValue",
    "change",
    "focus",
    "blur",
    "keyup",
    "keydown",
    "clear"
  ],
  setup(props, { emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const isFocused = ref(false);
    const rootClasses = computed(() => ({
      "stds-input-container": true,
      "h-32 pl-12 pr-12 focus-within:pr-[1.1rem] focus-within:pl-[1.1rem]": props.size === INPUT_SIZES.sm,
      "h-44 pl-16 pr-16 focus-within:pr-[1.5rem] focus-within:pl-[1.5rem]": props.size === INPUT_SIZES.lg,
      "bg-neutral-variant-3": props.variant === INPUT_VARIANTS.outline && !props.isDisabled,
      "bg-disabled-variant-3 border-border": props.variant === INPUT_VARIANTS.outline && props.isDisabled,
      "border-transparent bg-neutral-variant-2": props.variant === INPUT_VARIANTS.fill && !props.isDisabled,
      "bg-disabled-variant-3 border-transparent": props.variant === INPUT_VARIANTS.fill && props.isDisabled,
      "border-2 pr-[1.1rem] pl-[1.1rem]": props.validationState !== INPUT_VALIDATION_STATES.none && props.size === INPUT_SIZES.sm,
      "border-2 pr-[1.5rem] pl-[1.5rem]": props.validationState !== INPUT_VALIDATION_STATES.none && props.size === INPUT_SIZES.lg,
      "border-border": props.validationState === INPUT_VALIDATION_STATES.none && props.variant === INPUT_VARIANTS.outline,
      "border-error": props.validationState === INPUT_VALIDATION_STATES.error,
      "border-warning": props.validationState === INPUT_VALIDATION_STATES.warning,
      "border-success": props.validationState === INPUT_VALIDATION_STATES.success,
      "border-information": props.validationState === INPUT_VALIDATION_STATES.informational
    }));
    const inputClasses = computed(() => ({
      "stds-input": true,
      "text-xs leading-xs": props.size === INPUT_SIZES.sm,
      "text-md leading-sm": props.size === INPUT_SIZES.lg,
      [props.inputClass]: !isNullish(props.inputClass)
    }));
    const onInput = (event) => {
      if (isHTMLElement(event.target, HTMLInputElement)) {
        emit("input", event.target.value, event);
        modelValue.value = event.target.value;
      }
    };
    const onChange = (event) => {
      emit("change", event);
    };
    const onFocus = (event) => {
      isFocused.value = true;
      emit("focus", event);
    };
    const onBlur = (event) => {
      isFocused.value = false;
      emit("blur", event);
    };
    const onKeyup = (event) => {
      emit("keyup", event);
    };
    const onKeydown = (event) => {
      emit("keydown", event);
    };
    const onClear = () => {
      emit("clear");
      emit("input", "");
      modelValue.value = "";
    };
    return {
      isFocused,
      rootClasses,
      inputClasses,
      onInput,
      onChange,
      onFocus,
      onBlur,
      onKeyup,
      onKeydown,
      onClear
    };
  },
  methods: {
    onInputForStorybookDocs(value, event) {
      this.$emit("input", value, event);
    },
    onChangeForStorybookDocs(event) {
      this.$emit("change", event);
    },
    onFocusForStorybookDocs(event) {
      this.$emit("focus", event);
    },
    onBlurForStorybookDocs(event) {
      this.$emit("blur", event);
    },
    onKeyupForStorybookDocs(event) {
      this.$emit("keyup", event);
    },
    onKeydownForStorybookDocs(event) {
      this.$emit("keydown", event);
    },
    onClearForStorybookDocs() {
      this.$emit("clear");
    }
  }
});
const _hoisted_1$l = { class: "stds-input-wrapper" };
const _hoisted_2$a = ["value", "disabled"];
const _hoisted_3$6 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "Clear", -1);
const _hoisted_4$4 = [
  _hoisted_3$6
];
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.rootClasses)
  }, [
    createElementVNode("div", _hoisted_1$l, [
      createElementVNode("input", mergeProps(_ctx.$attrs, {
        class: _ctx.inputClasses,
        value: _ctx.modelValue,
        disabled: _ctx.isDisabled,
        onInput: _cache[0] || (_cache[0] = (...args) => _ctx.onInput && _ctx.onInput(...args)),
        onChange: _cache[1] || (_cache[1] = (...args) => _ctx.onChange && _ctx.onChange(...args)),
        onFocus: _cache[2] || (_cache[2] = (...args) => _ctx.onFocus && _ctx.onFocus(...args)),
        onBlur: _cache[3] || (_cache[3] = (...args) => _ctx.onBlur && _ctx.onBlur(...args)),
        onKeyup: _cache[4] || (_cache[4] = (...args) => _ctx.onKeyup && _ctx.onKeyup(...args)),
        onKeydown: _cache[5] || (_cache[5] = (...args) => _ctx.onKeydown && _ctx.onKeydown(...args))
      }), null, 16, _hoisted_2$a)
    ]),
    !_ctx.isDisabled && _ctx.isFocused && _ctx.modelValue.toString().length > 0 ? (openBlock(), createElementBlock("button", {
      key: 0,
      type: "button",
      class: "stds-input-clear-button stove-ui-icon before:ic-v2-control-close-circle-fill",
      onMousedown: _cache[6] || (_cache[6] = (...args) => _ctx.onClear && _ctx.onClear(...args))
    }, _hoisted_4$4, 32)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "rightIcon")
  ], 2);
}
const SInput = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$H]]);
const DATEPICKER_LANGUAGES = {
  ko: "ko",
  en: "en"
};
const DATEPICKER_VIEWS = {
  day: "day",
  month: "month",
  year: "year"
};
const DATEPICKER_VALIDATION_STATES = _pick(
  INPUT_VALIDATION_STATES,
  "none",
  "error"
);
const _sfc_main$G = defineComponent({
  name: "SDatepicker",
  components: {
    Datepicker: typeof window !== "undefined" ? defineAsyncComponent(
      () => isVue2 ? import("./vuejs-datepicker.esm-CB8f-gze.mjs").then(
        (module) => module.default
      ) : import("./vuejs3-datepicker-cL4RvB_C.mjs").then((module) => module.default)
    ) : null
  },
  /**
   * vuejs-datepicker에서 지원하는 props 중에서 커스텀하여 props로 제공
   *
   * Vue 2 @see https://github.com/charliekassel/vuejs-datepicker#available-props
   * Vue 3 @see https://github.com/charliekassel/vuejs-datepicker/blob/v1.6.2/src/components/Datepicker.vue#L110-L157
   */
  props: {
    /**
     * Datepicker 값
     */
    value: {
      type: [Date, String],
      default: void 0
    },
    /**
     * Input 요소의 name 속성
     */
    name: {
      type: String,
      default: void 0
    },
    /**
     * Input 요소의 id 속성
     */
    id: {
      type: String,
      default: void 0
    },
    /**
     * Date 포맷 문자열
     *
     * Vue 2 @see https://github.com/charliekassel/vuejs-datepicker#date-formatting
     * Vue 3 @see https://github.com/shubhadip/vuejs3-datepicker?tab=readme-ov-file#date-formatting
     */
    format: {
      type: [String, Function],
      default: "yyyy-MM-dd"
    },
    /**
     * 일/월 표기 언어
     *
     * @values ko, en
     */
    language: {
      type: String,
      default: "ko"
    },
    /**
     * 월 이름 전체 표기 여부
     */
    useFullMonthName: {
      type: Boolean,
      default: false
    },
    /**
     * 날짜 비활성 설정
     *
     * Vue 2 @see https://github.com/charliekassel/vuejs-datepicker#disabled-dates
     * Vue 3 @see https://github.com/shubhadip/vuejs3-datepicker/tree/v1.1.2?tab=readme-ov-file#disabled-dates
     */
    disabledDates: {
      type: Object,
      default: void 0
    },
    /**
     * 날짜 하이라이트 설정
     *
     * Vue 2 @see https://github.com/charliekassel/vuejs-datepicker#highlighted-dates
     * Vue 3 @see https://github.com/shubhadip/vuejs3-datepicker/tree/v1.1.2?tab=readme-ov-file#highlighted-dates
     */
    highlighted: {
      type: Object,
      default: void 0
    },
    /**
     * Input 자리표시자
     */
    placeholder: {
      type: String,
      default: "YYYY.MM.DD"
    },
    /**
     * Datepicker 항상 열려있을 지 여부
     */
    isInline: {
      type: Boolean,
      default: false
    },
    /**
     * 한 주 시작일을 월요일로 설정할 지 여부
     */
    useMondayFirst: {
      type: Boolean,
      default: false
    },
    /**
     * 처음에 표시할 날짜 화면 설정
     *
     * `day | month | year`
     */
    initialView: {
      type: String,
      default: void 0
    },
    /**
     * Datepicker 비활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Datepicker 필수 여부
     */
    isRequired: {
      type: Boolean,
      default: false
    },
    /**
     * Datepicker 직접 입력 가능 여부
     */
    isTypeable: {
      type: Boolean,
      default: false
    },
    /**
     * UTC 단위 사용 여부
     */
    useUtc: {
      type: Boolean,
      default: false
    },
    /**
     * 최소 날짜 화면 설정
     *
     * `day | month | year`
     */
    minimumView: {
      type: String,
      default: DATEPICKER_VIEWS.day
    },
    /**
     * 최대 날짜 화면 설정
     *
     * `day | month | year`
     */
    maximumView: {
      type: String,
      default: DATEPICKER_VIEWS.year
    },
    /**
     * Input 사이즈
     */
    size: {
      type: String,
      default: INPUT_SIZES.sm,
      validator: (value) => objectKeys(INPUT_SIZES).includes(value)
    },
    /**
     * 유효성 검사 상태
     */
    validationState: {
      type: String,
      default: DATEPICKER_VALIDATION_STATES.none,
      required: false,
      validator: (value) => objectKeys(DATEPICKER_VALIDATION_STATES).includes(value)
    }
  },
  emits: ["closed", "selected", "input"],
  setup(props) {
    const supportLanguages = isVue2 ? { en: localeExports.en, ko: localeExports.ko } : { en: "en", ko: "kr" };
    const wrapperClasses = computed(() => {
      return isVue2 ? {
        "stds-datepicker vdp-datepicker stove-ui-icon before:ic-v2-community-calendar-line relative inline-flex w-full flex-row flex-nowrap items-center justify-start rounded-lg outline outline-1 outline-border outline-offset-[-.1rem] before:absolute before:text-on-surface-elevation-2 focus-within:outline-2 focus-within:outline-gray400 focus-within:outline-offset-[-.2rem] focus-within:before:ic-community-calendar-line": true,
        "h-32 pl-12 pr-12 before:text-xl before:right-12": props.size === INPUT_SIZES.sm,
        "h-44 pl-16 pr-16 before:text-3xl before:right-16": props.size === INPUT_SIZES.lg,
        "outline-2 outline-error outline-offset-[-.2rem] focus-within:outline-error": props.validationState === DATEPICKER_VALIDATION_STATES.error && props.size === INPUT_SIZES.sm,
        "stds-datepicker-lg outline-2 outline-error outline-offset-[-.2rem] focus-within:outline-error": props.validationState === DATEPICKER_VALIDATION_STATES.error && props.size === INPUT_SIZES.lg,
        "outline outline-border bg-neutral-variant-3 focus-within:outline-gray400": !props.isDisabled,
        "outline outline-border bg-disabled-variant-3 focus-within:outline-gray400 before:text-disabled-variant-1": props.isDisabled
      } : {
        "stds-datepicker-vue3 stove-ui-icon before:ic-v2-community-calendar-line": true,
        "stds-datepicker-sm ": props.size === INPUT_SIZES.sm,
        "stds-datepicker-lg ": props.size === INPUT_SIZES.lg,
        "stds-datepicker-sm outline-2 outline-error focus-within:outline-error outline-offset-[-.2rem]": props.validationState === DATEPICKER_VALIDATION_STATES.error && props.size === INPUT_SIZES.sm,
        "stds-datepicker-lg outline-2 outline-error focus-within:outline-error outline-offset-[-.2rem]": props.validationState === DATEPICKER_VALIDATION_STATES.error && props.size === INPUT_SIZES.lg,
        "bg-neutral-variant-3": !props.isDisabled,
        "stds-datepicker-disabled bg-disabled-variant-3 before:text-disabled-variant-1": props.isDisabled
      };
    });
    const inputClasses = computed(() => {
      return isVue2 ? {
        "h-full w-full border-0 bg-transparent text-on-surface-elevation-2 caret-brand-primary outline-0 placeholder:text-placeholder placeholder:disabled:text-disabled-variant-1 disabled:text-disabled-variant-1": true,
        "text-xs leading-xs": props.size === INPUT_SIZES.sm,
        "text-md leading-sm": props.size === INPUT_SIZES.lg
      } : {};
    });
    return {
      wrapperClasses,
      inputClasses,
      computedLanguage: computed(() => supportLanguages[props.language]),
      isVue2,
      isVue3
    };
  },
  methods: {
    onClosed() {
      this.$emit("closed");
    },
    onSelected(date) {
      this.$emit("selected", date);
    },
    onInput(date) {
      this.$emit("input", date);
    }
  }
});
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Datepicker = resolveComponent("Datepicker");
  return openBlock(), createBlock(_component_Datepicker, mergeProps(_ctx.$props, {
    language: _ctx.computedLanguage,
    disabled: _ctx.isDisabled,
    fullMonthName: _ctx.useFullMonthName,
    inline: _ctx.isInline,
    mondayFirst: _ctx.useMondayFirst,
    required: _ctx.isRequired,
    typeable: _ctx.isTypeable,
    useUtc: _ctx.useUtc,
    inputClass: _ctx.inputClasses,
    wrapperClass: _ctx.wrapperClasses,
    hideInput: false,
    highlighted: _ctx.highlighted,
    calendarClass: "stds-datepicker",
    onClosed: _ctx.onClosed,
    onSelected: _ctx.onSelected,
    onInput: _ctx.onInput
  }), null, 16, ["language", "disabled", "fullMonthName", "inline", "mondayFirst", "required", "typeable", "useUtc", "inputClass", "wrapperClass", "highlighted", "onClosed", "onSelected", "onInput"]);
}
const SDatepicker = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$G]]);
const DIALOG_VARIANTS = {
  fullpage: "fullpage",
  bottom: "bottom"
};
const DIALOG_SIZES = {
  sm: "sm",
  md: "md",
  lg: "lg"
};
const _sfc_main$F = defineComponent({
  name: "SDialog",
  props: {
    /**
     * Dialog를 추가할 타겟 요소
     */
    to: {
      type: String,
      default: "stds-portal"
    },
    /**
     * Dialog 크기
     */
    size: {
      type: String,
      default: DIALOG_SIZES.sm,
      validator: (value) => objectKeys(DIALOG_SIZES).includes(value)
    },
    /**
     * Dialog 타입
     */
    variant: {
      type: String,
      default: DIALOG_VARIANTS.fullpage,
      validator: (value) => objectKeys(DIALOG_VARIANTS).includes(value)
    },
    open: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const context = reactive({
      variant: computed(() => props.variant),
      size: computed(() => props.size)
    });
    return {
      context
    };
  }
});
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SDialogProvider = resolveComponent("SDialogProvider");
  const _component_SPortal = resolveComponent("SPortal");
  return _ctx.open ? (openBlock(), createBlock(_component_SPortal, {
    key: 0,
    to: _ctx.to
  }, {
    default: withCtx(() => [
      createVNode(_component_SDialogProvider, {
        class: "stds-dialog",
        context: _ctx.context
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["context"])
    ]),
    _: 3
  }, 8, ["to"])) : createCommentVNode("", true);
}
const SDialog = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$F]]);
const _sfc_main$E = defineComponent({
  name: "SDialogContent"
});
const _hoisted_1$k = { class: "stds-dialog-content" };
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$k, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const SDialogContent = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$E]]);
const _sfc_main$D = defineComponent({
  name: "SDialogContentBody"
});
const _hoisted_1$j = { class: "stds-dialog-content-body" };
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$j, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const SDialogContentBody = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$D]]);
const _sfc_main$C = defineComponent({
  name: "SDialogFooter"
});
const _hoisted_1$i = { class: "stds-dialog-footer" };
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$i, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const SDialogFooter = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$C]]);
const _sfc_main$B = defineComponent({
  name: "SText",
  props: {
    /**
     * 렌더링할 HTML 태그 또는 컴포넌트
     */
    as: {
      type: [String, Object],
      default: "span"
    },
    /**
     * Typography Role
     */
    role: {
      type: [String, Array, Object],
      default: void 0
    },
    ...styleProps
  },
  setup(props) {
    const textClasses = computed(() => [
      "stds-text",
      ...useStyle({
        ...props,
        fontSize: props.fontSize ?? props.role,
        lineHeight: props.lineHeight ?? props.role,
        fontWeight: props.fontWeight ?? props.role
      }).value
    ]);
    return {
      textClasses
    };
  }
});
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.as), {
    class: normalizeClass(_ctx.textClasses)
  }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]);
}
const SText = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$B]]);
const _sfc_main$A = defineComponent({
  name: "SDialogHeader",
  components: {
    SText,
    SIcon
  },
  setup() {
    return {
      classes: computed(() => ({
        "stds-dialog-header": true
      }))
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
});
const _hoisted_1$h = { class: "stds-dialog-header" };
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SText = resolveComponent("SText");
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("div", _hoisted_1$h, [
    createVNode(_component_SText, {
      role: "title7",
      as: "h1"
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }),
    createElementVNode("button", {
      class: "stds-dialog-header-close-btn",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
    }, [
      createVNode(_component_SIcon, {
        icon: "ic-v2-control-close-line",
        size: "4xl",
        srOnlyText: "창닫기"
      })
    ])
  ]);
}
const SDialogHeader = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$A]]);
const _sfc_main$z = defineComponent({
  name: "SDialogOverlay",
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
});
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "stds-dialog-overlay",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  });
}
const SDialogOverlay = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$z]]);
const useDialogContext = () => useContext("SDialog");
const _sfc_main$y = defineComponent({
  name: "SDialogPanel",
  setup() {
    const context = useDialogContext();
    return {
      context,
      classes: computed(() => ({
        "stds-dialog-panel": true,
        "stds-dialog-panel-sm": context.size === DIALOG_SIZES.sm,
        "stds-dialog-panel-md-bottom": context.size === DIALOG_SIZES.md && context.variant === DIALOG_VARIANTS.bottom,
        "stds-dialog-panel-md-fullpage": context.size === DIALOG_SIZES.md && context.variant === DIALOG_VARIANTS.fullpage,
        "stds-dialog-panel-lg": context.size === DIALOG_SIZES.lg
      }))
    };
  }
});
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.classes)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
const SDialogPanel = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$y]]);
const _sfc_main$x = defineComponent({
  name: "SDialogProvider",
  props: {
    context: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    provide(CONTEXT_KEYS.SDialog, props.context);
    return {};
  }
});
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const SDialogProvider = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$x]]);
var DropdownState = /* @__PURE__ */ ((DropdownState2) => {
  DropdownState2[DropdownState2["Open"] = 0] = "Open";
  DropdownState2[DropdownState2["Closed"] = 1] = "Closed";
  return DropdownState2;
})(DropdownState || {});
const [useProvideDropdownContext, useDropdownContext] = createInjectionState(
  (context) => context,
  { injectionKey: CONTEXT_KEYS.SDropdown }
);
const useDropdownContextOrThrow = () => {
  const dropdownContext = useDropdownContext();
  if (!dropdownContext) {
    throw new Error(
      "Please call `useDropdownContext` on the parent <SDropdown /> component"
    );
  }
  return dropdownContext;
};
const DROPDOWN_VARIANTS = {
  text: "text",
  line: "line"
};
const DROPDOWN_SIZES = {
  sm: "sm",
  lg: "lg"
};
const _sfc_main$w = defineComponent({
  name: "SDropdown",
  components: {
    STooltip
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Dropdown 값
     */
    modelValue: {
      type: null,
      default: void 0
    },
    /**
     * Dropdown 초기값
     */
    defaultValue: {
      type: [Number, String, Boolean, Object],
      default: void 0
    },
    /**
     * Dropdown 타입
     */
    variant: {
      type: String,
      default: DROPDOWN_VARIANTS.line,
      validator: (value) => objectKeys(DROPDOWN_VARIANTS).includes(value)
    },
    /**
     * Dropdown 사이즈
     */
    size: {
      type: String,
      default: DROPDOWN_SIZES.sm,
      validator: (value) => objectKeys(DROPDOWN_SIZES).includes(value)
    },
    /**
     * Dropdown 비활성화 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Dropdown과 타겟 요소 간의 거리를 `[x, y]` 형으로 설정
     */
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    /**
     * 툴팁 방향
     *
     * 참조 요소를 기준으로 툴팁을 배치할 방향을 설정합니다.
     */
    placement: {
      type: String,
      default: TOOLTIP_PLACEMENTS["bottom-start"],
      validator: (value) => objectKeys(TOOLTIP_PLACEMENTS).includes(value)
    },
    /**
     * Dropdown List의 최대 높이 (px)
     */
    maxHeight: {
      type: Number,
      default: null
    },
    /**
     * Dropdown items 클릭시 Dropdown 접기 여부
     */
    closeOnClick: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "click",
    "open",
    "close",
    "update:modelValue",
    "hide",
    "mount",
    "show"
  ],
  setup(props, { slots, emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const selectedId = ref(void 0);
    const valueById = ref({});
    const state = ref(DropdownState.Closed);
    const tooltipRef = ref(null);
    const hasItems = computed(() => !isUndefined(slots.dropdownItems));
    const open = (instance) => {
      if (props.isDisabled)
        return;
      state.value = DropdownState.Open;
      emit("open", instance);
    };
    const close = (instance) => {
      if (props.isDisabled)
        return;
      state.value = DropdownState.Closed;
      emit("close", instance);
    };
    const select = (id2) => {
      if (props.isDisabled)
        return;
      if (tooltipRef.value && tooltipRef.value.tippyRef && props.closeOnClick) {
        if (isVue2) {
          tooltipRef.value.tippyRef.tippy().hide();
        } else {
          tooltipRef.value.tippyRef.hide();
        }
      }
      selectedId.value = id2;
      emit("update:modelValue", valueById.value[id2]);
    };
    const context = reactive({
      variant: computed(() => props.variant),
      size: computed(() => props.size),
      isDisabled: computed(() => props.isDisabled),
      state,
      modelValue,
      ids: ref([]),
      valueById,
      selectedId,
      open,
      close,
      select
    });
    useProvideDropdownContext(context);
    return {
      tooltipRef,
      context,
      hasItems,
      classes: computed(() => ({
        "stds-dropdown": true
      })),
      selectClasses: computed(
        () => ({
          text: "stds-dropdown-text-select",
          line: {
            "stds-dropdown-line-select": true,
            "pl-12 pr-32 focus-within:pl-[1.1rem] focus-within:pr-[3.1rem] h-32 text-btn3 leading-btn3 bg-[calc(100%-1.2rem)_center] bg-[length:1.2rem] focus-within:bg-[calc(100%-1.1rem)_center]": props.size === DROPDOWN_SIZES.sm,
            "pl-16 pr-[4.4rem] focus-within:pl-[1.5rem] focus-within:pr-[4.3rem] h-44 text-btn2 leading-btn2 bg-[calc(100%-1.6rem)_center] bg-[length:1.6rem] focus-within:bg-[calc(100%-1.5rem)_center]": props.size === DROPDOWN_SIZES.lg
          }
        })[props.variant]
      ),
      trigger: computed(() => props.isDisabled ? "" : "click"),
      open,
      close,
      select,
      dropdownListStyles: computed(
        () => props.maxHeight ? { maxHeight: `${props.maxHeight}px` } : null
      ),
      isVue2
    };
  },
  /**
   * Storybook Control 패널 문서화를 위해 작성
   */
  methods: {
    onOpen(instance) {
      this.$emit("open", instance);
    },
    onClose(instance) {
      this.$emit("close", instance);
    },
    onSelect(value) {
      this.$emit("update:modelValue", value);
    }
  }
});
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_STooltip = resolveComponent("STooltip");
  return openBlock(), createBlock(_component_STooltip, mergeProps({
    ref: "tooltipRef",
    class: _ctx.classes
  }, _ctx.$attrs, {
    appendTo: "parent",
    role: "listbox",
    trigger: _ctx.trigger,
    placement: _ctx.placement,
    offset: _ctx.offset,
    interactive: true,
    animateFill: false,
    arrow: false
  }, toHandlers(_ctx.isVue2 ? _ctx.$listeners : {}), {
    onShown: _ctx.open,
    onHidden: _ctx.close
  }), createSlots({
    target: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    !_ctx.isDisabled && _ctx.hasItems ? {
      name: "default",
      fn: withCtx(() => [
        createElementVNode("ul", {
          class: "stds-dropdown-list",
          style: normalizeStyle(_ctx.dropdownListStyles)
        }, [
          renderSlot(_ctx.$slots, "dropdownItems")
        ], 4)
      ]),
      key: "0"
    } : void 0
  ]), 1040, ["class", "trigger", "placement", "offset", "onShown", "onHidden"]);
}
const SDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$w]]);
const _sfc_main$v = defineComponent({
  name: "SDropdownButton",
  components: {
    SIcon
  },
  emits: ["click"],
  setup() {
    const context = useDropdownContextOrThrow();
    const iconSizeByDropdownSize = {
      [DROPDOWN_SIZES.sm]: "xs",
      [DROPDOWN_SIZES.lg]: "xl"
    };
    return {
      context,
      classes: computed(
        () => ({
          text: {
            "stds-dropdown-text-button": true,
            "h-32 text-md leading-lg": true
          },
          line: {
            "stds-dropdown-line-button": true,
            "px-12 focus-within:px-[1.1rem] h-32 text-btn3 leading-btn3 disabled:px-12": context.size === DROPDOWN_SIZES.sm,
            "px-16 focus-within:px-[1.5rem] h-44 text-btn2 leading-btn2 disabled:px-16": context.size === DROPDOWN_SIZES.lg
          }
        })[context.variant]
      ),
      labelClasses: "overflow-hidden overflow-ellipsis whitespace-nowrap",
      iconClasses: computed(
        () => ({
          text: {
            "ml-12": true,
            "text-xl": context.size,
            "text-on-surface-elevation-3": !context.isDisabled,
            "text-disabled-variant-1": context.isDisabled,
            "rotate-180": context.state === DropdownState.Open
          },
          line: {
            "text-xs ml-8": context.size === DROPDOWN_SIZES.sm,
            "text-xl ml-12": context.size === DROPDOWN_SIZES.lg,
            "text-on-surface-elevation-2": !context.isDisabled,
            "text-disabled-variant-1": context.isDisabled,
            "rotate-180": context.state === DropdownState.Open
          }
        })[context.variant]
      ),
      iconSize: computed(() => iconSizeByDropdownSize[context.size])
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
});
const _hoisted_1$g = ["disabled"];
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("button", {
    class: normalizeClass(_ctx.classes),
    disabled: _ctx.context.isDisabled,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    createElementVNode("span", {
      class: normalizeClass(_ctx.labelClasses)
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2),
    createVNode(_component_SIcon, {
      size: _ctx.iconSize,
      class: normalizeClass(_ctx.iconClasses),
      icon: "ic-v2-control-select-arrow-down-fill"
    }, null, 8, ["size", "class"])
  ], 10, _hoisted_1$g);
}
const SDropdownButton = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$v]]);
const _sfc_main$u = defineComponent({
  name: "SDropdownItem",
  props: {
    /**
     * DropdownItem 값
     */
    value: {
      type: [Number, String, Boolean, Object],
      required: true
    }
  },
  emits: ["click"],
  setup(props, { emit }) {
    const id2 = useId("s-dropdown-item");
    const context = useDropdownContextOrThrow();
    context.ids.push(id2);
    context.selectedId = isEqual(context.modelValue, props.value) ? id2 : context.selectedId;
    context.valueById = { ...context.valueById, [id2]: props.value };
    const isSelected = computed(() => id2 === context.selectedId);
    const click = (event) => {
      context.select(id2);
      emit("click", event);
    };
    return {
      id: id2,
      context,
      buttonClasses: computed(() => ({
        "stds-dropdown-list-item": true,
        "relative font-medium text-brand-primary": isSelected.value
      })),
      click,
      isSelected
    };
  },
  methods: {
    onClick(event) {
      this.context.select(this.id);
      this.$emit("click", event);
    }
  }
});
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("li", null, [
    createElementVNode("button", {
      class: normalizeClass(_ctx.buttonClasses),
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.click && _ctx.click(...args))
    }, [
      _ctx.isSelected ? (openBlock(), createBlock(_component_SIcon, {
        key: 0,
        size: "3xl",
        icon: "ic-v2-control-check-bold-line",
        class: "absolute left-[1.1rem] top-1/2 -translate-y-1/2"
      })) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "default")
    ], 2)
  ]);
}
const SDropdownItem = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$u]]);
const _sfc_main$t = defineComponent({
  name: "SEventDialog",
  props: {
    imageSrc: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      useId
    };
  }
});
const _hoisted_1$f = ["src"];
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SCheckbox = resolveComponent("SCheckbox");
  const _component_SBox = resolveComponent("SBox");
  const _component_SDialogContent = resolveComponent("SDialogContent");
  return openBlock(), createBlock(_component_SDialogContent, { class: "absolute top-32 left-0 right-0 z-modal mx-auto w-312 overflow-hidden rounded-lg bg-gray840" }, {
    default: withCtx(() => [
      createElementVNode("img", { src: _ctx.imageSrc }, null, 8, _hoisted_1$f),
      createVNode(_component_SBox, { class: "stds-event-dialog-button-wrap" }, {
        default: withCtx(() => [
          createVNode(_component_SCheckbox, {
            id: `stds-event-dialog-close-by-day-${_ctx.useId()}`,
            size: "sm",
            onChange: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close", true))
          }, {
            default: withCtx(() => [
              createTextVNode(" 1일 동안 보지않기 ")
            ]),
            _: 1
          }, 8, ["id"]),
          createElementVNode("button", {
            class: "w-48 flex-shrink-0 text-right text-md leading-lg",
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close", false))
          }, " 닫기 ")
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const SEventDialog = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$t]]);
const GRADE_BADGE_VARIANTS = {
  grade1: "grade1",
  grade2: "grade2",
  grade3: "grade3",
  grade4: "grade4",
  grade5: "grade5",
  grade6: "grade6",
  grade7: "grade7",
  grade8: "grade8",
  grade9: "grade9",
  grade10: "grade10"
};
const GRADE_BADGE_SVG_ICON_COMPONENTS = {
  grade1: defineAsyncComponent(() => import("./grade-badge-h-16-medal-01-zbGxF8Uw.mjs").then((i) => i.default)),
  grade2: defineAsyncComponent(() => import("./grade-badge-h-16-medal-02-CpkocPBM.mjs").then((i) => i.default)),
  grade3: defineAsyncComponent(() => import("./grade-badge-h-16-medal-03-squ9ixW1.mjs").then((i) => i.default)),
  grade4: defineAsyncComponent(() => import("./grade-badge-h-16-medal-04-KAOkMqG4.mjs").then((i) => i.default)),
  grade5: defineAsyncComponent(() => import("./grade-badge-h-16-medal-05-BydFOXxw.mjs").then((i) => i.default)),
  grade6: defineAsyncComponent(() => import("./grade-badge-h-16-medal-06-LM9Bmi0A.mjs").then((i) => i.default)),
  grade7: defineAsyncComponent(() => import("./grade-badge-h-16-medal-07-UKVZ6awp.mjs").then((i) => i.default)),
  grade8: defineAsyncComponent(() => import("./grade-badge-h-16-medal-08-BzUUjax2.mjs").then((i) => i.default)),
  grade9: defineAsyncComponent(() => import("./grade-badge-h-16-medal-09-C18fAlpr.mjs").then((i) => i.default)),
  grade10: defineAsyncComponent(() => import("./grade-badge-h-16-medal-10-CvoqkliA.mjs").then((i) => i.default))
};
const _sfc_main$s = defineComponent({
  name: "SGradeBadge",
  components: {
    ...GRADE_BADGE_SVG_ICON_COMPONENTS
  },
  props: {
    /**
     *  등급 뱃지 변형
     */
    variant: {
      type: String,
      default: GRADE_BADGE_VARIANTS.grade1,
      validator: (value) => objectKeys(GRADE_BADGE_VARIANTS).includes(value)
    }
  }
});
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.variant), { class: "h-20 w-20" });
}
const SGradeBadge = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s]]);
const _sfc_main$r = defineComponent({
  name: "SIconButton",
  components: {
    SButton
  },
  props: {
    /**
     * IconButton 타입
     */
    variant: {
      type: String,
      default: BUTTON_VARIANTS.primary,
      validator: (value) => objectKeys(BUTTON_VARIANTS).includes(value)
    },
    /**
     * IconButton 아이콘
     */
    icon: {
      type: String,
      validator: (value) => arrayIncludes$1(ALL_ICONS, value),
      default: void 0
    },
    /**
     * IconButton 좌측 아이콘 class
     */
    iconClass: {
      type: String,
      default: null
    },
    /**
     * IconButton 크기
     */
    size: {
      type: String,
      default: "md",
      validator: (value) => objectKeys(BUTTON_SIZES).includes(value)
    },
    /**
     * IconButton 활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
});
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SButton = resolveComponent("SButton");
  return openBlock(), createBlock(_component_SButton, mergeProps(_ctx.$props, { onClick: _ctx.onClick }), null, 16, ["onClick"]);
}
const SIconButton = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r]]);
const INDICATOR_SIZES = {
  sm: "sm",
  lg: "lg"
};
const INDICATOR_VARIANTS = {
  basic: "basic",
  white: "white"
};
const _sfc_main$q = defineComponent({
  name: "SIndicator",
  props: {
    size: {
      type: String,
      default: INDICATOR_SIZES.lg
    },
    variant: {
      type: String,
      default: INDICATOR_VARIANTS.basic
    },
    isActive: {
      type: Boolean,
      default: false
    },
    slide: {
      type: Number,
      default: 0
    }
  },
  emits: ["click"],
  setup(props) {
    const isFirstItem = computed(() => props.slide !== 0);
    const colorClasses = computed(
      () => props.variant === INDICATOR_VARIANTS.basic ? {
        "bg-brand-primary": props.isActive,
        "bg-disabled-variant-3": !props.isActive
      } : {
        "bg-white": true,
        "opacity-20": !props.isActive
      }
    );
    const sizeClasses = computed(
      () => props.size === INDICATOR_SIZES.sm ? {
        "h-[0.6rem]": true,
        "w-[0.6rem]": !props.isActive,
        "w-16": props.isActive,
        "ml-8": isFirstItem.value
      } : {
        "h-[1rem]": true,
        "w-[1rem]": !props.isActive,
        "w-24": props.isActive,
        "ml-12": isFirstItem.value
      }
    );
    return {
      indicatorClasses: computed(() => ({
        "rounded-full": true,
        ...colorClasses.value,
        ...sizeClasses.value
      }))
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", this.slide, event);
    }
  }
});
const _hoisted_1$e = { class: "sr-only" };
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", null, [
    createElementVNode("button", {
      class: normalizeClass(_ctx.indicatorClasses),
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
    }, [
      createElementVNode("span", _hoisted_1$e, "Go to slide " + toDisplayString(_ctx.slide), 1)
    ], 2)
  ]);
}
const SIndicator = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q]]);
const LINEAR_PROGRESS_VARIANTS = {
  default: "default",
  browser: "browser",
  infinite: "infinite"
};
const LINEAR_PROGRESS_SIZES = {
  sm: "sm",
  lg: "lg"
};
const _sfc_main$p = defineComponent({
  name: "SLinearProgress",
  props: {
    /**
     * LinearProgress 변형
     *
     * @values default, browser, infinite
     */
    variant: {
      type: String,
      default: LINEAR_PROGRESS_VARIANTS.default,
      validator: (value) => objectKeys(LINEAR_PROGRESS_VARIANTS).includes(value)
    },
    /**
     * LinearProgress 사이즈
     *
     * @values sm, lg
     */
    size: {
      type: String,
      default: LINEAR_PROGRESS_SIZES.sm,
      validator: (value) => objectKeys(LINEAR_PROGRESS_SIZES).includes(value)
    }
  },
  setup(props) {
    const variantClasses = {
      default: "stds-linear-progress",
      browser: "stds-linear-progress-browser",
      infinite: "stds-linear-progress-infinite"
    };
    const sizeClasses = {
      sm: "stds-linear-progress-sm",
      lg: "stds-linear-progress-lg"
    };
    return {
      linearProgressClasses: computed(() => [
        variantClasses[props.variant],
        sizeClasses[props.size]
      ])
    };
  }
});
const _hoisted_1$d = /* @__PURE__ */ createElementVNode("div", { class: "stds-progress-bar" }, null, -1);
const _hoisted_2$9 = [
  _hoisted_1$d
];
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.linearProgressClasses)
  }, _hoisted_2$9, 2);
}
const SLinearProgress = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p]]);
const _sfc_main$o = defineComponent({
  name: "SMenuPopup",
  components: {
    STooltip
  },
  props: {
    /**
     * MenuPopup과 타겟 요소 간의 거리
     */
    distance: {
      type: Number,
      default: 4
    },
    /**
     * MenuPopup과 타겟 요소 간의 거리를 `[x, y]` 형으로 설정
     */
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    /**
     * 툴팁 방향
     *
     * 참조 요소를 기준으로 툴팁을 배치할 방향을 설정합니다.
     */
    placement: {
      type: String,
      default: TOOLTIP_PLACEMENTS["bottom-start"],
      validator: (value) => objectKeys(TOOLTIP_PLACEMENTS).includes(value)
    },
    /**
     * MenuPopup을 표시하게 하는 이벤트 (공백으로 구분되는 문자열)
     */
    trigger: {
      type: String,
      default: "click"
    }
  },
  setup(_, { slots }) {
    return {
      hasMenuItems: computed(() => !isUndefined(slots.menuItems)),
      isVue2,
      isVue3
    };
  }
});
const _hoisted_1$c = { class: "z-dropdown" };
const _hoisted_2$8 = { class: "stds-menu-popup-list" };
const _hoisted_3$5 = { class: "z-dropdown" };
const _hoisted_4$3 = { class: "stds-menu-popup-list" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_STooltip = resolveComponent("STooltip");
  return _ctx.isVue2 ? (openBlock(), createBlock(_component_STooltip, mergeProps({
    key: 0,
    class: "stds-menu-popup"
  }, _ctx.$attrs, {
    appendTo: "parent",
    role: "listbox",
    placement: _ctx.placement,
    interactive: true,
    animateFill: false,
    arrow: false,
    distance: _ctx.distance,
    offset: _ctx.offset,
    trigger: _ctx.trigger
  }, toHandlers(_ctx.$listeners)), createSlots({
    target: withCtx(() => [
      renderSlot(_ctx.$slots, "target")
    ]),
    _: 2
  }, [
    _ctx.hasMenuItems ? {
      name: "default",
      fn: withCtx(() => [
        createElementVNode("div", _hoisted_1$c, [
          createElementVNode("div", _hoisted_2$8, [
            renderSlot(_ctx.$slots, "menuItems")
          ])
        ])
      ]),
      key: "0"
    } : void 0
  ]), 1040, ["placement", "distance", "offset", "trigger"])) : _ctx.isVue3 ? (openBlock(), createBlock(_component_STooltip, mergeProps({
    key: 1,
    class: "stds-menu-popup"
  }, _ctx.$attrs, {
    appendTo: "parent",
    role: "listbox",
    placement: _ctx.placement,
    interactive: true,
    animateFill: false,
    arrow: false,
    distance: _ctx.distance,
    offset: _ctx.offset,
    trigger: _ctx.trigger,
    tag: "div",
    "content-tag": "div"
  }), createSlots({
    target: withCtx(() => [
      renderSlot(_ctx.$slots, "target")
    ]),
    _: 2
  }, [
    _ctx.hasMenuItems ? {
      name: "default",
      fn: withCtx(() => [
        createElementVNode("div", _hoisted_3$5, [
          createElementVNode("div", _hoisted_4$3, [
            renderSlot(_ctx.$slots, "menuItems")
          ])
        ])
      ]),
      key: "0"
    } : void 0
  ]), 1040, ["placement", "distance", "offset", "trigger"])) : createCommentVNode("", true);
}
const SMenuPopup = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o]]);
const _sfc_main$n = defineComponent({
  name: "SMenuPopupItem",
  components: {
    SIcon
  },
  props: {
    /**
     * MenuPopup 아이템 value
     */
    value: {
      type: String,
      required: true
    },
    /**
     * 아이콘 이름
     */
    icon: {
      type: String,
      default: void 0
    }
  },
  emits: ["click"],
  methods: {
    onClick(event) {
      this.$emit("click", this.value, event);
    }
  }
});
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("button", {
    class: "stds-menu-popup-item",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    _ctx.icon ? (openBlock(), createBlock(_component_SIcon, {
      key: 0,
      icon: _ctx.icon,
      class: "mr-8 -ml-4",
      size: "3xl"
    }, null, 8, ["icon"])) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "default")
  ]);
}
const SMenuPopupItem = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n]]);
const NEW_BADGE_VARIANTS = {
  dot: "dot",
  letter: "letter",
  text: "text"
};
const _sfc_main$m = defineComponent({
  name: "SNewBadge",
  props: {
    /**
     * New Badge 타입
     *
     * @values text, dot
     */
    variant: {
      type: String,
      default: NEW_BADGE_VARIANTS.text
    }
  },
  setup(props) {
    const newBadgeLabel = {
      dot: "",
      text: "NEW",
      letter: "N"
    };
    return {
      classes: computed(() => ({
        "h-[0.6rem] w-[0.6rem] rounded-full": props.variant === NEW_BADGE_VARIANTS.dot,
        "h-[1.8rem] min-w-36 rounded-full px-4 font-bold leading-xs text-white indent-[-0.1rem]": props.variant === NEW_BADGE_VARIANTS.text,
        "h-[1.8rem] min-w-[1.8rem] rounded-full px-4 font-bold leading-xs text-white indent-[-0.1rem]": props.variant === NEW_BADGE_VARIANTS.letter
      })),
      label: computed(() => newBadgeLabel[props.variant])
    };
  }
});
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: normalizeClass(["inline-flex flex-row flex-nowrap items-center justify-center border-solid bg-brand-primary", _ctx.classes])
  }, toDisplayString(_ctx.label), 3);
}
const SNewBadge = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m]]);
const NUMBER_BADGE_VARIANTS = {
  dot: "dot",
  number: "number"
};
const _sfc_main$l = defineComponent({
  name: "SNumberBadge",
  props: {
    /**
     * Number Badge 타입
     *
     * @values number, dot
     */
    variant: {
      type: String,
      default: NUMBER_BADGE_VARIANTS.number
    },
    /**
     * 카운트 숫자
     */
    count: {
      type: Number,
      required: false,
      default: 0
    },
    /**
     * 최대 카운트 숫자
     */
    maxCount: {
      type: Number,
      required: false,
      default: 999
    }
  },
  setup(props) {
    return {
      classes: computed(() => ({
        "h-[0.6rem] w-[0.6rem] rounded-full": props.variant === NUMBER_BADGE_VARIANTS.dot,
        "h-[1.8rem] min-w-[1.8rem] rounded-full px-4 font-bold leading-xs text-white indent-[-0.1rem]": props.variant === NUMBER_BADGE_VARIANTS.number
      })),
      hasNumber: computed(() => props.variant === NUMBER_BADGE_VARIANTS.number),
      displayCount: computed(
        () => props.count > props.maxCount ? `${props.maxCount}+` : props.count
      )
    };
  }
});
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: normalizeClass(["inline-flex flex-row flex-nowrap items-center justify-center border-solid bg-brand-primary", _ctx.classes])
  }, toDisplayString(_ctx.hasNumber ? _ctx.displayCount : ""), 3);
}
const SNumberBadge = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l]]);
const DEFAULT_PAGE_PER_BLOCK = 10;
const MOBILE_PAGE_PER_BLOCK = 5;
const _sfc_main$k = defineComponent({
  name: "SPagination",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * 현재 페이지 번호
     */
    modelValue: {
      type: Number,
      default: void 0
    },
    /**
     * 최초 페이지 번호
     */
    defaultValue: {
      type: Number,
      default: 1
    },
    /**
     * 전체 페이지 갯수
     */
    pageCount: {
      type: Number,
      required: true
    },
    /**
     * 이전/다음 블록으로 이동 버튼을 노출할지 여부
     */
    displayPrevAndNextButton: {
      type: Boolean,
      default: true
    },
    /**
     * 처음/마지막 페이지로 이동 버튼을 노출할지 여부
     */
    displayFirstAndLastButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue", "change", "click"],
  setup(props, { emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const breakpoints2 = useBreakpoints(stds.glob.breakpoint);
    const isMobile = breakpoints2.smaller("sm");
    const pagePerBlock = computed(
      () => isMobile.value ? MOBILE_PAGE_PER_BLOCK : DEFAULT_PAGE_PER_BLOCK
    );
    const arrowButtonClassesByState = {
      activated: "active:text-on-surface-elevation-2 active:bg-interaction-pressed",
      disabled: "!text-disabled-variant-1 cursor-not-allowed pointer-events-none"
    };
    const pageButtonClassesByState = {
      active: "font-medium !text-white !bg-brand-primary",
      inactive: "focus-visible:bg-inverse-elevation-4 focus-within:bg-interaction-hover"
    };
    const currentBlockNumber = computed(() => Math.ceil(modelValue.value / pagePerBlock.value));
    const currentBlockFirstPage = computed(() => (currentBlockNumber.value - 1) * pagePerBlock.value + 1);
    const currentBlockLastPage = computed(() => currentBlockNumber.value === blockCounts.value ? props.pageCount : currentBlockNumber.value * pagePerBlock.value);
    const currentBlock = computed(() => Array.from({ length: currentBlockLastPage.value - currentBlockFirstPage.value + 1 }, (_, i) => currentBlockFirstPage.value + i));
    const blockCounts = computed(() => Math.ceil(props.pageCount / pagePerBlock.value));
    const hasPrevBlock = computed(() => modelValue.value > pagePerBlock.value);
    const hasNextBlock = computed(() => blockCounts.value > currentBlockNumber.value);
    const prevBlockLastPage = computed(() => currentBlockFirstPage.value - 1);
    const nextBlockFirstPage = computed(() => currentBlockLastPage.value + 1);
    const isFirstBlock = computed(() => currentBlockNumber.value === 1);
    const isLastBlock = computed(() => currentBlockNumber.value === blockCounts.value);
    const hasSingleBlock = computed(() => blockCounts.value === 1);
    const movePage = (page) => {
      emit("update:modelValue", page);
      emit("change", page);
    };
    const movePrevBlock = () => {
      if (hasPrevBlock.value) {
        movePage(prevBlockLastPage.value);
      }
    };
    const moveNextBlock = () => {
      if (hasNextBlock.value) {
        movePage(nextBlockFirstPage.value);
      }
    };
    const moveFirstPage = () => {
      if (!isFirstBlock.value) {
        movePage(1);
      }
    };
    const moveLastPage = () => {
      if (!isLastBlock.value) {
        movePage(props.pageCount);
      }
    };
    const onClickPageNumber = (page) => {
      emit("click", { el: "number", number: page });
      movePage(page);
    };
    const onClickPrevBlock = () => {
      emit("click", { el: "prev" });
      movePrevBlock();
    };
    const onClickNextBlock = () => {
      emit("click", { el: "next" });
      moveNextBlock();
    };
    const onClickFirstPage = () => {
      emit("click", { el: "first" });
      moveFirstPage();
    };
    const onClickLastPage = () => {
      emit("click", { el: "last" });
      moveLastPage();
    };
    return {
      breakpoints: breakpoints2,
      isMobile,
      pagePerBlock,
      arrowButtonClassesByState,
      pageButtonClassesByState,
      currentBlockNumber,
      blockCounts,
      hasPrevBlock,
      hasNextBlock,
      prevBlockLastPage,
      nextBlockFirstPage,
      isFirstBlock,
      isLastBlock,
      hasSingleBlock,
      currentBlock,
      movePage,
      movePrevBlock,
      moveNextBlock,
      moveFirstPage,
      moveLastPage,
      onClickPageNumber,
      onClickPrevBlock,
      onClickNextBlock,
      onClickFirstPage,
      onClickLastPage
    };
  },
  methods: {
    onChange(page) {
      this.$emit("update:modelValue", page);
      this.$emit("change", page);
    },
    onClick(payload) {
      this.$emit("click", payload);
    }
  }
});
const _hoisted_1$b = { class: "flex w-full items-center justify-center py-12 px-0 text-center text-md" };
const _hoisted_2$7 = ["onClick"];
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SIcon = resolveComponent("SIcon");
  return openBlock(), createElementBlock("div", _hoisted_1$b, [
    _ctx.displayFirstAndLastButton && !_ctx.isMobile && !_ctx.hasSingleBlock ? (openBlock(), createElementBlock("button", {
      key: 0,
      class: normalizeClass(`${_ctx.isFirstBlock ? _ctx.arrowButtonClassesByState.disabled : _ctx.arrowButtonClassesByState.activated} relative inline-block h-32 min-w-32 rounded-full leading-[3.2rem] text-on-surface-elevation-1 focus-within:outline-0 focus-visible:bg-inverse-elevation-4 focus-visible:outline-none`),
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClickFirstPage && _ctx.onClickFirstPage(...args))
    }, [
      createVNode(_component_SIcon, {
        icon: "ic-v2-control-double-arrow-left-line",
        size: "xl",
        srOnlyText: "처음",
        class: "align-middle"
      })
    ], 2)) : createCommentVNode("", true),
    _ctx.displayPrevAndNextButton ? (openBlock(), createElementBlock("button", {
      key: 1,
      class: normalizeClass(`${_ctx.isFirstBlock ? _ctx.arrowButtonClassesByState.disabled : _ctx.arrowButtonClassesByState.activated} relative inline-block h-32 min-w-32 rounded-full leading-[3.2rem] text-on-surface-elevation-1 focus-within:outline-0 focus-visible:bg-inverse-elevation-4 focus-visible:outline-none`),
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.onClickPrevBlock && _ctx.onClickPrevBlock(...args))
    }, [
      createVNode(_component_SIcon, {
        icon: "ic-v2-control-arrow-left-line",
        size: "xl",
        srOnlyText: "이전",
        class: "align-middle"
      })
    ], 2)) : createCommentVNode("", true),
    (openBlock(), createElementBlock("span", {
      key: _ctx.modelValue,
      class: "inline-block"
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.currentBlock, (pageNumber) => {
        return openBlock(), createElementBlock("button", {
          key: pageNumber,
          class: normalizeClass(`${_ctx.modelValue === pageNumber ? _ctx.pageButtonClassesByState.active : _ctx.pageButtonClassesByState.inactive} relative inline-block h-32 min-w-32 rounded-[1.6rem] py-0 px-12 leading-[3.2rem] text-on-surface-elevation-1 focus-within:outline-0 focus-visible:outline-none disabled:text-disabled-variant-1`),
          onClick: ($event) => _ctx.onClickPageNumber(pageNumber)
        }, toDisplayString(pageNumber), 11, _hoisted_2$7);
      }), 128))
    ])),
    _ctx.displayPrevAndNextButton ? (openBlock(), createElementBlock("button", {
      key: 2,
      class: normalizeClass(`${_ctx.isLastBlock ? _ctx.arrowButtonClassesByState.disabled : _ctx.arrowButtonClassesByState.activated} relative inline-block h-32 min-w-32 rounded-full leading-[3.2rem] text-on-surface-elevation-1 focus-within:outline-0 focus-visible:bg-inverse-elevation-4 focus-visible:outline-none`),
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.onClickNextBlock && _ctx.onClickNextBlock(...args))
    }, [
      createVNode(_component_SIcon, {
        icon: "ic-v2-control-arrow-right-line",
        size: "xl",
        srOnlyText: "다음",
        class: "align-middle"
      })
    ], 2)) : createCommentVNode("", true),
    _ctx.displayFirstAndLastButton && !_ctx.isMobile && !_ctx.hasSingleBlock ? (openBlock(), createElementBlock("button", {
      key: 3,
      type: "button",
      class: normalizeClass(`${_ctx.isLastBlock ? _ctx.arrowButtonClassesByState.disabled : _ctx.arrowButtonClassesByState.activated} relative inline-block h-32 min-w-32 rounded-full leading-[3.2rem] text-on-surface-elevation-1 focus-within:outline-0 focus-visible:bg-inverse-elevation-4 focus-visible:outline-none`),
      onClick: _cache[3] || (_cache[3] = (...args) => _ctx.onClickLastPage && _ctx.onClickLastPage(...args))
    }, [
      createVNode(_component_SIcon, {
        icon: "ic-v2-control-double-arrow-right-line",
        size: "xl",
        srOnlyText: "마지막",
        class: "align-middle"
      })
    ], 2)) : createCommentVNode("", true)
  ]);
}
const SPagination = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k]]);
const AVATAR_SIZES = {
  "20": "20",
  "24": "24",
  "32": "32",
  "40": "40",
  "56": "56",
  "72": "72",
  "144": "144"
};
const _sfc_main$j = defineComponent({
  name: "SAvatar",
  props: {
    /**
     * Avatar 사이즈
     */
    size: {
      type: String,
      default: AVATAR_SIZES[20]
    },
    /**
     * Avatar 썸네일 이미지 주소
     */
    src: {
      type: String,
      required: true
    },
    /**
     * Avatar 썸네일 이미지 대체 텍스트
     */
    alt: {
      type: String,
      default: void 0
    }
  },
  emits: ["click"],
  setup(props) {
    const widthClassesBySize = {
      "20": "w-20",
      "24": "w-24",
      "32": "w-32",
      "40": "w-40",
      "56": "w-56",
      "72": "w-72",
      "144": "w-144"
    };
    return {
      avatarClasses: computed(() => ["block", widthClassesBySize[props.size]])
    };
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
});
const _hoisted_1$a = ["src", "alt"];
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.avatarClasses),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    createElementVNode("img", {
      class: "w-full",
      src: _ctx.src,
      alt: _ctx.alt
    }, null, 8, _hoisted_1$a)
  ], 2);
}
const SAvatar = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j]]);
const _sfc_main$i = defineComponent({
  name: "SProfile",
  emits: ["click"],
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
});
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    class: "stds-profile",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const SProfile = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i]]);
const RADIO_SIZES = {
  sm: "sm",
  md: "md",
  lg: "lg"
};
const RADIO_ALIGNS = {
  top: "top",
  middle: "middle"
};
const [useProvideRadioContext, useRadioContext] = createInjectionState(
  (context) => context,
  { injectionKey: CONTEXT_KEYS.SRadio }
);
const useRadioContextWithDefaultValue = () => {
  return useRadioContext() ?? {
    hasRadioGroup: false,
    name: "",
    modelValue: void 0,
    size: RADIO_SIZES.md,
    isDisabled: false,
    onChange: noop
  };
};
const _sfc_main$h = defineComponent({
  name: "SRadio",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Radio Id
     */
    id: {
      type: String,
      default: void 0
    },
    /**
     * Radio 이름
     */
    name: {
      type: String,
      default: void 0
    },
    /**
     * Radio 값
     */
    value: {
      type: [String, Boolean, Number],
      required: true
    },
    /**
     * Radio 사이즈
     */
    size: {
      type: String,
      default: RADIO_SIZES.md,
      validator: (value) => objectKeys(RADIO_SIZES).includes(value)
    },
    /**
     * Radio 텍스트 정렬
     */
    align: {
      type: String,
      default: RADIO_ALIGNS.middle,
      validator: (value) => objectKeys(RADIO_ALIGNS).includes(value)
    },
    /**
     * Radio 체크 여부
     */
    modelValue: {
      type: Boolean,
      default: false
    },
    /**
     * Radio 비활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["change", "update:modelValue"],
  setup(props, { slots }) {
    const rootContext = useRadioContextWithDefaultValue();
    const id2 = computed(() => props.id ?? useId(rootContext.name));
    const context = reactive({
      id: id2,
      name: computed(() => props.name ?? id2.value),
      modelValue: computed(
        () => rootContext.hasRadioGroup ? rootContext.modelValue === props.value : props.modelValue
      ),
      size: computed(() => props.size ?? rootContext.size),
      isDisabled: computed(() => props.isDisabled || rootContext.isDisabled),
      hasText: computed(() => !isUndefined(slots.default))
    });
    return {
      rootContext,
      context,
      radioContainerClasses: computed(() => ({
        "stds-radio-container": true,
        "items-start": props.align === RADIO_ALIGNS.top,
        "items-center": props.align === RADIO_ALIGNS.middle,
        "min-h-16 min-w-16": context.size === RADIO_SIZES.sm,
        "min-h-20 min-w-20": context.size === RADIO_SIZES.md,
        "min-h-24 min-w-24": context.size === RADIO_SIZES.lg
      })),
      radioClasses: computed(() => ({
        "stds-radio peer": true,
        "top-2": props.align === RADIO_ALIGNS.top,
        "h-16 w-16 after:h-8 after:w-8": context.size === RADIO_SIZES.sm,
        "h-20 w-20 after:h-[1rem] after:w-[1rem]": context.size === RADIO_SIZES.md,
        "h-24 w-24 after:h-12 after:w-12": context.size === RADIO_SIZES.lg
      })),
      labelClasses: computed(() => ({
        "stds-radio-label": context.hasText,
        "stds-radio-label-sr-only": !context.hasText,
        "text-text3 leading-text3": context.hasText && (context.size === RADIO_SIZES.sm || context.size === RADIO_SIZES.md),
        "text-text1 leading-text1": context.hasText && context.size === RADIO_SIZES.lg
      }))
    };
  },
  methods: {
    onChange(event) {
      if (isHTMLElement(event.target, HTMLInputElement)) {
        this.$emit("change", event);
        this.$emit("update:modelValue", event.target.checked);
        this.rootContext.onChange(this.value);
      }
    }
  }
});
const _hoisted_1$9 = ["id", "name", "value", "checked", "disabled"];
const _hoisted_2$6 = ["for"];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createElementVNode("div", {
      class: normalizeClass(_ctx.radioContainerClasses)
    }, [
      createElementVNode("input", mergeProps(_ctx.$attrs, {
        id: _ctx.context.id,
        class: _ctx.radioClasses,
        type: "radio",
        name: _ctx.context.name,
        value: String(_ctx.value),
        checked: _ctx.context.modelValue,
        disabled: _ctx.context.isDisabled,
        onChange: _cache[0] || (_cache[0] = (...args) => _ctx.onChange && _ctx.onChange(...args))
      }), null, 16, _hoisted_1$9),
      createElementVNode("label", {
        class: normalizeClass(_ctx.labelClasses),
        for: _ctx.id
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_2$6)
    ], 2)
  ]);
}
const SRadio = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h]]);
const _sfc_main$g = defineComponent({
  name: "SRadioGroup",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Radio 이름
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Radio 값
     */
    modelValue: {
      type: [String, Boolean, Number],
      default: void 0
    },
    /**
     * Radio 초기 값
     */
    defaultValue: {
      type: [String, Boolean, Number],
      default: void 0
    },
    /**
     * Radio 사이즈
     */
    size: {
      type: String,
      default: RADIO_SIZES.md,
      validator: (value) => objectKeys(RADIO_SIZES).includes(value)
    },
    /**
     * Radio 비활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const onChange = (value) => {
      modelValue.value = value;
    };
    const rootContext = reactive({
      hasRadioGroup: true,
      name: computed(() => props.name),
      modelValue,
      size: computed(() => props.size),
      isDisabled: computed(() => props.isDisabled),
      onChange
    });
    useProvideRadioContext(rootContext);
    return {
      rootContext
    };
  },
  methods: {
    onChange(value) {
      this.$emit("update:modelValue", value);
    }
  }
});
const _hoisted_1$8 = { role: "radiogroup" };
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$8, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const SRadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g]]);
const _sfc_main$f = defineComponent({
  name: "SSearchField",
  components: {
    SInput
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Input 값
     */
    modelValue: {
      type: String,
      default: void 0
    },
    /**
     * Input 값
     */
    defaultValue: {
      type: String,
      default: ""
    },
    /**
     * Input 사이즈
     */
    size: {
      type: String,
      default: INPUT_SIZES.sm,
      validator: (value) => objectKeys(INPUT_SIZES).includes(value)
    },
    /**
     * Input 요소 class
     */
    inputClass: {
      type: String,
      default: null
    },
    /**
     * InputContainer 클래스
     */
    inputContainerClass: {
      type: [String, Object, Array],
      default: ""
    }
  },
  emits: ["clear", "input", "search", "update:modelValue"],
  setup(props, { emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const isModuleOpen = ref(false);
    const context = reactive({
      searchInput: modelValue,
      isModuleOpen,
      openModule: () => {
        isModuleOpen.value = true;
      },
      closeModule: () => {
        isModuleOpen.value = false;
      }
    });
    provide(CONTEXT_KEYS.SSearchField, context);
    const updateIsModuleOpen = (value) => {
      if (value.length > 0) {
        context.openModule();
        return;
      }
      context.closeModule();
    };
    const onInput = (value, event) => {
      modelValue.value = value;
      emit("input", value, event);
      updateIsModuleOpen(value);
    };
    const onFocus = () => {
      updateIsModuleOpen(context.searchInput);
    };
    const onClear = () => {
      emit("clear");
    };
    const onClickSearchButton = (event) => {
      emit("search", modelValue.value, event);
    };
    const target = ref(null);
    onClickOutside(target, () => {
      context.closeModule();
    });
    return {
      target,
      context,
      searchButtonClasses: computed(() => ({
        "stds-search-field-search-button stove-ui-icon before:ic-v2-navigation-search-line": true,
        "text-xl": props.size === INPUT_SIZES.sm,
        "text-3xl": props.size === INPUT_SIZES.lg
      })),
      updateIsModuleOpen,
      onInput,
      onFocus,
      onClear,
      onClickSearchButton
    };
  },
  methods: {
    onClearForStorybookDocs() {
      this.$emit("clear");
    },
    onClickSearchButtonForStorybookDocs(value, event) {
      this.$emit("search", value, event);
    }
  }
});
const _hoisted_1$7 = { ref: "target" };
const _hoisted_2$5 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "Search", -1);
const _hoisted_3$4 = [
  _hoisted_2$5
];
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SInput = resolveComponent("SInput");
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    createVNode(_component_SInput, mergeProps(_ctx.$attrs, {
      modelValue: _ctx.modelValue,
      size: _ctx.size,
      inputClass: _ctx.inputClass,
      class: _ctx.inputContainerClass
    }, toHandlers(_ctx.$listeners), {
      onInput: _ctx.onInput,
      onFocus: _ctx.onFocus,
      onClear: _ctx.onClear
    }), {
      rightIcon: withCtx(() => [
        createElementVNode("button", {
          class: normalizeClass(_ctx.searchButtonClasses),
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClickSearchButton && _ctx.onClickSearchButton(...args))
        }, _hoisted_3$4, 2)
      ]),
      _: 1
    }, 16, ["modelValue", "size", "inputClass", "class", "onInput", "onFocus", "onClear"]),
    renderSlot(_ctx.$slots, "autocomplete"),
    renderSlot(_ctx.$slots, "recentSearch")
  ], 512);
}
const SSearchField = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f]]);
const useSearchFieldContext = () => useContext("SSearchField");
const SWITCH_SIZES = {
  sm: "sm",
  md: "md",
  lg: "lg"
};
const _sfc_main$e = defineComponent({
  name: "SSwitch",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Switch 요소 id
     */
    id: {
      type: String,
      required: true
    },
    /**
     * Switch 사이즈
     */
    size: {
      type: String,
      default: SWITCH_SIZES.md,
      validator: (value) => objectKeys(SWITCH_SIZES).includes(value)
    },
    /**
     * 레이블 텍스트 표시 여부
     */
    isLabelVisible: {
      type: Boolean,
      default: false
    },
    /**
     * 레이블 텍스트
     */
    labelText: {
      type: String,
      default: void 0
    },
    /**
     * 비활성화 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Switch 입력으로 사용되는 값
     */
    value: {
      type: String,
      default: void 0
    },
    /**
     * Switch 체크 여부
     */
    modelValue: {
      type: Boolean,
      default: void 0
    },
    /**
     * Switch 체크 여부 초기값
     */
    defaultValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["change", "update:modelValue"],
  setup(props, { emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const onChange = (event) => {
      modelValue.value = !modelValue.value;
      emit("change", event);
    };
    return {
      onChange,
      visibleLabelClasses: computed(() => [
        "stds-switch-visible-label",
        modelValue.value ? "before:translate-x-[1rem] after:bg-brand-primary" : "before:translate-x-0 after:bg-neutral-variant-4",
        props.isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      ]),
      visibleLabelTextClasses: computed(() => [
        "pr-8 text-md leading-lg font-medium",
        modelValue.value ? "text-brand-primary" : "text-on-surface-elevation-3"
      ]),
      invisibleLabelClasses: computed(() => ({
        sm: [
          "stds-switch-invisible-label",
          "h-16 w-[2.6rem] rounded-lg before:top-[0.3rem] before:left-[0.3rem] before:h-[1rem] before:w-[1rem]",
          modelValue.value ? "bg-brand-primary before:translate-x-[1rem]" : "bg-neutral-variant-4 before:translate-x-0",
          props.isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        ],
        md: [
          "stds-switch-invisible-label",
          "h-24 w-40 rounded-[1.2rem] before:top-4 before:left-4 before:h-16 before:w-16",
          modelValue.value ? "bg-brand-primary before:translate-x-16" : "bg-neutral-variant-4 before:translate-x-0",
          props.isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        ],
        lg: [
          "stds-switch-invisible-label",
          "h-32 w-56 rounded-[1.6rem] before:top-4 before:left-4 before:h-24 before:w-24",
          modelValue.value ? "bg-brand-primary before:translate-x-24" : "bg-neutral-variant-4 before:translate-x-0",
          props.isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        ]
      }))
    };
  },
  methods: {
    onChange_(event) {
      const newValue = !this.modelValue;
      this.$emit("update:modelValue", newValue);
      this.$emit("change", event);
    }
  }
});
const _hoisted_1$6 = { class: "stds-switch" };
const _hoisted_2$4 = ["id", "checked", "disabled", "value"];
const _hoisted_3$3 = ["for"];
const _hoisted_4$2 = ["for"];
const _hoisted_5$2 = { class: "sr-only" };
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$6, [
    createElementVNode("input", {
      id: _ctx.id,
      type: "checkbox",
      checked: _ctx.modelValue,
      disabled: _ctx.isDisabled,
      value: _ctx.value,
      class: "stds-switch-checkbox",
      onChange: _cache[0] || (_cache[0] = (...args) => _ctx.onChange && _ctx.onChange(...args))
    }, null, 40, _hoisted_2$4),
    _ctx.isLabelVisible ? (openBlock(), createElementBlock("label", {
      key: 0,
      for: _ctx.id,
      class: normalizeClass(_ctx.visibleLabelClasses)
    }, [
      createElementVNode("span", {
        class: normalizeClass(_ctx.visibleLabelTextClasses)
      }, toDisplayString(_ctx.labelText), 3)
    ], 10, _hoisted_3$3)) : (openBlock(), createElementBlock("label", {
      key: 1,
      for: _ctx.id,
      class: normalizeClass(_ctx.invisibleLabelClasses[_ctx.size])
    }, [
      createElementVNode("span", _hoisted_5$2, toDisplayString(_ctx.labelText), 1)
    ], 10, _hoisted_4$2))
  ]);
}
const SSwitch = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e]]);
const _sfc_main$d = defineComponent({
  name: "SAutocomplete",
  components: {
    SSwitch
  },
  props: {
    searchResults: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const context = useSearchFieldContext();
    const query = computed(() => new RegExp(context.searchInput, "i"));
    return {
      context,
      useId,
      isOn: ref(true),
      filteredResults: computed(
        () => props.searchResults.filter((result) => query.value.test(result))
      ),
      highlight: (text) => text.replace(
        query.value,
        (match) => `<span class="text-brand-primary">${match}</span>`
      )
    };
  },
  methods: {
    onClickSearchResultItem(result) {
      this.$emit("clickSearchResultItem", result);
    },
    onChangeIsOn(newValue, event) {
      this.isOn = newValue;
      this.$emit("changeIsOn", newValue, event);
    },
    onClickReportButton(event) {
      this.$emit("report", event);
    },
    onClickCloseButton(event) {
      this.$emit("click", event);
      this.context.closeModule();
    }
  }
});
const _hoisted_1$5 = { class: "relative" };
const _hoisted_2$3 = { class: "absolute top-4 z-dropdown block w-full rounded-lg border-1 border-solid border-inverse-variant-1 bg-surface-layer shadow-4" };
const _hoisted_3$2 = {
  key: 0,
  class: "max-h-[33.8rem] overflow-hidden overflow-y-auto border-b-1 border-solid border-inverse-variant-1 scrollbar-form-1"
};
const _hoisted_4$1 = { class: "py-8 px-0" };
const _hoisted_5$1 = ["onClick"];
const _hoisted_6$1 = ["innerHTML"];
const _hoisted_7$1 = { class: "flex flex-row flex-nowrap items-center justify-between py-[1.0rem] px-16" };
const _hoisted_8$1 = { class: "flex" };
const _hoisted_9$1 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "신고", -1);
const _hoisted_10$1 = [
  _hoisted_9$1
];
const _hoisted_11$1 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "닫기", -1);
const _hoisted_12$1 = [
  _hoisted_11$1
];
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SSwitch = resolveComponent("SSwitch");
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$5, [
    createElementVNode("div", _hoisted_2$3, [
      _ctx.isOn && _ctx.filteredResults.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_3$2, [
        createElementVNode("ul", _hoisted_4$1, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.filteredResults, (result) => {
            return openBlock(), createElementBlock("li", {
              key: result,
              class: "relative",
              onClick: ($event) => _ctx.onClickSearchResultItem(result)
            }, [
              createElementVNode("span", {
                class: "flex w-full flex-row flex-nowrap items-center justify-start whitespace-pre py-8 px-16 text-md font-regular leading-lg text-on-surface-elevation-2 hover:bg-interaction-hover active:bg-interaction-pressed",
                innerHTML: _ctx.highlight(result)
              }, null, 8, _hoisted_6$1)
            ], 8, _hoisted_5$1);
          }), 128))
        ])
      ])) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_7$1, [
        createVNode(_component_SSwitch, {
          id: `stds-autocomplete-switch-${_ctx.useId()}`,
          modelValue: _ctx.isOn,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.isOn = $event),
          isLabelVisible: true,
          labelText: "자동완성",
          onChange: _ctx.onChangeIsOn
        }, null, 8, ["id", "modelValue", "onChange"]),
        createElementVNode("div", _hoisted_8$1, [
          createElementVNode("button", {
            class: "stove-ui-icon my-0 mx-12 shrink-0 text-3xl text-on-surface-elevation-4 duration-150 before:ic-v2-object-report-fill focus-within:outline-0",
            onClick: _cache[1] || (_cache[1] = (...args) => _ctx.onClickReportButton && _ctx.onClickReportButton(...args))
          }, _hoisted_10$1),
          createElementVNode("button", {
            class: "stove-ui-icon relative my-0 mx-12 mr-0 shrink-0 text-3xl text-on-surface-elevation-3 duration-150 before:ic-v2-control-close-line after:absolute after:-left-12 after:top-1/2 after:-mt-[0.9rem] after:h-[1.8rem] after:w-[0.1rem] after:bg-inverse-elevation-3 after:content-[''] focus-within:outline-0",
            onClick: _cache[2] || (_cache[2] = (...args) => _ctx.onClickCloseButton && _ctx.onClickCloseButton(...args))
          }, _hoisted_12$1)
        ])
      ])
    ])
  ], 512)), [
    [vShow, _ctx.context.isModuleOpen]
  ]);
}
const SAutocomplete = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d]]);
const _sfc_main$c = defineComponent({
  name: "SRecentSearch",
  props: {
    recentSearchRecords: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const context = useSearchFieldContext();
    const query = computed(() => new RegExp(context.searchInput, "i"));
    return {
      context,
      highlight: (text) => text.replace(
        query.value,
        (match) => `<span class="text-brand-primary">${match}</span>`
      )
    };
  },
  methods: {
    onClickSearchRecordItem(record, event) {
      this.$emit("clickSearchRecordItem", record, event);
    },
    onClickDeleteSearchRecord(event) {
      this.$emit("clickDeleteSearchRecord", event);
    },
    onClickDeleteSearchRecordItem(index, event) {
      this.$emit("clickDeleteSearchRecordItem", index, event);
    },
    onClickCloseButton(event) {
      this.$emit("click", event);
      this.context.closeModule();
    }
  }
});
const _hoisted_1$4 = { class: "relative" };
const _hoisted_2$2 = { class: "absolute top-4 z-dropdown block w-full rounded-md border-1 border-solid border-inverse-elevation-1 bg-surface-layer shadow-4" };
const _hoisted_3$1 = { class: "max-h-[33.8rem] overflow-hidden overflow-y-auto" };
const _hoisted_4 = { class: "py-8 px-0" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "Delete", -1);
const _hoisted_9 = [
  _hoisted_8
];
const _hoisted_10 = { class: "flex h-44 flex-row flex-nowrap items-center justify-between border-t-1 border-solid border-inverse-elevation-1 px-16" };
const _hoisted_11 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "닫기", -1);
const _hoisted_12 = [
  _hoisted_11
];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$4, [
    createElementVNode("div", _hoisted_2$2, [
      createElementVNode("div", _hoisted_3$1, [
        createElementVNode("ul", _hoisted_4, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.recentSearchRecords, (record, index) => {
            return openBlock(), createElementBlock("li", {
              key: record,
              class: "relative",
              onClick: ($event) => _ctx.onClickSearchRecordItem(record, $event)
            }, [
              createElementVNode("span", {
                class: "flex w-full flex-row flex-nowrap items-center justify-start whitespace-nowrap py-8 px-16 text-md font-regular leading-lg text-on-surface-elevation-2 hover:bg-interaction-hover active:bg-interaction-pressed",
                innerHTML: _ctx.highlight(record)
              }, null, 8, _hoisted_6),
              createElementVNode("button", {
                class: "stove-ui-icon absolute top-1/2 right-16 -mt-8 ml-8 shrink-0 text-xl text-inverse-elevation-2 duration-150 before:ic-v2-control-close-circle-fill focus-within:outline-0",
                onClick: withModifiers(($event) => _ctx.onClickDeleteSearchRecordItem(index, $event), ["stop"])
              }, _hoisted_9, 8, _hoisted_7)
            ], 8, _hoisted_5);
          }), 128))
        ])
      ]),
      createElementVNode("div", _hoisted_10, [
        createElementVNode("button", {
          class: "text-md font-regular leading-lg text-on-surface-elevation-3 focus-within:outline-0",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.onClickDeleteSearchRecord($event))
        }, " 전체 삭제 "),
        createElementVNode("button", {
          class: "stove-ui-icon relative my-0 mx-12 mr-0 shrink-0 text-3xl text-on-surface-elevation-3 duration-150 before:ic-v2-control-close-line focus-within:outline-0",
          onClick: _cache[1] || (_cache[1] = (...args) => _ctx.onClickCloseButton && _ctx.onClickCloseButton(...args))
        }, _hoisted_12)
      ])
    ])
  ], 512)), [
    [vShow, _ctx.context.isModuleOpen]
  ]);
}
const SRecentSearch = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c]]);
const _sfc_main$b = defineComponent({
  name: "SSkeleton",
  props: {
    /**
     * Skeleton 너비
     */
    width: {
      type: [String, Array, Object],
      default: void 0
    },
    /**
     * Skeleton 높이
     */
    height: {
      type: [String, Array, Object],
      default: void 0
    },
    /**
     * 로딩 완료 여부
     */
    isLoaded: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      skeletonClasses: computed(
        () => [
          props.isLoaded || "stds-skeleton-contents",
          ...mapResponsiveClasses(props.width, (width) => `w-${width}`),
          ...mapResponsiveClasses(props.height, (height) => `h-${height}`)
        ].filter(isString)
      )
    };
  },
  computed: {}
});
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.skeletonClasses)
  }, [
    _ctx.isLoaded ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("", true)
  ], 2);
}
const SSkeleton = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b]]);
const _sfc_main$a = defineComponent({
  name: "SSkeletonCircle",
  components: {
    SSkeleton
  },
  props: {
    /**
     * SkeletonCircle 크기
     */
    size: {
      type: [String, Array, Object],
      default: "40"
    },
    /**
     * 로딩 완료 여부
     */
    isLoaded: {
      type: Boolean
    }
  }
});
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SSkeleton = resolveComponent("SSkeleton");
  return openBlock(), createBlock(_component_SSkeleton, {
    class: "rounded-full",
    width: _ctx.size,
    height: _ctx.size,
    isLoaded: _ctx.isLoaded
  }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["width", "height", "isLoaded"]);
}
const SSkeletonCircle = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]);
const _sfc_main$9 = defineComponent({
  name: "SSkeletonText",
  components: {
    SSkeleton
  },
  props: {
    /**
     * SkeletonText 너비
     */
    width: {
      type: [String, Array, Object],
      default: void 0
    },
    /**
     * SkeletonText 높이
     */
    lineHeight: {
      type: [String, Array, Object],
      default: "text1"
    },
    /**
     * 로딩 완료 여부
     */
    isLoaded: {
      type: Boolean
    }
  },
  setup(props) {
    const isLineHeight = (value) => value in stds.glob.typography.lineHeight;
    const mapHeight = (lineHeight2) => isLineHeight(lineHeight2) ? `h-[${stds.glob.typography.lineHeight[lineHeight2]}]` : mapHeight(stds.sem.typography[lineHeight2].lineHeight);
    return {
      skeletonTextClasses: computed(() => [
        ...mapResponsiveClasses(props.lineHeight, mapHeight)
      ])
    };
  }
});
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SSkeleton = resolveComponent("SSkeleton");
  return openBlock(), createBlock(_component_SSkeleton, {
    class: normalizeClass(_ctx.skeletonTextClasses),
    width: _ctx.width,
    isLoaded: _ctx.isLoaded
  }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "width", "isLoaded"]);
}
const SSkeletonText = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9]]);
const [useProvideTabsContext, useTabsContext] = createInjectionState(
  (context) => context,
  { injectionKey: CONTEXT_KEYS.STabs }
);
const useTabsContextOrThrow = () => {
  const tabsContext = useTabsContext();
  if (!tabsContext) {
    throw new Error(
      "Please call `useTabsContext` on the parent <STabs /> component"
    );
  }
  return tabsContext;
};
const TABS_VARIANTS = {
  "line-flexible": "line-flexible",
  "line-fixed": "line-fixed",
  "box": "box"
};
const TABS_SIZES = {
  sm: "sm",
  lg: "lg"
};
const _sfc_main$8 = defineComponent({
  name: "STabs",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * 활성 Tab value, 탭의 상태를 제어할 때 사용, `v-model`로 사용 가능
     */
    modelValue: {
      type: String,
      default: void 0
    },
    /**
     * 최초 활성 Tab value, 탭의 상태를 제어할 필요가 없을 때 사용
     */
    defaultValue: {
      type: String,
      default: void 0
    },
    /**
     * Tabs 타입
     */
    variant: {
      type: String,
      default: TABS_VARIANTS["line-flexible"]
    },
    /**
     * Tabs 사이즈
     */
    size: {
      type: String,
      default: TABS_SIZES.sm
    }
  },
  setup(props, { emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const onChange = (value) => {
      modelValue.value = value;
    };
    const rootContext = reactive({
      values: [],
      modelValue,
      variant: props.variant,
      size: props.size,
      onChange
    });
    useProvideTabsContext(rootContext);
    return {
      rootContext
    };
  },
  methods: {
    onChange(value) {
      this.$emit("update:modelValue", value);
    }
  }
});
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const STabs = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8]]);
const _sfc_main$7 = defineComponent({
  name: "STabItem",
  props: {
    value: {
      type: String,
      required: true
    }
  },
  emits: ["click"],
  setup(props, { emit }) {
    const rootContext = useTabsContextOrThrow();
    rootContext.values.push(props.value);
    const onClick = (event) => {
      rootContext.onChange(props.value);
      emit("click", event);
    };
    const isSelected = computed(() => rootContext.modelValue === props.value);
    const isFirstItem = computed(() => {
      return rootContext.values.indexOf(props.value) === 0;
    });
    const isAfterSelected = computed(() => {
      const selectedIndex = rootContext.values.indexOf(rootContext.modelValue);
      const index = rootContext.values.indexOf(props.value);
      return index - selectedIndex === 1;
    });
    const listItemClasses = computed(() => {
      const { size: size2, variant } = rootContext;
      if (variant === "line-flexible") {
        return ["relative px-16"];
      }
      if (variant === "line-fixed") {
        return ["relative basis-full"];
      }
      if (variant === "box") {
        const deviderClasses = {
          sm: "before:stds-tab-divider-1 first:before:content-none",
          lg: "before:stds-tab-divider-2 first:before:content-none"
        };
        const hasDivider = !isFirstItem.value && !isSelected.value && !isAfterSelected.value;
        return [
          "relative ml-[0.1rem] basis-full first:ml-0",
          hasDivider && deviderClasses[size2],
          isSelected.value && "bg-surface-elevation-1"
        ].filter(isString);
      }
      return [];
    });
    const lineFlexibleButtonClasses = computed(() => {
      const { size: size2 } = rootContext;
      const defaultClasses = "relative flex h-full w-full items-center justify-center break-all py-11 text-xl leading-xl";
      const sizeClasses = {
        sm: "min-h-48",
        lg: "min-h-60"
      };
      const activeClasses = {
        activated: "font-medium text-on-surface-elevation-1 after:bg-on-surface-elevation-1 after:w-full after:h-2 after:absolute after:left-0 after:bottom-0",
        inactive: "text-on-surface-elevation-2"
      };
      return [
        defaultClasses,
        sizeClasses[size2],
        isSelected.value ? activeClasses.activated : activeClasses.inactive
      ];
    });
    const lineFixedButtonClasses = computed(() => {
      const { size: size2 } = rootContext;
      const defaultClasses = "flex h-full w-full items-center justify-center break-all py-8 px-20";
      const sizeClasses = {
        sm: "min-h-44 text-md leading-lg",
        lg: "min-h-48 text-xl leading-xl"
      };
      const activeClasses = {
        activated: "after:stds-tab-active-1 font-medium text-on-surface-elevation-1",
        inactive: "text-on-surface-elevation-2"
      };
      return [
        defaultClasses,
        sizeClasses[size2],
        isSelected.value ? activeClasses.activated : activeClasses.inactive
      ];
    });
    const boxButtonClasses = computed(() => {
      const { size: size2 } = rootContext;
      const defaultClasses = "flex h-full w-full items-center justify-center break-all py-10 px-20 font-medium";
      const sizeClasses = {
        sm: "min-h-44 text-md leading-lg",
        lg: "min-h-60 text-xl leading-xl"
      };
      const activeClasses = {
        activated: "bg-transparent after:stds-tab-active-2 text-on-surface-elevation-1",
        inactive: "bg-surface-elevation-3 text-on-surface-elevation-3"
      };
      return [
        defaultClasses,
        sizeClasses[size2],
        isSelected.value ? activeClasses.activated : activeClasses.inactive
      ];
    });
    const buttonClasses = computed(() => {
      const { variant } = rootContext;
      if (variant === "line-flexible") {
        return lineFlexibleButtonClasses.value;
      }
      if (variant === "line-fixed") {
        return lineFixedButtonClasses.value;
      }
      if (variant === "box") {
        return boxButtonClasses.value;
      }
      return [];
    });
    return {
      rootContext,
      onClick,
      isFirstItem,
      isAfterSelected,
      listItemClasses,
      lineFlexibleButtonClasses,
      lineFixedButtonClasses,
      boxButtonClasses,
      buttonClasses
    };
  }
});
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", {
    class: normalizeClass(_ctx.listItemClasses)
  }, [
    createElementVNode("button", {
      type: "button",
      class: normalizeClass(_ctx.buttonClasses),
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2);
}
const STabItem = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]);
const _sfc_main$6 = defineComponent({
  name: "STabList",
  setup() {
    const rootContext = useTabsContextOrThrow();
    const classesByVariant = {
      "line-flexible": "flex relative px-16 bg-surface-elevation-1 overflow-x-auto scrollbar-form-2 after:w-full after:h-[0.1rem] after:bg-inverse-elevation-2 after:absolute after:bottom-0 after:left-0",
      "line-fixed": "flex relative bg-surface-elevation-1 overflow-hidden after:bg-inverse-elevation-2  after:absolute after:left-0 after:right-0 after:bottom-0 after:w-full after:h-[0.1rem]",
      "box": "flex bg-surface-elevation-3"
    };
    return {
      rootContext,
      classesByVariant
    };
  }
});
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", {
    class: normalizeClass(_ctx.classesByVariant[_ctx.rootContext.variant])
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
const STabList = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
const _sfc_main$5 = defineComponent({
  name: "STabPanel",
  props: {
    value: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const rootContext = useTabsContextOrThrow();
    const isSelected = computed(() => rootContext.modelValue === props.value);
    return {
      rootContext,
      isSelected
    };
  }
});
const _hoisted_1$3 = ["hidden"];
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    hidden: !_ctx.isSelected
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1$3);
}
const STabPanel = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
const _sfc_main$4 = defineComponent({
  name: "STabPanels",
  setup() {
    const rootContext = useTabsContextOrThrow();
    return {
      rootContext
    };
  }
});
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const STabPanels = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
const TEXTAREA_SIZES = {
  sm: "sm",
  lg: "lg"
};
const TEXTAREA_VARIANTS = {
  fill: "fill",
  outline: "outline"
};
const TEXTAREA_VALIDATION_STATES = {
  none: "none",
  error: "error",
  warning: "warning",
  success: "success",
  informational: "informational"
};
const _sfc_main$3 = defineComponent({
  name: "STextarea",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Textarea 값
     */
    modelValue: {
      type: String,
      default: void 0
    },
    /**
     * Textarea 초기값
     */
    defaultValue: {
      type: String,
      default: ""
    },
    /**
     * Textarea 타입
     */
    variant: {
      type: String,
      default: TEXTAREA_VARIANTS.outline,
      validator: (value) => objectKeys(TEXTAREA_VARIANTS).includes(value)
    },
    /**
     * Textarea 사이즈
     */
    size: {
      type: String,
      default: TEXTAREA_SIZES.sm,
      validator: (value) => objectKeys(TEXTAREA_SIZES).includes(value)
    },
    /**
     * 유효성 검사 상태
     */
    validationState: {
      type: String,
      default: "none",
      required: false,
      validator: (value) => objectKeys(TEXTAREA_VALIDATION_STATES).includes(value)
    },
    /**
     * Textarea 비활성 여부
     */
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["input", "change", "update:modelValue"],
  setup(props, { emit }) {
    const modelValue = useVModel(props, "modelValue", emit, {
      defaultValue: props.defaultValue,
      passive: props.modelValue === void 0
    });
    const onInput = (event) => {
      if (event.target instanceof HTMLTextAreaElement) {
        modelValue.value = event.target.value;
      }
      emit("input", event);
    };
    const onChange = (event) => {
      emit("change", event);
    };
    const outlineTextareaContainerClasses = computed(() => ({
      "border-border": true,
      "bg-neutral-variant-3": !props.isDisabled,
      "bg-disabled-variant-3": props.isDisabled
    }));
    const fillTextareaContainerClasses = computed(() => ({
      "border-transparent bg-neutral-variant-2": !props.isDisabled,
      "border-transparent bg-disabled-variant-3": props.isDisabled
    }));
    return {
      onInput,
      onChange,
      textareaContainerClasses: computed(() => ({
        "stds-textarea-container group": true,
        ...props.variant === TEXTAREA_VARIANTS.outline ? outlineTextareaContainerClasses.value : fillTextareaContainerClasses.value,
        "border": props.validationState === TEXTAREA_VALIDATION_STATES.none,
        "border-2": props.validationState !== TEXTAREA_VALIDATION_STATES.none,
        "focus-within:border-2 focus-within:border-gray400 focus-within:pr-[0.6rem] focus-within:pb-[1.0rem]": props.validationState === TEXTAREA_VALIDATION_STATES.none,
        "border-error focus-within:border-error": props.validationState === TEXTAREA_VALIDATION_STATES.error,
        "border-warning focus-within:border-warning": props.validationState === TEXTAREA_VALIDATION_STATES.warning,
        "border-success focus-within:border-success": props.validationState === TEXTAREA_VALIDATION_STATES.success,
        "border-information focus-within:border-information": props.validationState === TEXTAREA_VALIDATION_STATES.informational
      })),
      textareaClasses: computed(() => ({
        "stds-textarea scrollbar-form-1": true,
        "text-text3 leading-btn2": props.size === TEXTAREA_SIZES.sm,
        "text-text1 leading-btn1": props.size === TEXTAREA_SIZES.lg,
        "group-focus-within:-m-[0.1rem]": props.validationState === TEXTAREA_VALIDATION_STATES.none
      }))
    };
  },
  methods: {
    onInput_(event) {
      if (event.target instanceof HTMLTextAreaElement) {
        this.$emit("update:modelValue", event.target.value, event);
      }
      this.$emit("input", event);
    },
    onChange_(event) {
      this.$emit("change", event);
    }
  }
});
const _hoisted_1$2 = ["value", "disabled"];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.textareaContainerClasses)
  }, [
    createElementVNode("textarea", mergeProps({ class: _ctx.textareaClasses }, _ctx.$attrs, {
      value: _ctx.modelValue,
      disabled: _ctx.isDisabled,
      onInput: _cache[0] || (_cache[0] = (...args) => _ctx.onInput && _ctx.onInput(...args)),
      onChange: _cache[1] || (_cache[1] = (...args) => _ctx.onChange && _ctx.onChange(...args))
    }), null, 16, _hoisted_1$2)
  ], 2);
}
const STextarea = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
const TOAST_LOCATION = {
  center: "center",
  left: "left"
};
const MINIMUM_DURATION = 1e3;
const MAXIMUM_DURATION = 120 * 1e3;
const DEFAULT_DURATION = 5 * 1e3;
function mitt(n) {
  return { all: n = n || /* @__PURE__ */ new Map(), on: function(t, e) {
    var i = n.get(t);
    i ? i.push(e) : n.set(t, [e]);
  }, off: function(t, e) {
    var i = n.get(t);
    i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
  }, emit: function(t, e) {
    var i = n.get(t);
    i && i.slice().map(function(n2) {
      n2(e);
    }), (i = n.get("*")) && i.slice().map(function(n2) {
      n2(t, e);
    });
  } };
}
const bus = mitt();
const _sfc_main$2 = defineComponent({
  name: "SToastArea",
  props: {
    /**
     * toast 노출 위치
     */
    location: {
      type: String,
      default: TOAST_LOCATION.center,
      validator: (value) => objectKeys(TOAST_LOCATION).includes(value)
    }
  },
  setup(props) {
    const breakpoints2 = useBreakpoints(stds.glob.breakpoint);
    const isMobile = breakpoints2.smaller("sm");
    const toasts = ref([]);
    const removeToast = (id2) => {
      const index = toasts.value.findIndex((toastItem) => toastItem.id === id2);
      toasts.value.splice(index, 1);
    };
    const createToast = ({
      id: id2 = Date.now(),
      text,
      duration = DEFAULT_DURATION
    }) => {
      const toast = {
        id: id2,
        text,
        duration: duration > MAXIMUM_DURATION ? MAXIMUM_DURATION : duration < MINIMUM_DURATION ? MINIMUM_DURATION : duration
      };
      toasts.value.push(toast);
      setTimeout(
        (id22) => {
          removeToast(id22);
        },
        toast.duration,
        toast.id
      );
    };
    const locationClasses = {
      center: isMobile.value ? "left-1/2 -translate-x-1/2 w-[calc(100%-2.4rem)]" : "left-1/2 -translate-x-1/2 w-[32.8rem]",
      left: isMobile.value ? "w-[calc(100%-2.4rem)]" : "w-[32.8rem]"
    };
    onMounted(() => {
      bus.on("create-stoast", createToast);
    });
    return {
      isMobile,
      toasts,
      createToast,
      toastPlateClasses: computed(() => [
        "fixed bottom-0",
        locationClasses[props.location]
      ]),
      toastClasses: "stds-toast",
      textClasses: "font-normal text-xl leading-xl text-white text-center"
    };
  }
});
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.toastPlateClasses)
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.toasts, ({ id: id2, text }) => {
      return openBlock(), createElementBlock("div", {
        key: id2,
        class: normalizeClass(_ctx.toastClasses)
      }, [
        createElementVNode("p", {
          class: normalizeClass(_ctx.textClasses)
        }, toDisplayString(text), 3)
      ], 2);
    }), 128))
  ], 2);
}
const SToastArea = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const _sfc_main$1 = defineComponent({
  name: "STopButton",
  props: {
    /**
     * Scroll을 이동할 target 요소
     */
    target: {
      type: isClient ? [Window, Element] : Object,
      default: void 0
    },
    /**
     * TopButton을 표시하기 시작할 최소 높이
     */
    visibleHeight: {
      type: Number,
      default: 50
    },
    /**
     * `Element.scrollTo(options)`
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollTo
     */
    scrollToOptions: {
      type: Object,
      default: () => ({ top: 0, left: 0 })
    }
  },
  emits: ["click"],
  setup(props) {
    const { y } = useWindowScroll();
    return {
      isVisible: computed(() => y.value >= props.visibleHeight)
    };
  },
  methods: {
    onClick(event) {
      (this.target ?? globalThis).scrollTo(this.scrollToOptions);
      this.$emit("click", event);
    }
  }
});
const _hoisted_1$1 = /* @__PURE__ */ createElementVNode("span", { class: "sr-only" }, "Scroll to top", -1);
const _hoisted_2$1 = [
  _hoisted_1$1
];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("button", {
    class: "stds-top-button stove-ui-icon before:ic-v2-control-top-line",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, _hoisted_2$1, 512)), [
    [vShow, _ctx.isVisible]
  ]);
}
const STopButton = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
const _sfc_main = defineComponent({
  name: "STopNotice",
  setup() {
    return {
      useId
    };
  }
});
const _hoisted_1 = { class: "mx-auto flex w-full max-w-[130rem] flex-col justify-between md:flex-row" };
const _hoisted_2 = /* @__PURE__ */ createElementVNode("i", { class: "stove-ui-icon flex before:ic-v2-control-close-line" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SText = resolveComponent("SText");
  const _component_SCheckbox = resolveComponent("SCheckbox");
  const _component_SBox = resolveComponent("SBox");
  const _component_SDialogContent = resolveComponent("SDialogContent");
  return openBlock(), createBlock(_component_SDialogContent, { class: "w-full bg-orange50 py-16 px-20 sm:px-40" }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1, [
        createVNode(_component_SText, {
          class: "max-w-[130rem] gap-y-4 text-gray880",
          role: "text3",
          as: "p"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }),
        createVNode(_component_SBox, { class: "stds-top-notice-button-wrap" }, {
          default: withCtx(() => [
            createVNode(_component_SCheckbox, {
              id: `stds-top-notice-close-by-day-${_ctx.useId()}`,
              size: "sm",
              onChange: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close", true))
            }, {
              default: withCtx(() => [
                createTextVNode(" 1일 동안 보지않기 ")
              ]),
              _: 1
            }, 8, ["id"]),
            createElementVNode("button", {
              class: "flex-shrink-0 text-right text-xl leading-lg text-gray600",
              onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close", false))
            }, _hoisted_3)
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  });
}
const STopNotice = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
const components = {
  ...core,
  SBadge,
  SBox,
  SButton,
  SCheckbox,
  SCheckboxGroup,
  SChips,
  SCircularProgress,
  SContentsPopup,
  SContentsPopupContentBody,
  SContentsPopupHeader,
  SDatepicker,
  SDialog,
  SDialogContent,
  SDialogContentBody,
  SDialogFooter,
  SDialogHeader,
  SDialogOverlay,
  SDialogPanel,
  SDialogProvider,
  SDropdown,
  SDropdownButton,
  SDropdownItem,
  SEventDialog,
  SGradeBadge,
  SIcon,
  SIconButton,
  SIndicator,
  SInput,
  SLinearProgress,
  SMenuPopup,
  SMenuPopupItem,
  SNewBadge,
  SNumberBadge,
  SPagination,
  SProfile,
  SAvatar,
  SRadio,
  SRadioGroup,
  SSearchField,
  SAutocomplete,
  SRecentSearch,
  SSkeleton,
  SSkeletonCircle,
  SSkeletonText,
  SSwitch,
  STabs,
  STabItem,
  STabList,
  STabPanel,
  STabPanels,
  SText,
  STextarea,
  SToastArea,
  STooltip,
  STopButton,
  STopNotice
};
const StoveUI = {
  install(app) {
    if (isVue2) {
      app.prototype.$SToast = (toastOption) => {
        bus.emit("create-stoast", toastOption);
      };
    }
    if (isVue3) {
      app.config.globalProperties.$SToast = (toastOption) => {
        bus.emit("create-stoast", toastOption);
      };
    }
    app.use(PortalVue, {
      portalName: "SPortal",
      portalTargetName: "SPortalTarget"
    });
    Object.entries(components).forEach(([componentName, component]) => {
      app.component(componentName, component);
    });
  }
};
export {
  SIconButton as $,
  SDatepicker as A,
  BADGE_VARIANTS as B,
  CreateSComponent as C,
  DATEPICKER_LANGUAGES as D,
  DATEPICKER_VIEWS as E,
  DATEPICKER_VALIDATION_STATES as F,
  SDialog as G,
  SDialogContent as H,
  SDialogContentBody as I,
  SDialogFooter as J,
  SDialogHeader as K,
  SDialogOverlay as L,
  SDialogPanel as M,
  SDialogProvider as N,
  DIALOG_VARIANTS as O,
  DIALOG_SIZES as P,
  SDropdown as Q,
  RenderVNode as R,
  SlimComponent as S,
  SDropdownButton as T,
  SDropdownItem as U,
  SEventDialog as V,
  SGradeBadge as W,
  GRADE_BADGE_VARIANTS as X,
  SIcon as Y,
  ICON_SIZES as Z,
  _export_sfc as _,
  core as a,
  stds as a$,
  SIndicator as a0,
  INDICATOR_SIZES as a1,
  INDICATOR_VARIANTS as a2,
  SInput as a3,
  INPUT_SIZES as a4,
  INPUT_VARIANTS as a5,
  INPUT_VALIDATION_STATES as a6,
  SLinearProgress as a7,
  LINEAR_PROGRESS_VARIANTS as a8,
  LINEAR_PROGRESS_SIZES as a9,
  STabPanels as aA,
  TABS_VARIANTS as aB,
  TABS_SIZES as aC,
  useProvideTabsContext as aD,
  useTabsContextOrThrow as aE,
  SText as aF,
  STextarea as aG,
  TEXTAREA_SIZES as aH,
  TEXTAREA_VARIANTS as aI,
  TEXTAREA_VALIDATION_STATES as aJ,
  SToastArea as aK,
  TOAST_LOCATION as aL,
  MINIMUM_DURATION as aM,
  MAXIMUM_DURATION as aN,
  DEFAULT_DURATION as aO,
  STooltip as aP,
  TOOLTIP_PLACEMENTS as aQ,
  STopButton as aR,
  STopNotice as aS,
  useBackgroundImageStyle as aT,
  CONTEXT_KEYS as aU,
  getContextKey as aV,
  useContext as aW,
  useDefaultSlots as aX,
  useId as aY,
  tailwindClassByStyleProp as aZ,
  useStyle as a_,
  SMenuPopup as aa,
  SMenuPopupItem as ab,
  SNewBadge as ac,
  NEW_BADGE_VARIANTS as ad,
  SNumberBadge as ae,
  NUMBER_BADGE_VARIANTS as af,
  SPagination as ag,
  SAvatar as ah,
  SProfile as ai,
  AVATAR_SIZES as aj,
  SRadio as ak,
  SRadioGroup as al,
  RADIO_SIZES as am,
  RADIO_ALIGNS as an,
  SSearchField as ao,
  SAutocomplete as ap,
  SRecentSearch as aq,
  SSkeleton as ar,
  SSkeletonCircle as as,
  SSkeletonText as at,
  SSwitch as au,
  SWITCH_SIZES as av,
  STabs as aw,
  STabItem as ax,
  STabList as ay,
  STabPanel as az,
  createSComponent as b,
  stdsGlobalToken as b0,
  LINE_ICONS as b1,
  FILL_ICONS as b2,
  COLOR_ICONS as b3,
  ALL_ICONS as b4,
  SAMPLE_ICON_VARIANTS_BY_NAME as b5,
  SAMPLE_ICON_NAMES as b6,
  NAVIGATION_ICON_VARIANTS_BY_NAME as b7,
  NAVIGATION_ICON_NAMES as b8,
  CONTROL_ICON_VARIANTS_BY_NAME as b9,
  stdsSemanticToken as bA,
  lightThemeColorTokenByRole as bB,
  darkThemeColorTokenByRole as bC,
  getSemanticColorToken as bD,
  typographyRoleNameByRole as bE,
  semanticTypographyTokenByRole as bF,
  StoveUI as bG,
  CONTROL_ICON_NAMES as ba,
  COMMUNITY_ICON_VARIANTS_BY_NAME as bb,
  COMMUNITY_ICON_NAMES as bc,
  OBJECT_ICON_VARIANTS_BY_NAME as bd,
  OBJECT_ICON_NAMES as be,
  MEDIA_AV_ICON_VARIANTS_BY_NAME as bf,
  MEDIA_AV_ICON_NAMES as bg,
  MEDIA_IMAGE_ICON_VARIANTS_BY_NAME as bh,
  MEDIA_IMAGE_ICON_NAMES as bi,
  STATE_ICON_VARIANTS_BY_NAME as bj,
  STATE_ICON_NAMES as bk,
  HARDWARE_ICON_VARIANTS_BY_NAME as bl,
  HARDWARE_ICON_NAMES as bm,
  LOGO_ICON_VARIANTS_BY_NAME as bn,
  LOGO_ICON_NAMES as bo,
  BADGE_ICON_VARIANTS_BY_NAME as bp,
  BADGE_ICON_NAMES as bq,
  STOVE_ICON_VARIANTS_BY_NAME as br,
  STOVE_ICON_NAMES as bs,
  COMMUNICATION_ICON_VARIANTS_BY_NAME as bt,
  COMMUNICATION_ICON_NAMES as bu,
  CONTENT_ICON_VARIANTS_BY_NAME as bv,
  CONTENT_ICON_NAMES as bw,
  EDITOR_ICON_VARIANTS_BY_NAME as bx,
  EDITOR_ICON_NAMES as by,
  breakpoints as bz,
  components as c,
  RenderVNodes as d,
  SBadge as e,
  BADGE_SIZES as f,
  BADGE_COLORS as g,
  h,
  SBox as i,
  SButton as j,
  BUTTON_VARIANTS as k,
  BUTTON_SIZES as l,
  SCheckbox as m,
  SCheckboxGroup as n,
  CHECKBOX_SIZES as o,
  CHECKBOX_ALIGNS as p,
  SChips as q,
  render as r,
  slot as s,
  CHIPS_VARIANTS as t,
  CHIPS_SIZES as u,
  SCircularProgress as v,
  CIRCULAR_PROGRESS_SIZES as w,
  SContentsPopup as x,
  SContentsPopupContentBody as y,
  SContentsPopupHeader as z
};
